import { MediumIcon } from "../IconSizes";

export const stenaAccount: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L15 24C14.45 24 14 23.55 14 23 14 22.45 14.45 22 15 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM1 14C1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L9 22C9.55 22 10 22.45 10 23 10 23.55 9.55 24 9 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14ZM15 14C16.66 14 18 15.34 18 17L18 19C18 19.55 17.55 20 17 20 16.45 20 16 19.55 16 19L16 17C16 16.45 15.55 16 15 16L9 16C8.45 16 8 16.45 8 17L8 19C8 19.55 7.55 20 7 20 6.45 20 6 19.55 6 19L6 17C6 15.34 7.34 14 9 14L15 14ZM12 4C14.21 4 16 5.79 16 8 16 10.21 14.21 12 12 12 9.79 12 8 10.21 8 8 8 5.79 9.79 4 12 4ZM9 0C9.55 0 10 0.45 10 1 10 1.55 9.55 2 9 2L3 2C2.45 2 2 2.45 2 3L2 9C2 9.55 1.55 10 1 10 0.45 10 0 9.55 0 9L0 3C0 1.34 1.34 0 3 0L9 0ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6ZM21 0C22.66 0 24 1.34 24 3L24 9C24 9.55 23.55 10 23 10 22.45 10 22 9.55 22 9L22 3C22 2.45 21.55 2 21 2L15 2C14.45 2 14 1.55 14 1 14 0.45 14.45 0 15 0L21 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAnimals: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.89 1.94L21.97 3.68C22.55 4.61 22.27 5.85 21.33 6.43L21.03 6.62 21.1 6.82C22.82 11.96 22.33 16.34 19.87 19.38L19.68 19.6C17.79 21.8 14.99 23 12.04 23 9.1 23 6.29 21.8 4.4 19.6 1.78 16.55 1.23 12.07 2.99 6.8L3.06 6.62 2.75 6.43C1.86 5.87 1.56 4.73 2.03 3.82L2.12 3.68 3.2 1.94C3.78 1.01 5.01 0.72 5.95 1.3L9.23 3.33C10.11 3.88 10.43 5 9.97 5.93 8.03 9.81 7.91 12.74 9.04 14.51 9.7 15.56 10.82 16.14 12.04 16.14 13.26 16.14 14.38 15.56 15.05 14.51 16.18 12.74 16.05 9.81 14.12 5.93 13.66 5 13.98 3.88 14.86 3.33L18.14 1.3C19.08 0.72 20.31 1.01 20.89 1.94ZM19.19 3L15.91 5.03C18.33 9.9 18.11 13.42 16.74 15.58 15.65 17.29 13.85 18.14 12.04 18.14 10.24 18.14 8.44 17.29 7.35 15.58 5.97 13.42 5.75 9.9 8.18 5.03L4.89 3 3.81 4.73 5.29 5.66C5.42 5.73 5.47 5.89 5.41 6.03 3.07 11.78 3.83 15.86 5.92 18.3 7.47 20.1 9.75 21 12.04 21 14.33 21 16.62 20.1 18.17 18.3 20.26 15.86 21.02 11.79 18.68 6.05 18.61 5.91 18.66 5.74 18.79 5.66L20.27 4.73 19.19 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAtm: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 1C22.66 1 24 2.34 24 4L24 9C24 10.66 22.66 12 21 12L19.23 12 19.98 20.72C20.08 21.88 19.23 22.89 18.07 22.99L17.89 23 6.11 23C4.95 23 4.01 22.06 4.01 20.9L4.02 20.72 4.76 12 3 12C1.34 12 0 10.66 0 9L0 4C0 2.34 1.34 1 3 1L21 1ZM7.29 7C7.24 7 7.2 7.04 7.19 7.09L6.01 20.89C6.01 20.94 6.03 20.97 6.06 20.99 6.08 21 6.09 21 6.11 21L14 21 13 7 7.29 7ZM21 3L3 3C2.45 3 2 3.45 2 4L2 9C2 9.55 2.45 10 3 10L4.93 10 5.2 6.92C5.29 5.83 6.2 5 7.29 5L16.71 5C17.8 5 18.71 5.83 18.8 6.92L19.06 10 21 10C21.55 10 22 9.55 22 9L22 4C22 3.45 21.55 3 21 3ZM16 21L17.89 21C17.95 20.99 18 20.95 17.99 20.89L16.81 7.09C16.8 7.05 16.78 7.02 16.75 7.01L16.71 7 15 7 16 21Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBackspace: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 5C21.66 5 23 6.34 23 8L23 17C23 18.66 21.66 20 20 20L9.23 20C8.59 20 7.97 19.8 7.46 19.42L1.84 15.29C1.65 15.16 1.48 15 1.33 14.82 0.25 13.56 0.41 11.66 1.67 10.59L7.4 5.71C7.94 5.25 8.63 5 9.35 5L20 5ZM20 7L9.35 7C9.11 7 8.88 7.08 8.7 7.24L2.96 12.11C2.54 12.47 2.49 13.1 2.85 13.52 2.9 13.58 2.96 13.64 3.02 13.68L8.64 17.81C8.81 17.93 9.02 18 9.23 18L20 18C20.55 18 21 17.55 21 17L21 8C21 7.45 20.55 7 20 7ZM13.71 9.29L15.66 11.24 17.61 9.29C18 8.9 18.63 8.9 19.02 9.29 19.41 9.68 19.41 10.32 19.02 10.71L17.07 12.66 19.02 14.61C19.41 15 19.41 15.63 19.02 16.02 18.63 16.41 18 16.41 17.61 16.02L15.66 14.07 13.71 16.02C13.32 16.41 12.68 16.41 12.29 16.02 11.9 15.63 11.9 15 12.29 14.61L14.24 12.66 12.29 10.71C11.9 10.32 11.9 9.68 12.29 9.29 12.68 8.9 13.32 8.9 13.71 9.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBan: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM2 12C2 17.52 6.48 22 12 22 14.4 22 16.6 21.15 18.33 19.74L4.26 5.67C2.85 7.39 2 9.6 2 12ZM12 2C9.6 2 7.39 2.85 5.67 4.26L19.74 18.33C21.15 16.6 22 14.4 22 12 22 6.48 17.52 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBar: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 12.93C7.61 12.44 5 9.53 5 6L5 1 19 1 19 6C19 9.53 16.39 12.44 13 12.93L13 21 16 21C16.55 21 17 21.45 17 22 17 22.55 16.55 23 16 23L8 23C7.45 23 7 22.55 7 22 7 21.45 7.45 21 8 21L11 21 11 12.93ZM17 3L7 3 7 6C7 8.69 9.12 10.88 11.78 11L12 11C14.76 11 17 8.76 17 6L17 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBasket: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.5 3.4C15.98 3.13 16.59 3.29 16.87 3.77L19.31 8 22 8C22.55 8 23 8.45 23 9 23 9.55 22.55 10 22 10L21.05 10 19.26 17.68C18.94 19.04 17.73 20 16.34 20L7.66 20C6.27 20 5.06 19.04 4.74 17.68L2.95 10 2 10C1.45 10 1 9.55 1 9 1 8.45 1.45 8 2 8L4.69 8 7.13 3.77C7.41 3.29 8.02 3.13 8.5 3.4 8.98 3.68 9.14 4.29 8.87 4.77L7 8 17 8 15.13 4.77C14.88 4.32 15 3.76 15.4 3.47L15.5 3.4ZM19 10L5 10 6.69 17.23C6.79 17.68 7.2 18 7.66 18L16.34 18C16.8 18 17.21 17.68 17.31 17.23L19 10ZM10 12C10.55 12 11 12.45 11 13L11 15C11 15.55 10.55 16 10 16 9.45 16 9 15.55 9 15L9 13C9 12.45 9.45 12 10 12ZM14 12C14.55 12 15 12.45 15 13L15 15C15 15.55 14.55 16 14 16 13.45 16 13 15.55 13 15L13 13C13 12.45 13.45 12 14 12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBell: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.83 0 20 3.84 20 9 20 10.99 20.37 12.74 21.03 14.49 21.1 14.68 21.21 14.95 21.33 15.24L21.45 15.53C21.7 16.11 21.95 16.67 21.93 16.62 22.36 17.69 21.7 18.11 20.61 18.39 20.09 18.53 19.36 18.64 18.43 18.73 16.74 18.89 14.42 18.97 12 18.97 9.58 18.97 7.26 18.89 5.57 18.73 4.64 18.64 3.91 18.53 3.39 18.39 2.3 18.11 1.64 17.69 2.07 16.62 2.06 16.67 2.26 16.2 2.49 15.67L2.61 15.38C2.75 15.04 2.89 14.71 2.97 14.49 3.63 12.74 4 10.99 4 9 4 3.84 7.17 0 12 0ZM12 2C8.37 2 6 4.87 6 9 6 11.25 5.58 13.24 4.84 15.2 4.73 15.5 4.52 16 4.33 16.45L4.29 16.54 4.37 16.56C4.67 16.61 5.05 16.66 5.49 16.71L5.76 16.73C7.38 16.89 9.64 16.97 12 16.97 14.36 16.97 16.62 16.89 18.24 16.73 18.8 16.68 19.26 16.62 19.63 16.56L19.71 16.54 19.67 16.45C19.65 16.41 19.63 16.36 19.61 16.32L19.5 16.04C19.36 15.72 19.24 15.41 19.16 15.2 18.42 13.24 18 11.25 18 9 18 4.87 15.63 2 12 2ZM14.11 20.55C14.35 20.06 14.95 19.86 15.45 20.11 15.94 20.35 16.14 20.95 15.89 21.45 15.06 23.11 13.73 24 12 24 10.27 24 8.94 23.11 8.11 21.45 7.86 20.95 8.06 20.35 8.55 20.11 9.05 19.86 9.65 20.06 9.89 20.55 10.4 21.56 11.06 22 12 22 12.94 22 13.6 21.56 14.11 20.55Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBellFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.74 0 19.88 3.7 20 8.72L20 9C20 10.99 20.37 12.74 21.03 14.49L21.13 14.75 21.79 16.31C21.88 16.52 21.94 16.65 21.93 16.62 22.36 17.69 21.7 18.11 20.61 18.39 20.09 18.53 19.36 18.64 18.43 18.73 16.74 18.89 14.42 18.97 12 18.97L10.97 18.97C8.93 18.95 7.02 18.86 5.57 18.73 4.64 18.64 3.91 18.53 3.39 18.39 2.35 18.12 1.7 17.72 2.02 16.76L2.09 16.58C2.15 16.45 2.31 16.08 2.49 15.67L2.87 14.74C2.91 14.65 2.94 14.56 2.97 14.49 3.58 12.88 3.94 11.26 3.99 9.45L4 9C4 3.84 7.17 0 12 0ZM14.11 20.55C14.35 20.06 14.95 19.86 15.45 20.11 15.94 20.35 16.14 20.95 15.89 21.45 15.06 23.11 13.73 24 12 24 10.27 24 8.94 23.11 8.11 21.45 7.86 20.95 8.06 20.35 8.55 20.11 9.05 19.86 9.65 20.06 9.89 20.55 10.4 21.56 11.06 22 12 22 12.94 22 13.6 21.56 14.11 20.55Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBilling: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12.65 4.81C13.51 4.9 14.28 5.15 14.95 5.55 15.62 5.96 16.14 6.49 16.51 7.13L14.61 8.25C14.15 7.51 13.5 7.06 12.65 6.9V10.5C13.9 10.77 14.89 11.19 15.61 11.73 16.34 12.28 16.7 13.12 16.7 14.26 16.7 14.93 16.53 15.55 16.18 16.12 15.84 16.69 15.37 17.16 14.76 17.54 14.15 17.91 13.45 18.15 12.65 18.25V19.84H11.3V18.29C10.29 18.21 9.38 17.95 8.58 17.51 7.79 17.06 7.17 16.49 6.74 15.8L8.7 14.5C8.98 14.96 9.34 15.33 9.78 15.63 10.22 15.92 10.73 16.1 11.3 16.18V12.36C10.03 12.09 9.05 11.69 8.36 11.16 7.66 10.63 7.31 9.82 7.31 8.75 7.31 8.1 7.47 7.49 7.79 6.92 8.12 6.35 8.58 5.88 9.17 5.52 9.78 5.14 10.49 4.9 11.3 4.81V3.12H12.65V4.81ZM12.65 16.14C13.16 16.02 13.55 15.81 13.83 15.51 14.12 15.19 14.26 14.81 14.26 14.37 14.26 13.57 13.73 13.01 12.65 12.68V16.14ZM11.3 6.92C10.82 7.02 10.43 7.23 10.14 7.53 9.86 7.84 9.72 8.18 9.72 8.58 9.72 8.96 9.86 9.27 10.12 9.53 10.39 9.78 10.78 9.99 11.3 10.15V6.92Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBookmark: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 20.91C21 22.29 19.88 23.41 18.5 23.41 17.9 23.41 17.33 23.2 16.87 22.81L12 18.63 7.13 22.81C6.12 23.67 4.64 23.6 3.72 22.67L3.6 22.54C3.21 22.09 3 21.51 3 20.91L3 4C3 2.34 4.34 1 6 1L18 1ZM18 3L6 3C5.45 3 5 3.45 5 4L5 20.91C5 21.03 5.04 21.15 5.12 21.24 5.3 21.45 5.62 21.47 5.83 21.29L11.35 16.56C11.72 16.24 12.28 16.24 12.65 16.56L18.17 21.29C18.27 21.37 18.38 21.41 18.5 21.41 18.78 21.41 19 21.19 19 20.91L19 4C19 3.45 18.55 3 18 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBookmarkFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1a3 3 0 0 1 3 3v16.91a2.5 2.5 0 0 1-4.13 1.9L12 18.63l-4.87 4.18a2.5 2.5 0 0 1-3.41-0.14l-0.12-0.13A2.5 2.5 0 0 1 3 20.91V4a3 3 0 0 1 3-3h12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBriefcase: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 1C16.1 1 17 1.9 17 3V5H21C22.66 5 24 6.34 24 8V8.89C24 10.86 23.28 12.76 22 14.24V21C22 22.66 20.66 24 19 24H5C3.39 24 2.08 22.74 2 21.15L2 21V14.51C1.99 14.5 1.97 14.48 1.96 14.47 0.7 13.02 0 11.17 0 9.25V8C0 6.34 1.34 5 3 5H7V3C7 1.9 7.9 1 9 1H15ZM20 15.7C19.48 15.89 18.93 16 18.37 16H16V16.5C16 17.6 15.1 18.5 14 18.5H9.5C8.4 18.5 7.5 17.6 7.5 16.5V16H5.33C4.87 16 4.43 15.93 4 15.8V21L4 21.1C4.06 21.61 4.48 22 5 22H19C19.55 22 20 21.55 20 21V15.7ZM9.5 16.5H14V13.5H9.5V16.5ZM3 7C2.45 7 2 7.45 2 8V9.25C2 10.68 2.52 12.07 3.47 13.15 3.94 13.69 4.61 14 5.33 14H7.5V13.5C7.5 12.4 8.4 11.5 9.5 11.5H14C15.1 11.5 16 12.4 16 13.5V14H18.37C19.06 14 19.71 13.73 20.2 13.24 21.35 12.09 22 10.52 22 8.89V8C22 7.45 21.55 7 21 7H3ZM9 5H15V3H9V5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBunkBed: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 22C23 22.55 22.55 23 22 23 21.45 23 21 22.55 21 22L21 20 3 20 3 22C3 22.55 2.55 23 2 23 1.45 23 1 22.55 1 22L1 2C1 1.45 1.45 1 2 1 2.55 1 3 1.45 3 2L3 6 5 6C7.21 6 9 7.79 9 10L21 10 21 9C21 8.45 21.45 8 22 8 22.55 8 23 8.45 23 9L23 22ZM5 16L3 16 3 18 7 18C7 16.9 6.1 16 5 16ZM21 12L3 12 3 14 5 14C7.21 14 9 15.79 9 18L21 18 21 12ZM5 8L3 8 3 10 7 10C7 8.9 6.1 8 5 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBuy: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 19L6 19C4.8 19 4.03 18.25 4 17.06 3.33 11.04 3 5.38 3 4 3 3.22 2.78 3 2 3 1.45 3 1 2.55 1 2 1 1.45 1.45 1 2 1 3.89 1 5 2.11 5 4L22 4C22.29 4 22.57 4.13 22.76 4.35 22.95 4.58 23.03 4.87 22.98 5.16 21.86 10.93 20.86 13.88 20 14L5.88 15.88 5.99 16.89 6 17 19 17C19.55 17 20 17.45 20 18 20 18.55 19.55 19 19 19ZM5.67 13.89L19 12C19.29 11.96 19.89 9.96 20.82 6L5.11 6C5.21 7.39 5.4 11.36 5.67 13.89ZM7.25 22.8C6.79 23.07 6.21 23.07 5.75 22.8 5.29 22.53 5 22.04 5 21.5 5 20.67 5.67 20 6.5 20 7.33 20 8 20.67 8 21.5 8 22.04 7.71 22.53 7.25 22.8ZM20 21.5C20 20.67 19.33 20 18.5 20 17.67 20 17 20.67 17 21.5 17 22.33 17.67 23 18.5 23 19.33 23 20 22.33 20 21.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCafe: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.5 7C22.43 7 24 8.57 24 10.5 24 12.43 22.43 14 20.5 14L20 14C20 16.39 18.95 18.54 17.29 20L21 20C21.55 20 22 20.45 22 21 22 21.51 21.61 21.94 21.12 21.99L21 22 3 22C2.45 22 2 21.55 2 21 2 20.45 2.45 20 3 20L6.71 20C5.05 18.54 4 16.39 4 14L4 8C4 7.45 4.45 7 5 7L20.5 7ZM18 9L6 9 6 14C6 17.31 8.69 20 12 20 15.31 20 18 17.31 18 14L18 9ZM20.5 9L20 9 20 12 20.5 12C21.33 12 22 11.33 22 10.5 22 9.67 21.33 9 20.5 9ZM8 2C8.55 2 9 2.45 9 3L9 5C9 5.55 8.55 6 8 6 7.45 6 7 5.55 7 5L7 3C7 2.45 7.45 2 8 2ZM12 2C12.55 2 13 2.45 13 3L13 5C13 5.55 12.55 6 12 6 11.45 6 11 5.55 11 5L11 3C11 2.45 11.45 2 12 2ZM16 2C16.55 2 17 2.45 17 3L17 5C17 5.55 16.55 6 16 6 15.45 6 15 5.55 15 5L15 3C15 2.45 15.45 2 16 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalculate: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C21.66 1 23 2.34 23 4L23 20C23 21.66 21.66 23 20 23L4 23C2.34 23 1 21.66 1 20L1 4C1 2.34 2.34 1 4 1L20 1ZM20 3L4 3C3.45 3 3 3.45 3 4L3 20C3 20.55 3.45 21 4 21L20 21C20.55 21 21 20.55 21 20L21 4C21 3.45 20.55 3 20 3ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11ZM12 7C12.55 7 13 7.45 13 8 13 8.55 12.55 9 12 9 11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalendar: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalendarFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalendarManage: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM18.54 14.23C18.93 14.62 18.93 15.26 18.54 15.65L14.42 19.77C14.21 19.98 13.92 20.08 13.64 20.06 13.36 20.08 13.07 19.98 12.85 19.77L10.73 17.65C10.34 17.26 10.34 16.62 10.73 16.23 11.12 15.84 11.76 15.84 12.15 16.23L13.64 17.72 17.13 14.23C17.52 13.84 18.15 13.84 18.54 14.23ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalendarSortDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM12 12C12.55 12 13 12.45 13 13L13 16.41 14.12 15.29C14.48 14.93 15.05 14.9 15.44 15.21L15.54 15.29C15.93 15.68 15.93 16.32 15.54 16.71L12.71 19.54C12.32 19.93 11.68 19.93 11.29 19.54L8.46 16.71C8.07 16.32 8.07 15.68 8.46 15.29 8.85 14.9 9.49 14.9 9.88 15.29L11 16.41 11 13C11 12.45 11.45 12 12 12ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCalendarSortUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM12.71 12.46L15.54 15.29C15.93 15.68 15.93 16.32 15.54 16.71 15.15 17.1 14.51 17.1 14.12 16.71L13 15.59 13 19C13 19.55 12.55 20 12 20 11.45 20 11 19.55 11 19L11 15.59 9.88 16.71C9.49 17.1 8.85 17.1 8.46 16.71 8.07 16.32 8.07 15.68 8.46 15.29L11.29 12.46C11.68 12.07 12.32 12.07 12.71 12.46ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCameraError: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.59 16.17L20 18.59 22.41 16.17C22.8 15.78 23.44 15.78 23.83 16.17 24.22 16.56 24.22 17.2 23.83 17.59L21.41 20 23.83 22.41C24.22 22.8 24.22 23.44 23.83 23.83 23.44 24.22 22.8 24.22 22.41 23.83L20 21.41 17.59 23.83C17.2 24.22 16.56 24.22 16.17 23.83 15.78 23.44 15.78 22.8 16.17 22.41L18.59 20 16.17 17.59C15.78 17.2 15.78 16.56 16.17 16.17 16.56 15.78 17.2 15.78 17.59 16.17ZM15 1C15.33 1 15.65 1.17 15.83 1.45L17.54 4 20 4C21.6 4 22.9 5.25 22.99 6.82L23 7 23 13 21 13 21 7C21 6.45 20.55 6 20 6L17 6C16.67 6 16.35 5.83 16.17 5.55L14.46 3 9.54 3 7.83 5.55C7.67 5.8 7.41 5.96 7.12 5.99L7 6 4 6C3.45 6 3 6.45 3 7L3 18C3 18.55 3.45 19 4 19L14 19 14 21 4 21C2.34 21 1 19.66 1 18L1 7C1 5.34 2.34 4 4 4L6.46 4 8.17 1.45C8.33 1.2 8.59 1.04 8.88 1.01L9 1 15 1ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCameraOk: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23.68 16.32C24.11 16.76 24.11 17.46 23.68 17.89L18.01 23.68C17.78 23.91 17.47 24.02 17.16 24 16.86 24.02 16.54 23.91 16.31 23.68L12.82 20.11C12.39 19.68 12.39 18.97 12.82 18.54 13.24 18.11 13.93 18.11 14.36 18.54L17.16 21.41 22.14 16.32C22.57 15.89 23.26 15.89 23.68 16.32ZM15 1C15.33 1 15.65 1.17 15.83 1.45L17.54 4 20 4C21.6 4 22.9 5.25 22.99 6.82L23 7 23 14 21 14 21 7C21 6.45 20.55 6 20 6L17 6C16.67 6 16.35 5.83 16.17 5.55L14.46 3 9.54 3 7.83 5.55C7.67 5.8 7.41 5.96 7.12 5.99L7 6 4 6C3.45 6 3 6.45 3 7L3 18C3 18.55 3.45 19 4 19L10 19 10 21 4 21C2.34 21 1 19.66 1 18L1 7C1 5.34 2.34 4 4 4L6.46 4 8.17 1.45C8.33 1.2 8.59 1.04 8.88 1.01L9 1 15 1ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCarRentalDesk: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 1C15.76 1 18 3.24 18 6L18 8C18 9.6 16.75 10.9 15.18 10.99L15 11 15 12.28 14.56 13.79 15.06 16.05 14.57 17.82 15.25 20.29 11.5 23.7 8 20.52 8 11 7.82 10.99C6.25 10.9 5 9.6 5 8L5 6C5 3.24 7.24 1 10 1L13 1ZM13 11L10 11 10 19.64 11.5 21 13 19.64 12.5 17.82 13 16 12.5 13.73 13 12 13 11ZM13 3L10 3C8.34 3 7 4.34 7 6L7 8C7 8.55 7.45 9 8 9L15 9C15.55 9 16 8.55 16 8L16 6C16 4.34 14.66 3 13 3ZM13 5C13.55 5 14 5.45 14 6 14 6.55 13.55 7 13 7L10 7C9.45 7 9 6.55 9 6 9 5.45 9.45 5 10 5L13 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCargoConstruction: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.5 0.68L11.3 4.47C12.1 5.28 12.1 6.38 11.6 7.28L11.6 10.57 13.9 8.28C14.3 7.88 15 7.97 15.2 8.38L15.3 8.47 17.3 12.68 18 14.47 21.8 22.68C22.1 23.38 21.4 24.07 20.7 23.88L20.6 23.88 6.5 17.27C6 16.98 5.8 16.27 6.3 15.88L7.44 14.56 9.6 12.57 9.6 8.57C9.1 8.57 8.5 8.38 8.1 8.07L5 5C3.8 3.83 3 2 4 1L4.4 0.68C5 0 6.7-0.23 7.5 0.68ZM14.1 10.28L11.8 12.57 14 14.78C14.3 15.07 14.3 15.57 14.1 15.88L14 15.97C13.7 16.27 13.2 16.27 12.9 16.07L10.6 13.78 8.3 16.07 19.2 21.18 14.1 10.28ZM5.5 1.88C5.3 2.08 5.3 2.38 5.5 2.58L9.3 6.38C9.5 6.58 9.8 6.58 10 6.38 10.2 6.17 10.2 5.88 10 5.67L6.2 1.88C6 1.68 5.7 1.68 5.5 1.88Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCargoMetal: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.11 0C20.87 0 21.27 0.92 20.79 1.44L16.45 5.58 16.45 7.45 20.11 7.45C20.78 7.45 21.16 8.16 20.91 8.68L20.86 8.77 20.81 8.86 20.71 9 10.54 18.76C10.4 18.91 10.19 19 9.97 19L0.85 19C0.14 19-0.27 18.13 0.2 17.55L0.25 17.49 4.51 13.39 4.51 11.51 0.85 11.51C0.18 11.51-0.23 10.73 0.14 10.14L0.2 10.05 0.25 10 10.42 0.24C10.57 0.09 10.73 0.02 10.92 0L10.97 0 20.11 0ZM4.51 15.8L3.03 17.22 4.51 17.22 4.51 15.8ZM17.93 9.22L15.94 9.22 7.57 17.22 9.56 17.22 17.93 9.22ZM14.7 7.49L14.7 7.27 10.54 11.27C10.44 11.38 10.32 11.45 10.18 11.48 10.09 11.5 10.03 11.51 9.93 11.51L6.27 11.51 6.27 16.08 14.71 8.01 14.7 7.49ZM17.93 1.78L11.4 1.78 3.03 9.78 9.56 9.78 17.93 1.78Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaChangingTable: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C22.21 1 24 2.79 24 5L24 15C24 19.42 20.42 23 16 23L8 23C3.67 23 0.14 19.55 0 15.25L0 14.8 0 5C0 2.79 1.79 1 4 1L20 1ZM3 14C2.66 14 2.32 14.03 2 14.08L2 15C2 18.31 4.69 21 8 21L8.92 21C8.97 20.68 9 20.34 9 20 9 16.69 6.31 14 3 14ZM21 14C17.68 14 15 16.69 15 20 15 20.34 15.03 20.68 15.08 21L16 21C19.31 21 22 18.31 22 15L22 14.08C21.67 14.03 21.34 14 21 14ZM20 3L4 3C2.9 3 2 3.9 2 5L2 7 6 7C6.55 7 7 7.45 7 8 7 8.55 6.55 9 6 9L2 9 2 12.06C2.33 12.02 2.66 12 3 12 7.42 12 11 15.58 11 20 11 20.34 10.98 20.67 10.94 21L13.06 21C13.02 20.67 13 20.34 13 20 13 15.58 16.58 12 21 12 21.34 12 21.67 12.02 22 12.06L22 9 18 9C17.45 9 17 8.55 17 8 17 7.45 17.45 7 18 7L22 7 22 5C22 3.9 21.1 3 20 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCheck: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.54 17.61L4.29 13.36C3.9 12.97 3.9 12.34 4.29 11.95 4.68 11.56 5.32 11.56 5.71 11.95L9.29 15.54 18.54 6.29C18.93 5.9 19.56 5.9 19.95 6.29 20.34 6.68 20.34 7.32 19.95 7.71L10.05 17.61C9.87 17.79 9.64 17.88 9.4 17.9L9.18 17.9C8.95 17.88 8.72 17.79 8.54 17.61Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCheckCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCheckCircleFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM17.54 9.23C17.15 8.84 16.52 8.84 16.13 9.23L11.64 13.72 9.15 11.23C8.76 10.84 8.12 10.84 7.73 11.23 7.34 11.62 7.34 12.26 7.73 12.65L10.85 15.77C11.07 15.98 11.36 16.08 11.64 16.06 11.92 16.08 12.21 15.98 12.42 15.77L17.54 10.65C17.93 10.26 17.93 9.62 17.54 9.23Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCheckDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.95 5.29C22.34 5.68 22.34 6.32 21.95 6.71L10.05 18.61C9.87 18.79 9.64 18.88 9.4 18.9L9.18 18.9C8.95 18.88 8.72 18.79 8.54 18.61L2.29 12.36C1.9 11.97 1.9 11.34 2.29 10.95 2.68 10.56 3.32 10.56 3.71 10.95L9.29 16.54 20.54 5.29C20.93 4.9 21.56 4.9 21.95 5.29ZM14.95 5.29C15.34 5.68 15.34 6.32 14.95 6.71L10.05 11.61C9.87 11.79 9.64 11.88 9.4 11.9L9.18 11.9C8.95 11.88 8.72 11.79 8.54 11.61L5.29 8.36C4.9 7.97 4.9 7.34 5.29 6.95 5.68 6.56 6.32 6.56 6.71 6.95L9.29 9.54 13.54 5.29C13.93 4.9 14.56 4.9 14.95 5.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCheckThick: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.5 13L9.15 18.65C9.34 18.84 9.66 18.84 9.85 18.65L21 7.5C21.55 6.95 21.55 6.05 21 5.5 20.45 4.95 19.55 4.95 19 5.5L9.5 15 5.5 11C4.95 10.45 4.05 10.45 3.5 11 2.95 11.55 2.95 12.45 3.5 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaClean: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16.27 2.98L22.03 8.74C23.2 9.91 23.2 11.81 22.03 12.98L13.3 21.71C13.12 21.89 12.86 22 12.6 22L7.1 22C6.84 22 6.58 21.89 6.39 21.71L1.97 17.28C0.8 16.11 0.8 14.21 1.97 13.04L12.03 2.98C13.2 1.81 15.1 1.81 16.27 2.98ZM9.71 8.13L3.39 14.46C2.99 14.85 2.99 15.48 3.39 15.87L7.22 19.71C7.41 19.89 7.66 20 7.93 20L11.77 20C12.03 20 12.29 19.89 12.48 19.71L16.88 15.3 9.71 8.13ZM13.44 4.4L11.13 6.71 18.3 13.88 20.61 11.57C21.01 11.18 21.01 10.54 20.61 10.15L14.86 4.4C14.47 4.01 13.83 4.01 13.44 4.4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaClear: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 1C21.66 1 23 2.34 23 4L23 20C23 21.66 21.66 23 20 23L4 23C2.34 23 1 21.66 1 20L1 4C1 2.34 2.34 1 4 1L20 1ZM20 3L4 3C3.45 3 3 3.45 3 4L3 20C3 20.55 3.45 21 4 21L20 21C20.55 21 21 20.55 21 20L21 4C21 3.45 20.55 3 20 3ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaClearRow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 3C19.66 3 21 4.34 21 6L21 18C21 19.66 19.66 21 18 21L6 21C4.34 21 3 19.66 3 18L3 6C3 4.34 4.34 3 6 3L18 3ZM18 5L6 5C5.45 5 5 5.45 5 6L5 18C5 18.55 5.45 19 6 19L18 19C18.55 19 19 18.55 19 18L19 6C19 5.45 18.55 5 18 5ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L8 13C7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11L16 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaClock: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 5C12.55 5 13 5.45 13 6L13 12.59 15.71 15.29C16.07 15.65 16.1 16.22 15.79 16.61L15.71 16.71C15.32 17.1 14.68 17.1 14.29 16.71L11.29 13.71C11.11 13.52 11 13.27 11 13L11 6C11 5.45 11.45 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaClockFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 5C11.45 5 11 5.45 11 6L11 13C11 13.27 11.11 13.52 11.29 13.71L14.29 16.71C14.68 17.1 15.32 17.1 15.71 16.71L15.79 16.61C16.1 16.22 16.07 15.65 15.71 15.29L13 12.59 13 6C13 5.45 12.55 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCloud: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.78 20.59L19.59 20.66 19.27 20.76 18.98 20.83 18.75 20.88 18.64 20.9C18.37 20.95 18.09 20.98 17.82 20.99L17.5 21 17.35 21 17.04 20.98 17 20.98 17 21 9 21C4.03 21 0 16.97 0 12 0 7.03 4.03 3 9 3 12.45 3 15.5 4.95 17.01 7.89L17.07 8.01C17.26 8 17.46 8 17.65 8L17.98 8.02 18.29 8.05 18.55 8.09C19.41 8.22 20.21 8.53 20.92 8.97L21.1 9.09C21.67 9.46 22.18 9.93 22.62 10.49L22.74 10.65C22.82 10.76 22.89 10.87 22.97 10.99L23.01 11.05C23.28 11.49 23.51 11.96 23.67 12.46L23.79 12.84 23.85 13.11 23.86 13.17C23.99 13.75 24.02 14.34 23.99 14.92L23.97 15.11 23.95 15.3 23.92 15.53C23.8 16.25 23.57 16.93 23.24 17.54L23.04 17.9 23.02 17.93C22.68 18.48 22.25 18.99 21.74 19.43L21.43 19.68 21.18 19.86 21.13 19.89C20.8 20.11 20.46 20.3 20.09 20.46L19.78 20.59ZM17.97 10.02L17.72 10 17.68 10C17.62 10 17.56 10 17.5 10L17.25 10.01 16.97 10.03 16.84 10.05 16.57 10.1C16.45 10.12 16.33 10.15 16.21 10.19L16.03 10.25C15.95 10.27 15.88 10.3 15.8 10.33L15.65 10.4C15.51 10.46 15.38 10.53 15.25 10.6L14.82 10.85C14.34 11.13 13.73 10.97 13.45 10.49 13.17 10.01 13.34 9.4 13.82 9.12L14.53 8.73 14.81 8.58C14.9 8.54 14.96 8.51 14.98 8.51L15.05 8.48C13.84 6.4 11.58 5 9 5 5.13 5 2 8.13 2 12 2 15.87 5.13 19 9 19L17 19 17 18.97C17.16 18.99 17.33 19 17.5 19 18.1 19 18.67 18.88 19.19 18.67L19.41 18.57 19.56 18.5 19.77 18.39 19.96 18.27C20.39 17.99 20.77 17.64 21.08 17.23L21.22 17.03 21.33 16.86 21.43 16.69 21.48 16.61C21.75 16.1 21.92 15.54 21.98 14.96 21.99 14.81 22 14.66 22 14.5 22 14.22 21.97 13.95 21.93 13.68 21.89 13.5 21.85 13.31 21.79 13.13L21.69 12.86 21.61 12.66C21.55 12.53 21.48 12.39 21.41 12.26L21.34 12.15 21.2 11.93 21.27 12.04C21.02 11.67 20.72 11.33 20.38 11.04L20.15 10.86 19.96 10.73 19.78 10.62 19.61 10.52 19.51 10.47 19.25 10.35 19.19 10.33C18.89 10.21 18.57 10.12 18.26 10.06L17.97 10.02Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCloudArrow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.29 21.73C12.68 22.09 13.32 22.09 13.71 21.73L16.71 18.94C17.1 18.58 17.1 17.99 16.71 17.62L16.64 17.57C16.25 17.26 15.66 17.28 15.29 17.62L14 18.82 14 18.78 14 11.97C14 11.44 13.55 11 13 11 12.45 11 12 11.44 12 11.97L12 18.82 10.71 17.62C10.32 17.26 9.68 17.26 9.29 17.62 8.9 17.99 8.9 18.58 9.29 18.94L12.29 21.73ZM9 3C12.45 3 15.5 4.95 17.01 7.89L17.07 8.02 17.18 8.01 17.5 8C21.09 8 24 10.91 24 14.5 24 18.09 22 21 19 21 18.88 21 18.76 21 18.64 20.99 18.6 21 18.55 21 18.5 21 17.95 21 17.5 20.55 17.5 20 17.5 19.45 17.95 19 18.5 19L18.5 18.97C18.66 18.99 18.83 19 19 19 21 19 22 16.99 22 14.5 22 12.01 19.99 10 17.5 10 16.9 10 16.32 10.12 15.8 10.33 15.05 7.27 12.29 5 9 5 5.13 5 2 7 2 12 2 16.89 4.87 18.91 6.65 18.99L7 19C7.55 19 8 19.45 8 20 8 20.51 7.61 20.94 7.12 20.99L7 21C4 21 0 18 0 12 0 6 4.03 3 9 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCo2: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.05 3L21.25 3.77C22.8 3.9 24 5.2 24 6.76L24 17.24C24 18.8 22.8 20.1 21.25 20.23L12.06 21 2.75 20.23C1.2 20.1 0 18.8 0 17.24L0 6.76C0 5.2 1.2 3.9 2.75 3.77L12.05 3ZM12.05 5.01L2.92 5.76C2.4 5.81 2 6.24 2 6.76L2 17.24C2 17.76 2.4 18.19 2.92 18.24L12.05 18.99 21.08 18.24C21.56 18.2 21.94 17.82 21.99 17.36L22 17.24 22 6.76C22 6.24 21.6 5.81 21.08 5.76L12.05 5.01ZM18.05 11C19.3 11 20 11.65 20 12.46 20 13.1 19.63 13.48 18.92 13.96L18.57 14.19C18.1 14.49 17.81 14.74 17.65 15.01L19.98 15.01 19.98 16 16.09 16 16.09 15.89C16.09 14.87 16.78 14.34 17.7 13.71L17.87 13.6C18.51 13.16 18.75 12.92 18.75 12.56 18.75 12.26 18.51 12 18.01 12 17.6 12 17.28 12.21 17.1 12.66L16 12.26C16.41 11.33 17.32 11 18.05 11ZM7.04 8.45C8.03 8.45 9.03 8.96 9.42 9.89L8.31 10.46C8.08 9.97 7.62 9.65 7.06 9.65 6.19 9.65 5.6 10.34 5.6 11.28 5.6 12.22 6.19 12.91 7.06 12.91 7.64 12.91 8.1 12.57 8.34 12.06L9.45 12.62C9.08 13.58 8.06 14.11 7.04 14.11 5.57 14.11 4.26 13.07 4.26 11.28 4.26 9.49 5.57 8.45 7.04 8.45ZM12.62 8.45C14.1 8.45 15.42 9.51 15.42 11.28 15.42 13.05 14.1 14.11 12.62 14.11 11.13 14.11 9.81 13.05 9.81 11.28 9.81 9.51 11.13 8.45 12.62 8.45ZM12.62 9.67C11.74 9.67 11.15 10.38 11.15 11.28 11.15 12.18 11.74 12.89 12.62 12.89 13.48 12.89 14.08 12.18 14.08 11.28 14.08 10.38 13.48 9.67 12.62 9.67Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCog: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 0C14.1 0 15 0.9 15 2L15 2.98C15.34 3.1 15.67 3.23 15.99 3.38L16.3 3.53 16.98 2.84C17.72 2.1 18.9 2.06 19.68 2.72L19.81 2.84 21.16 4.19C21.94 4.97 21.94 6.24 21.16 7.02L20.47 7.7 20.62 8.01C20.77 8.33 20.9 8.66 21.01 9L22 9C23.05 9 23.92 9.82 23.99 10.85L24 11 24 13C24 14.1 23.1 15 22 15L21.02 15C20.9 15.34 20.77 15.67 20.62 15.99L20.47 16.3 21.16 16.98C21.9 17.72 21.94 18.9 21.28 19.68L21.16 19.81 19.81 21.16C19.03 21.94 17.76 21.94 16.98 21.16L16.3 20.47 15.99 20.62C15.67 20.77 15.34 20.9 15 21.01L15 22C15 23.05 14.18 23.92 13.15 23.99L13 24 11 24C9.9 24 9 23.1 9 22L9 21.02C8.66 20.9 8.33 20.77 8.01 20.62L7.7 20.47 7.02 21.16C6.28 21.9 5.1 21.94 4.32 21.28L4.19 21.16 2.84 19.81C2.06 19.03 2.06 17.76 2.84 16.98L3.53 16.3 3.38 15.99C3.23 15.67 3.1 15.34 2.99 15L2 15C0.95 15 0.08 14.18 0.01 13.15L0 13 0 11C0 9.9 0.9 9 2 9L2.98 9C3.1 8.66 3.23 8.33 3.38 8.01L3.53 7.7 2.84 7.02C2.1 6.28 2.06 5.1 2.72 4.32L2.84 4.19 4.19 2.84C4.97 2.06 6.24 2.06 7.02 2.84L7.7 3.53 8.01 3.38C8.33 3.23 8.66 3.1 9 2.99L9 2C9 0.95 9.82 0.08 10.85 0.01L11 0 13 0ZM13 2L11 2 11 4.57C9.66 4.74 8.43 5.28 7.41 6.07L5.6 4.26 4.26 5.6 6.07 7.41C5.28 8.43 4.74 9.66 4.57 11L2 11 2 13 4.57 13C4.74 14.34 5.28 15.57 6.07 16.59L4.26 18.4 5.6 19.74 7.41 17.93C8.43 18.72 9.66 19.26 11 19.43L11 22 13 22 13 19.43C14.34 19.26 15.57 18.72 16.59 17.93L18.4 19.74 19.74 18.4 17.93 16.59C18.72 15.57 19.26 14.34 19.43 13L22 13 22 11 19.43 11C19.26 9.66 18.72 8.43 17.93 7.41L19.74 5.6 18.4 4.26 16.59 6.07C15.57 5.28 14.34 4.74 13 4.57L13 2ZM12 8C14.21 8 16 9.79 16 12 16 14.21 14.21 16 12 16 9.79 16 8 14.21 8 12 8 9.79 9.79 8 12 8ZM12 10C10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14 13.1 14 14 13.1 14 12 14 10.9 13.1 10 12 10Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCogAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.42 0C13.38 0 14.3 0.38 14.99 1.07 15.67 1.76 16.05 2.69 16.04 3.67L16.04 3.87C16.04 4.53 16.7 4.93 17.23 4.6 18.88 3.6 20.99 4.2 21.97 5.87L22.44 6.67C23.41 8.36 22.85 10.54 21.18 11.53 20.91 11.69 20.74 11.98 20.74 12.3 20.74 12.62 20.91 12.91 21.18 13.07 22.88 14.03 23.5 16.2 22.57 17.93L22.11 18.73C21.12 20.4 19.01 21 17.36 20L17.23 19.93C16.7 19.67 16.11 20 16.11 20.6 16.1 22.47 14.6 23.99 12.75 24L11.63 24C10.72 24.01 9.84 23.64 9.2 22.99 8.55 22.34 8.2 21.45 8.2 20.53 8.2 20.25 8.05 19.99 7.8 19.85 7.56 19.71 7.26 19.72 7.02 19.87L6.82 20C6 20.48 5.02 20.61 4.11 20.36 3.19 20.11 2.41 19.5 1.94 18.67L1.48 17.93C0.5 16.24 1.06 14.06 2.73 13.07 3.01 12.91 3.18 12.62 3.18 12.3 3.18 11.98 3.01 11.69 2.73 11.53 1.09 10.53 0.49 8.33 1.48 6.67L1.88 5.93C2.35 5.1 3.13 4.49 4.04 4.24 4.96 3.99 5.93 4.12 6.75 4.6 7.35 4.93 8.14 4.53 8.14 3.8L8.14 3.67C8.15 1.65 9.77 0.02 11.76 0L12.42 0ZM12.42 2L11.78 2C10.88 2.01 10.14 2.75 10.14 3.67L10.14 3.8C10.14 6.07 7.69 7.42 5.74 6.33 5.39 6.12 4.96 6.06 4.57 6.17 4.17 6.28 3.83 6.55 3.64 6.88L3.2 7.69C2.78 8.39 3.04 9.38 3.72 9.79 4.62 10.3 5.18 11.26 5.18 12.3 5.18 13.34 4.62 14.3 3.76 14.78 3.03 15.22 2.78 16.18 3.17 16.87L3.68 17.68C3.89 18.05 4.23 18.32 4.63 18.43 5.02 18.53 5.43 18.48 5.78 18.29L5.95 18.17C6.75 17.67 7.75 17.61 8.6 18.01L8.78 18.1C9.66 18.6 10.2 19.53 10.2 20.55 10.2 20.94 10.35 21.31 10.62 21.59 10.89 21.85 11.24 22 11.63 22L12.74 22C13.49 22 14.11 21.37 14.11 20.6 14.11 18.49 16.29 17.22 18.13 18.15L18.26 18.22 18.4 18.29C19.06 18.69 19.95 18.45 20.37 17.73L20.8 16.99C21.22 16.21 20.95 15.23 20.19 14.8 19.29 14.3 18.74 13.34 18.74 12.3 18.74 11.26 19.29 10.3 20.16 9.82 20.89 9.38 21.13 8.42 20.7 7.67L20.25 6.89C19.81 6.15 18.93 5.91 18.3 6.29 16.39 7.5 14.04 6.05 14.04 3.87L14.04 3.66C14.04 3.22 13.87 2.79 13.56 2.48 13.26 2.17 12.85 2 12.42 2ZM11.99 8C13.06 7.99 14.08 8.41 14.83 9.17 15.59 9.92 16.01 10.94 16 12 16 14.21 14.21 16 12 16 9.79 16 8 14.21 8 12 8 9.79 9.79 8 11.99 8ZM12 10C10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14 13.1 14 14 13.1 14 11.99 14 11.46 13.79 10.95 13.42 10.58 13.05 10.21 12.54 10 12 10Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCompare: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 3C6.66 3 8 4.34 8 6 8 7.31 7.17 8.42 6 8.83L6 16C6 16.55 6.45 17 7 17L9.73 17 8.47 15.71C8.1 15.32 8.1 14.68 8.47 14.29 8.85 13.9 9.45 13.9 9.83 14.29L12.72 17.29C13.09 17.68 13.09 18.32 12.72 18.71L9.83 21.71C9.45 22.1 8.85 22.1 8.47 21.71L8.42 21.64C8.1 21.25 8.12 20.66 8.47 20.29L9.73 19 7 19C5.34 19 4 17.66 4 16L4 8.83C2.83 8.42 2 7.31 2 6 2 4.34 3.34 3 5 3ZM15.03 2.29L15.08 2.36C15.4 2.75 15.38 3.34 15.03 3.71L13.77 5 17 5C18.66 5 20 6.34 20 8L20 15.17C21.17 15.58 22 16.69 22 18 22 19.66 20.66 21 19 21 17.34 21 16 19.66 16 18 16 16.69 16.83 15.58 18 15.17L18 8C18 7.45 17.55 7 17 7L13.77 7 15.03 8.29C15.4 8.68 15.4 9.32 15.03 9.71 14.65 10.1 14.05 10.1 13.67 9.71L10.78 6.71C10.41 6.32 10.41 5.68 10.78 5.29L13.67 2.29C14.05 1.9 14.65 1.9 15.03 2.29ZM19 17C18.45 17 18 17.45 18 18 18 18.55 18.45 19 19 19 19.55 19 20 18.55 20 18 20 17.45 19.55 17 19 17ZM5 5C4.45 5 4 5.45 4 6 4 6.55 4.45 7 5 7 5.55 7 6 6.55 6 6 6 5.45 5.55 5 5 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaContactAt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 12C3 16.97 7.03 21 12 21 12.62 21 13.12 20.5 13.12 19.88 13.12 19.25 12.62 18.75 12 18.75 8.27 18.75 5.25 15.73 5.25 12 5.25 8.27 8.27 5.25 12 5.25 15.73 5.25 18.75 8.27 18.75 12L18.75 15.38C18.75 16 18.25 16.5 17.62 16.5 17 16.5 16.5 16 16.5 15.38L16.5 12C16.5 10.18 15.4 8.54 13.72 7.84 12.04 7.15 10.11 7.53 8.82 8.82 7.53 10.11 7.15 12.04 7.84 13.72 8.54 15.4 10.18 16.5 12 16.5 12.81 16.5 13.61 16.27 14.3 15.85 14.54 17.6 16.1 18.87 17.87 18.74 19.64 18.62 21 17.15 21 15.38L21 12C21 7.03 16.97 3 12 3 7.03 3 3 7.03 3 12ZM12 14C10.9 14 10 13.1 10 12 10 10.9 10.9 10 12 10 13.1 10 14 10.9 14 12 14 13.1 13.1 14 12 14Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCookies: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C13.22 0 14.36 0.59 15.04 1.53L15.27 1.87C15.67 2.39 16.36 2.63 17.07 2.45L17.34 2.39C18.51 2.22 19.7 2.6 20.57 3.45 21.26 4.16 21.64 5.1 21.64 6.12L21.63 6.35C21.62 6.49 21.6 6.63 21.58 6.75L21.52 7.01 21.5 7.24 21.49 7.38C21.49 7.91 21.75 8.4 22.2 8.73L22.57 8.98C23.16 9.42 23.61 10.02 23.87 10.74 24 11.12 24.07 11.52 24.07 11.93 24.07 13.15 23.48 14.29 22.52 14.98L22.18 15.21C21.68 15.58 21.43 16.19 21.52 16.84L21.6 17.27C21.78 18.45 21.4 19.64 20.55 20.5 19.84 21.19 18.89 21.57 17.9 21.57 17.61 21.57 17.33 21.54 17 21.47 16.88 21.44 16.75 21.42 16.62 21.42 16.09 21.42 15.6 21.68 15.28 22.11L15.19 22.24C14.5 23.34 13.29 24 12 24 11.05 24 10.13 23.64 9.41 22.97 9.26 22.82 9.12 22.66 9.01 22.5L8.79 22.18C8.64 21.98 8.46 21.82 8.24 21.7 7.99 21.57 7.72 21.49 7.45 21.49 7.37 21.49 7.29 21.5 7.24 21.5L6.98 21.56 6.67 21.61C6.51 21.63 6.34 21.64 6.16 21.64 5.29 21.64 4.44 21.34 3.73 20.76L3.5 20.55C2.81 19.84 2.43 18.9 2.43 17.9 2.43 17.62 2.46 17.33 2.53 17 2.56 16.88 2.58 16.75 2.58 16.62 2.58 16.09 2.32 15.6 1.89 15.28L1.76 15.19C0.66 14.5 0 13.29 0 12 0 11.86 0.01 11.72 0.02 11.58 0.12 10.68 0.54 9.85 1.2 9.24 1.37 9.08 1.56 8.94 1.75 8.81 2.02 8.64 2.24 8.39 2.36 8.12L2.4 8.04 2.46 7.84C2.53 7.56 2.53 7.27 2.45 6.94L2.4 6.69 2.37 6.5 2.36 6.4 2.36 6.16C2.36 5.17 2.74 4.23 3.45 3.51 4.32 2.65 5.55 2.27 6.72 2.47L7.12 2.55C7.79 2.65 8.45 2.35 8.83 1.72L8.99 1.49C9.71 0.55 10.82 0 12 0ZM12 2C11.44 2 10.92 2.26 10.61 2.67L10.51 2.81C9.74 4.08 8.28 4.75 6.78 4.52L6.51 4.47C5.91 4.33 5.29 4.5 4.86 4.92 4.54 5.25 4.36 5.7 4.36 6.13L4.36 6.3 4.37 6.36 4.4 6.49C4.55 7.1 4.55 7.74 4.38 8.39L4.28 8.71 4.2 8.91C3.91 9.56 3.43 10.11 2.83 10.5 2.73 10.56 2.65 10.63 2.57 10.7 2.26 10.99 2.06 11.38 2.01 11.8 2 11.87 2 11.93 2 12 2 12.61 2.31 13.17 2.81 13.49 3.9 14.15 4.57 15.33 4.58 16.62 4.58 16.92 4.54 17.22 4.48 17.46 4.45 17.61 4.43 17.76 4.43 17.91 4.43 18.37 4.61 18.82 4.89 19.11L5.03 19.24C5.35 19.5 5.75 19.64 6.15 19.64L6.33 19.63C6.35 19.63 6.37 19.63 6.39 19.63L6.6 19.59 6.85 19.54C7.05 19.51 7.25 19.49 7.46 19.49 8.08 19.49 8.68 19.66 9.21 19.95 9.67 20.21 10.08 20.56 10.42 21.02L10.57 21.24C10.64 21.36 10.72 21.46 10.79 21.53 11.12 21.83 11.55 22 12 22 12.61 22 13.17 21.69 13.49 21.19 14.15 20.1 15.33 19.43 16.62 19.42 16.92 19.42 17.22 19.46 17.46 19.52 17.61 19.55 17.76 19.57 17.91 19.57 18.37 19.57 18.82 19.39 19.14 19.08 19.53 18.68 19.71 18.12 19.63 17.61L19.6 17.42C19.26 15.98 19.81 14.48 21.03 13.58L21.24 13.43C21.76 13.1 22.07 12.54 22.07 11.93 22.07 11.74 22.04 11.55 21.99 11.4 21.87 11.08 21.66 10.8 21.41 10.62L21.26 10.51C20.17 9.85 19.5 8.67 19.49 7.38 19.49 7.27 19.49 7.16 19.51 7.05L19.54 6.72 19.6 6.44C19.62 6.35 19.63 6.27 19.64 6.24L19.64 6.09C19.64 5.63 19.46 5.18 19.15 4.86 18.75 4.47 18.19 4.29 17.68 4.36L17.51 4.4C16.08 4.77 14.58 4.25 13.66 3.05L13.5 2.83C13.17 2.31 12.61 2 12 2ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11ZM12 7C12.55 7 13 7.45 13 8 13 8.55 12.55 9 12 9 11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCopy: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 7C22.66 7 24 8.34 24 10L24 21C24 22.66 22.66 24 21 24L10 24C8.34 24 7 22.66 7 21L7 10C7 8.34 8.34 7 10 7L21 7ZM21 9L10 9C9.45 9 9 9.45 9 10L9 21C9 21.55 9.45 22 10 22L21 22C21.55 22 22 21.55 22 21L22 10C22 9.45 21.55 9 21 9ZM14 0C15.66 0 17 1.34 17 3L17 4C17 4.55 16.55 5 16 5 15.45 5 15 4.55 15 4L15 3C15 2.45 14.55 2 14 2L3 2C2.45 2 2 2.45 2 3L2 14C2 14.55 2.45 15 3 15L4 15C4.55 15 5 15.45 5 16 5 16.55 4.55 17 4 17L3 17C1.34 17 0 15.66 0 14L0 3C0 1.34 1.34 0 3 0L14 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCopyDocument: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 21C24 22.66 22.66 24 21 24L10 24C8.34 24 7 22.66 7 21L7 6C7 4.34 8.34 3 10 3L21 3ZM21 5L10 5C9.45 5 9 5.45 9 6L9 21C9 21.55 9.45 22 10 22L21 22C21.55 22 22 21.55 22 21L22 6C22 5.45 21.55 5 21 5ZM14.2 18C14.75 18 15.2 18.45 15.2 19 15.2 19.55 14.75 20 14.2 20L12 20C11.45 20 11 19.55 11 19 11 18.45 11.45 18 12 18L14.2 18ZM15.6 14C16.15 14 16.6 14.45 16.6 15 16.6 15.55 16.15 16 15.6 16L12 16C11.45 16 11 15.55 11 15 11 14.45 11.45 14 12 14L15.6 14ZM17 10C17.55 10 18 10.45 18 11 18 11.55 17.55 12 17 12L12 12C11.45 12 11 11.55 11 11 11 10.45 11.45 10 12 10L17 10ZM3 22C1.34 22 0 20.66 0 19L0 3C0 1.34 1.34 0 3 0L5 0 5 2 3 2C2.45 2 2 2.45 2 3L2 19C2 19.55 2.45 20 3 20L4 20C4.55 20 5 20.45 5 21 5 21.55 4.55 22 4 22L3 22Z M5 0H7A1 1 0 0 1 8 1V1A1 1 0 0 1 7 2H5A1 1 0 0 1 4 1V1A1 1 0 0 1 5 0z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDark: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.14 7.71C9.14 6.73 9.28 5.84 9.55 5.11L9.67 4.8C9.71 4.69 9.73 4.58 9.7 4.46 9.68 4.35 9.63 4.25 9.55 4.17 9.47 4.09 9.36 4.03 9.25 4.01 9.14 3.99 9.02 4 8.92 4.05L8.64 4.17C5.81 5.54 4 8.46 4 11.71 4 13.91 4.87 16.02 6.43 17.57 7.88 19.03 9.83 19.89 11.88 19.99L12.29 20C15.64 20 18.65 18.07 19.95 15.09 20 14.98 20.01 14.86 19.99 14.75 19.97 14.64 19.91 14.53 19.83 14.45 19.75 14.37 19.65 14.32 19.54 14.3 19.42 14.27 19.31 14.29 19.2 14.33 18.41 14.68 17.41 14.86 16.29 14.86V12.86C17.21 12.86 17.93 12.71 18.4 12.5L18.58 12.43C18.95 12.3 19.33 12.26 19.72 12.3L19.91 12.33 20.1 12.37C20.47 12.47 20.81 12.66 21.11 12.91L21.25 13.04 21.38 13.18C21.63 13.47 21.81 13.82 21.91 14.19L21.96 14.38 21.98 14.57C22.03 15.02 21.97 15.47 21.79 15.88 20.16 19.63 16.41 22 12.29 22 9.56 22 6.94 20.92 5.01 18.99 3.08 17.06 2 14.44 2 11.71 2 7.59 4.37 3.85 8.12 2.21 8.53 2.03 8.98 1.97 9.43 2.02L9.62 2.04 9.81 2.09C10.18 2.19 10.53 2.37 10.82 2.62L10.96 2.75 11.09 2.89C11.39 3.24 11.58 3.65 11.67 4.09 11.75 4.54 11.72 4.99 11.57 5.42L11.5 5.6C11.29 6.07 11.14 6.79 11.14 7.71 11.14 10.55 13.45 12.86 16.29 12.86V14.86L15.92 14.85C12.15 14.66 9.14 11.53 9.14 7.71Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDetails: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 0C15.31 0 16.42 0.83 16.83 2L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L7.17 2C7.58 0.83 8.69 0 10 0L14 0ZM7.17 4L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L16.83 4C16.42 5.17 15.31 6 14 6L10 6C8.69 6 7.58 5.17 7.17 4ZM13 18C13.55 18 14 18.45 14 19 14 19.55 13.55 20 13 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L13 18ZM13 14C13.55 14 14 14.45 14 15 14 15.55 13.55 16 13 16L7 16C6.45 16 6 15.55 6 15 6 14.45 6.45 14 7 14L13 14ZM14 2L10 2C9.45 2 9 2.45 9 3 9 3.55 9.45 4 10 4L14 4C14.55 4 15 3.55 15 3 15 2.45 14.55 2 14 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDimensions: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C12.55 1 13 1.45 13 2L13 4C13 4.04 13 4.08 12.99 4.12 14.72 4.57 16 6.13 16 8 16 9.08 15.57 10.06 14.87 10.78L18.34 16.79C19.3 15.91 20.04 14.76 20.4 13.41 20.54 12.88 21.09 12.56 21.62 12.71 22.16 12.85 22.47 13.4 22.33 13.93 21.82 15.81 20.76 17.4 19.36 18.55L21.12 21.59C21.39 22.07 21.23 22.68 20.75 22.96 20.61 23.04 20.47 23.08 20.32 23.09L20.21 23.09C19.88 23.08 19.56 22.9 19.38 22.59L17.68 19.64C15.78 20.6 13.53 20.89 11.31 20.29 10.77 20.15 10.46 19.6 10.6 19.07 10.74 18.54 11.29 18.22 11.82 18.36 13.51 18.81 15.22 18.61 16.68 17.91L13.17 11.83C12.8 11.94 12.41 12 12 12 11.75 12 11.51 11.98 11.27 11.93L5.12 22.59C4.96 22.87 4.69 23.04 4.4 23.08L4.29 23.09C4.11 23.1 3.92 23.06 3.75 22.96 3.27 22.68 3.11 22.07 3.38 21.59L9.45 11.08C8.56 10.35 8 9.24 8 8 8 6.13 9.28 4.57 11.01 4.12L11 4.06 11 2C11 1.45 11.45 1 12 1ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDotFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDotOutline: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M24 12A12 12 0 0 1 12 24 12 12 0 0 1 0 12 12 12 0 0 1 24 12z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDots: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4.5 14C5.6 14 6.5 13.1 6.5 12 6.5 10.9 5.6 10 4.5 10 3.4 10 2.5 10.9 2.5 12 2.5 13.1 3.4 14 4.5 14ZM12 14C13.1 14 14 13.1 14 12 14 10.9 13.1 10 12 10 10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14ZM19.5 14C20.6 14 21.5 13.1 21.5 12 21.5 10.9 20.6 10 19.5 10 18.4 10 17.5 10.9 17.5 12 17.5 13.1 18.4 14 19.5 14Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDotsVertical: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 19.5C14 18.4 13.1 17.5 12 17.5 10.9 17.5 10 18.4 10 19.5 10 20.6 10.9 21.5 12 21.5 13.1 21.5 14 20.6 14 19.5ZM14 12C14 10.9 13.1 10 12 10 10.9 10 10 10.9 10 12 10 13.1 10.9 14 12 14 13.1 14 14 13.1 14 12ZM14 4.5C14 3.4 13.1 2.5 12 2.5 10.9 2.5 10 3.4 10 4.5 10 5.6 10.9 6.5 12 6.5 13.1 6.5 14 5.6 14 4.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDownload: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12 0C12.55 0 13 0.45 13 1L13 13.54 14.29 12.28C14.68 11.91 15.32 11.91 15.71 12.28 16.1 12.65 16.1 13.26 15.71 13.63L12.71 16.53C12.32 16.9 11.68 16.9 11.29 16.53L8.29 13.63C7.9 13.26 7.9 12.65 8.29 12.28L8.36 12.22C8.75 11.91 9.34 11.93 9.71 12.28L11 13.54 11 1C11 0.45 11.45 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDownloadPdf: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.27 0 17.52 0.11 17.71 0.29L21.71 4.29C21.89 4.48 22 4.73 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 2C2 0.9 2.9 0 4 0L17 0ZM15 2L4 2 4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 7 16 7 15.88 6.99C15.39 6.94 15 6.51 15 6L15 2ZM10.8 8L10.88 8C11.41 8.03 12.02 8.35 12.17 9.19 12.37 10.13 12.16 11.15 11.96 12.03L11.87 12.4C12.32 13.59 12.95 14.39 13.91 14.97 15.87 14.73 17.13 14.86 17.65 15.37 18 15.73 18.1 16.39 17.89 16.92 17.76 17.22 17.43 17.72 16.58 17.72 15.73 17.72 14.47 17.34 13.37 16.75 12.47 16.91 11.47 17.23 10.5 17.56L10.21 17.65C9.98 17.74 9.74 17.81 9.52 17.89 8.02 20.44 6.91 21 6.22 21 6.06 21 5.91 20.97 5.8 20.92 5.53 20.82 5.3 20.61 5.15 20.33 5.02 20.09 4.97 19.81 5.02 19.6 5.25 18.43 6.8 17.5 7.96 16.91 8.59 15.81 9.43 13.97 9.97 12.7L9.87 12.3C9.51 10.85 9.33 9.7 9.57 8.84 9.7 8.35 10.21 8.01 10.8 8ZM10.9 14C10.69 14.56 10.37 15.33 10 16L10.17 15.93 10.34 15.86C10.84 15.66 11.4 15.43 12 15.29 11.58 14.97 11.2 14.52 10.9 14ZM17 2.63L17 5 19.37 5 17 2.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaDrag: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 9L20 9C20.55 9 21 9.45 21 10 21 10.55 20.55 11 20 11L4 11C3.45 11 3 10.55 3 10 3 9.45 3.45 9 4 9ZM4 13L20 13C20.55 13 21 13.45 21 14 21 14.55 20.55 15 20 15L4 15C3.45 15 3 14.55 3 14 3 13.45 3.45 13 4 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEdit: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 0C10.55 0 11 0.45 11 1 11 1.51 10.61 1.94 10.12 1.99L10 2 3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 14C22 13.45 22.45 13 23 13 23.51 13 23.94 13.39 23.99 13.88L24 14 24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L10 0ZM20.81 1.11C21.89 1.4 22.73 2.24 23.01 3.31 23.3 4.39 23 5.54 22.21 6.33L12.71 15.83C12.58 15.96 12.42 16.05 12.24 16.09L8.24 17.09C7.51 17.27 6.85 16.61 7.03 15.88L8.03 11.88C8.07 11.7 8.16 11.54 8.29 11.41L17.79 1.91C18.58 1.13 19.73 0.82 20.81 1.11ZM19.21 3.33L9.9 12.63 9.37 14.75 11.49 14.22 20.79 4.91C21.04 4.66 21.16 4.31 21.11 3.96L21.08 3.83C20.98 3.44 20.68 3.14 20.29 3.04 19.9 2.93 19.49 3.05 19.21 3.33Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEditColumns: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM6 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L6 22 6 2ZM21 2L8 2 8 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM16 18C16.55 18 17 18.45 17 19 17 19.55 16.55 20 16 20L11 20C10.45 20 10 19.55 10 19 10 18.45 10.45 18 11 18L16 18ZM16 14C16.55 14 17 14.45 17 15 17 15.55 16.55 16 16 16L11 16C10.45 16 10 15.55 10 15 10 14.45 10.45 14 11 14L16 14ZM16 10C16.55 10 17 10.45 17 11 17 11.55 16.55 12 16 12L11 12C10.45 12 10 11.55 10 11 10 10.45 10.45 10 11 10L16 10Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaElectricCharger: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 1C17.55 1 18 1.45 18 2L18 4 19 4C20.1 4 21 4.9 21 6L21 16.53 21 16.69C20.9 19.65 18.47 22 15.5 22L8.47 22 8.31 22C5.35 21.9 3 19.47 3 16.5L3 6C3 4.9 3.9 4 5 4L6 4 6 2C6 1.45 6.45 1 7 1 7.55 1 8 1.45 8 2L8 4 16 4 16 2C16 1.45 16.45 1 17 1ZM19 6L5 6 5 16.5C5 18.39 6.5 19.93 8.38 20L8.5 20 15.5 20C17.39 20 18.93 18.5 19 16.62L19 16.5 19 6ZM12.38 8.08C12.89 8.29 13.14 8.87 12.92 9.38L11.83 12 15.17 12 12.92 17.38C12.71 17.89 12.13 18.14 11.62 17.92 11.11 17.71 10.86 17.13 11.08 16.62L12.17 14 8.83 14 11.08 8.62C11.29 8.11 11.87 7.86 12.38 8.08Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaElevator: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 1C12.66 1 14 2.34 14 4L15 4C16.66 4 18 5.34 18 7L18 23 0 23 0 7C0 5.34 1.34 4 3 4L4 4C4 2.34 5.34 1 7 1L11 1ZM8 6L3 6C2.45 6 2 6.45 2 7L2 21 8 21 8 6ZM15 6L10 6 10 21 16 21 16 7C16 6.49 15.61 6.06 15.12 6.01L15 6ZM22.29 15.29L23.71 16.71 21 19.41 18.29 16.71 19.71 15.29 21 16.59 22.29 15.29ZM21 9.59L23.71 12.29 22.29 13.71 21 12.41 19.71 13.71 18.29 12.29 21 9.59ZM11 3L7 3C6.45 3 6 3.45 6 4L12 4C12 3.45 11.55 3 11 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEmptyRead: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 4C19.76 4 20.45 4.43 20.79 5.11L23.79 9.11C23.93 9.38 24 9.69 24 10L24 18C24 19.1 23.1 20 22 20L2 20C0.9 20 0 19.1 0 18L0 10C0 9.69 0.07 9.38 0.21 9.11L3.21 5.11C3.55 4.43 4.24 4 5 4L19 4ZM22 12L16 12C15.52 13.84 14.02 15 12.04 15 10.05 15 8.49 13.84 8 12L2 12 2 18 22 18 22 12ZM19 6L5 6 2 10 8.6 10.01C9.09 10.01 9.49 10.39 9.49 10.87 9.49 12.22 10.61 13.28 12.04 13.28 13.46 13.28 14.58 12.22 14.58 10.87 14.58 10.39 14.98 10.01 15.47 10.01L22 10 19 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEmptyReadAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 5C17 4.45 17.45 4 18 4L19 4C19.76 4 20.45 4.43 20.79 5.11L23.79 9.11C23.93 9.38 24 9.69 24 10L24 18C24 19.1 23.1 20 22 20L2 20C0.9 20 0 19.1 0 18L0 10C0 9.69 0.07 9.38 0.21 9.11L3.21 5.11C3.55 4.43 4.24 4 5 4L6 4C6.55 4 7 4.45 7 5 7 5.51 6.61 5.94 6.12 5.99L6 6 5 6 2 10 8.6 10.01C9.09 10.01 9.49 10.39 9.49 10.87 9.49 12.22 10.61 13.28 12.04 13.28 13.46 13.28 14.58 12.22 14.58 10.87 14.58 10.39 14.98 10.01 15.47 10.01L22 10 19 6 18 6C17.45 6 17 5.55 17 5ZM8 12L2 12 2 18 22 18 22 12 16 12C15.52 13.84 14.02 15 12.04 15 10.05 15 8.49 13.84 8 12ZM12.61 0.38L15.61 3.27C16 3.64 16 4.25 15.61 4.62L15.55 4.68C15.15 5 14.57 4.98 14.2 4.62L12.9 3.36 12.9 10.9C12.9 11.46 12.46 11.9 11.9 11.9 11.35 11.9 10.9 11.46 10.9 10.9L10.9 3.36 9.61 4.62C9.22 5 8.59 5 8.2 4.62 7.81 4.25 7.81 3.64 8.2 3.27L11.2 0.38C11.59 0 12.22 0 12.61 0.38Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExclamationCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 16C12.83 16 13.5 16.67 13.5 17.5 13.5 18.33 12.83 19 12 19 11.17 19 10.5 18.33 10.5 17.5 10.5 16.67 11.17 16 12 16ZM12 5C12.55 5 13 5.5 13 6.13L13 12.88C13 13.5 12.55 14 12 14 11.45 14 11 13.5 11 12.88L11 6.13C11 5.5 11.45 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExclamationCircleFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 15.5C11.17 15.5 10.5 16.17 10.5 17 10.5 17.83 11.17 18.5 12 18.5 12.83 18.5 13.5 17.83 13.5 17 13.5 16.17 12.83 15.5 12 15.5ZM12 6C11.47 6 11.04 6.41 11 6.93L11 7 11 13C11 13.55 11.45 14 12 14 12.53 14 12.96 13.59 13 13.07L13 13 13 7C13 6.45 12.55 6 12 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExclamationTriangle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.36 0.34C13.7 0.57 13.98 0.88 14.17 1.21L23.67 18.13 23.74 18.25 23.77 18.31 23.81 18.42C24.26 19.53 23.89 20.84 22.86 21.52 22.46 21.79 21.99 21.93 21.51 21.93L2.49 21.93 2.37 21.93 2.18 21.91C0.9 21.75 0 20.64 0 19.38 0 18.95 0.11 18.53 0.33 18.13L9.88 1.14 9.97 0.99 10.07 0.86 10.15 0.77C10.95-0.15 12.31-0.35 13.36 0.34ZM11.65 2.09L11.61 2.14 11.58 2.19 2.07 19.11C2.02 19.19 2 19.29 2 19.38 2 19.66 2.19 19.89 2.44 19.93L2.49 19.93 21.51 19.93C21.6 19.93 21.68 19.9 21.76 19.85 21.98 19.71 22.06 19.41 21.96 19.17L21.93 19.11 12.42 2.19C12.38 2.12 12.32 2.05 12.25 2.01 12.05 1.87 11.8 1.92 11.65 2.09ZM12 15C12.83 15 13.5 15.67 13.5 16.5 13.5 17.33 12.83 18 12 18 11.17 18 10.5 17.33 10.5 16.5 10.5 15.67 11.17 15 12 15ZM12 7C12.55 7 13 7.39 13 7.88L13 13.13C13 13.61 12.55 14 12 14 11.45 14 11 13.61 11 13.13L11 7.88C11 7.39 11.45 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExclamationTriangleFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.97 2.29C13.21 2.44 13.41 2.65 13.56 2.89L13.62 2.99 22.73 18.9C23.27 19.87 22.98 21.13 22.08 21.71 21.82 21.88 21.52 21.98 21.22 22L21.11 22 2.89 22C1.85 22 1 21.08 1 19.95 1 19.63 1.07 19.31 1.21 19.02L1.27 18.9 10.38 2.99C10.91 2.02 12.08 1.71 12.97 2.29ZM12 16C11.17 16 10.5 16.67 10.5 17.5 10.5 18.33 11.17 19 12 19 12.83 19 13.5 18.33 13.5 17.5 13.5 16.67 12.83 16 12 16ZM12 7C11.45 7 11 7.45 11 8L11 14C11 14.55 11.45 15 12 15 12.55 15 13 14.55 13 14L13 8C13 7.45 12.55 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExternalLink: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 4C14.55 4 15 4.45 15 5 15 5.55 14.55 6 14 6L3 6C2.45 6 2 6.45 2 7L2 21C2 21.55 2.45 22 3 22L17 22C17.55 22 18 21.55 18 21L18 11C18 10.45 18.45 10 19 10 19.55 10 20 10.45 20 11L20 21C20 22.66 18.66 24 17 24L3 24C1.34 24 0 22.66 0 21L0 7C0 5.34 1.34 4 3 4L14 4ZM23 0C23.55 0 24 0.45 24 1L24 6C24 6.55 23.55 7 23 7 22.45 7 22 6.55 22 6L22 3.71 8.96 16.79C8.56 17.19 7.93 17.19 7.54 16.8 7.15 16.41 7.15 15.77 7.54 15.38L20.96 2 18 2C17.45 2 17 1.55 17 1 17 0.45 17.45 0 18 0L23 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExtra: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.19 0.93L20.26 1 20.34 1.09C20.79 1.65 21.01 2.32 20.99 3L21.02 3C21.73 2.99 22.44 3.24 23 3.74L23.14 3.87 23.21 3.94 23.27 4.02 23.34 4.09C24.24 5.2 24.22 6.79 23.24 7.94L23.12 8.07 19.25 11.93 23.2 15.88 23.27 15.95 23.34 16.04C24.3 17.22 24.2 18.93 23.12 20 22.53 20.58 21.76 20.87 20.99 20.86L20.86 20.85 20.86 21.02C20.87 21.73 20.61 22.44 20.11 23L19.98 23.14C18.9 24.21 17.19 24.29 16.01 23.32L15.93 23.24 15.8 23.12 11.93 19.25 8.05 23.13 7.98 23.2 7.84 23.33C6.65 24.3 4.92 24.21 3.85 23.11 3.31 22.57 3.03 21.86 3.01 21.14L3.01 21 2.97 21C2.26 21 1.55 20.75 0.99 20.25L0.85 20.11C-0.22 19.02-0.29 17.3 0.76 16.06L0.88 15.93 4.74 12.07 0.87 8.19 0.79 8.11 0.73 8.04 0.66 7.96C-0.3 6.77-0.2 5.05 0.89 3.98 1.48 3.41 2.26 3.12 3.03 3.14L3.14 3.15 3.14 2.97C3.14 2.25 3.39 1.54 3.89 0.98L4.03 0.85C5.12-0.22 6.84-0.29 8.08 0.76L8.2 0.88 12.07 4.75 16.02 0.8 16.09 0.73 16.17 0.66C17.35-0.29 19.06-0.21 20.19 0.93ZM21.72 5.28C21.37 4.93 20.82 4.9 20.43 5.22L20.36 5.28 5.29 20.35 5.23 20.42C4.91 20.8 4.93 21.36 5.28 21.71 5.62 22.07 6.18 22.1 6.57 21.78L6.64 21.72 11.93 16.43 17.21 21.7 17.29 21.78C17.67 22.09 18.23 22.07 18.58 21.72 18.93 21.37 18.96 20.82 18.65 20.43L18.58 20.36 13.29 15.07 15.07 13.29 20.35 18.57 20.43 18.64C20.81 18.95 21.36 18.93 21.71 18.58 22.07 18.24 22.1 17.68 21.79 17.3L21.72 17.22 16.43 11.93 21.71 6.65 21.77 6.58C22.07 6.23 22.08 5.71 21.79 5.36L21.72 5.28ZM6.72 2.23C6.34 1.91 5.78 1.93 5.43 2.27 5.07 2.62 5.04 3.18 5.35 3.56L5.42 3.64 10.71 8.93 8.93 10.71 3.65 5.43 3.58 5.36C3.2 5.05 2.64 5.07 2.29 5.41 1.93 5.76 1.9 6.32 2.21 6.7L2.28 6.78 7.57 12.07 2.29 17.35 2.23 17.42C1.91 17.8 1.93 18.36 2.28 18.71 2.62 19.07 3.18 19.1 3.57 18.78L3.64 18.72 18.71 3.65 18.77 3.58C19.07 3.23 19.08 2.71 18.79 2.35L18.72 2.28C18.37 1.93 17.82 1.9 17.43 2.22L17.36 2.28 12.07 7.57 6.79 2.29 6.72 2.23Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEyeClose: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.01 16L13.01 13.97C15.28 13.83 17.18 13.2 18.68 12.08L20.31 13.71C20.7 14.09 21.32 14.08 21.71 13.69 22.09 13.31 22.1 12.69 21.72 12.29L20.13 10.7C20.91 9.77 21.52 8.64 21.96 7.32 22.07 6.98 22 6.6 21.76 6.34 21.52 6.07 21.16 5.95 20.81 6.02 20.46 6.09 20.18 6.35 20.06 6.68 18.87 10.26 16.26 12 12.01 12 7.76 12 5.15 10.26 3.96 6.68 3.79 6.16 3.22 5.88 2.7 6.05 2.17 6.23 1.89 6.79 2.06 7.32 2.5 8.64 3.12 9.77 3.9 10.7L2.31 12.29C2.05 12.54 1.94 12.92 2.03 13.27 2.12 13.62 2.4 13.89 2.75 13.98 3.1 14.07 3.47 13.97 3.72 13.71L5.35 12.08C6.85 13.2 8.74 13.83 11.01 13.97L11.01 16C11.01 16.55 11.46 17 12.01 17 12.56 17 13.01 16.55 13.01 16Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEyeHide: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.73 1.77C23.12 2.16 23.12 2.8 22.73 3.19L2.93 22.99C2.54 23.38 1.91 23.38 1.51 22.99 1.12 22.59 1.12 21.96 1.51 21.57L5.02 18.06C4.37 17.58 3.75 17.03 3.15 16.42 2.28 15.55 1.53 14.62 0.89 13.69 0.51 13.13 0.25 12.69 0.11 12.42-0.04 12.16-0.04 11.84 0.11 11.58L0.22 11.37 0.37 11.12C0.5 10.89 0.68 10.62 0.89 10.31 1.53 9.38 2.28 8.45 3.15 7.58 5.66 5.04 8.62 3.5 12 3.5 14.13 3.5 16.09 4.11 17.88 5.2L21.31 1.77C21.7 1.38 22.34 1.38 22.73 1.77ZM20.85 7.58C21.72 8.45 22.47 9.38 23.11 10.31 23.49 10.87 23.75 11.31 23.89 11.58 24.04 11.84 24.04 12.16 23.89 12.42L23.78 12.63 23.63 12.88C23.5 13.11 23.32 13.38 23.11 13.69 22.47 14.62 21.72 15.55 20.85 16.42 18.34 18.96 15.38 20.5 12 20.5 10.64 20.5 9.35 20.25 8.13 19.79L9.63 18.28C10.4 18.5 11.19 18.61 12 18.61 14.75 18.61 17.22 17.32 19.4 15.13 20.17 14.35 20.85 13.51 21.43 12.67 21.53 12.52 21.62 12.38 21.71 12.25L21.86 12 21.83 11.95C21.75 11.82 21.66 11.69 21.57 11.55L21.43 11.33C20.85 10.49 20.17 9.65 19.4 8.87L19.22 8.7 20.59 7.32 20.85 7.58ZM12 5.39C9.25 5.39 6.78 6.68 4.6 8.87 3.83 9.65 3.15 10.49 2.57 11.33 2.47 11.48 2.38 11.62 2.29 11.75L2.14 12 2.17 12.05C2.25 12.18 2.34 12.31 2.43 12.45L2.57 12.67C3.15 13.51 3.83 14.35 4.6 15.13 5.18 15.71 5.78 16.23 6.4 16.68L8.18 14.9C7.44 14.12 7 13.11 7 12 7 9.51 9.24 7.5 12 7.5 13.04 7.5 14.01 7.79 14.81 8.28L16.48 6.6C15.08 5.82 13.59 5.39 12 5.39ZM12 9.3C10.34 9.3 9 10.51 9 12 9 12.57 9.2 13.11 9.54 13.54L13.45 9.64C13.02 9.42 12.53 9.3 12 9.3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEyeOpen: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.01 2C12.56 2 13.01 2.45 13.01 3L13.01 5.05C14.87 5.22 16.58 5.86 18.17 6.88L20.31 5.29C20.56 5.03 20.93 4.93 21.28 5.02 21.63 5.11 21.9 5.38 21.99 5.73 22.08 6.08 21.98 6.46 21.72 6.71L19.93 8.21C20.25 8.48 20.55 8.77 20.85 9.08 21.72 9.95 22.47 10.88 23.11 11.81 23.49 12.37 23.75 12.81 23.89 13.08 24.04 13.34 24.04 13.66 23.89 13.92L23.78 14.13C23.63 14.39 23.4 14.76 23.11 15.19 22.47 16.12 21.72 17.05 20.85 17.92 18.34 20.46 15.38 22 12 22 8.62 22 5.66 20.46 3.15 17.92 2.28 17.05 1.53 16.12 0.89 15.19 0.51 14.63 0.25 14.19 0.11 13.92-0.04 13.66-0.04 13.34 0.11 13.08L0.22 12.87C0.37 12.61 0.6 12.24 0.89 11.81 1.53 10.88 2.28 9.95 3.15 9.08 3.45 8.77 3.75 8.48 4.07 8.21L2.31 6.71C1.93 6.31 1.93 5.69 2.32 5.31 2.7 4.92 3.33 4.91 3.72 5.29L5.83 6.88C7.42 5.86 9.15 5.21 11.01 5.04L11.01 3C11.01 2.45 11.46 2 12.01 2ZM12 6.89C9.25 6.89 6.78 8.18 4.6 10.37 3.83 11.15 3.15 11.99 2.57 12.83 2.47 12.98 2.38 13.12 2.29 13.25L2.14 13.5 2.17 13.55C2.25 13.68 2.34 13.81 2.43 13.95L2.57 14.17C3.15 15.01 3.83 15.85 4.6 16.63 6.78 18.82 9.25 20.11 12 20.11 14.75 20.11 17.22 18.82 19.4 16.63 20.17 15.85 20.85 15.01 21.43 14.17 21.53 14.02 21.62 13.88 21.71 13.75L21.86 13.5 21.83 13.45C21.75 13.32 21.66 13.19 21.57 13.05L21.43 12.83C20.85 11.99 20.17 11.15 19.4 10.37 17.22 8.18 14.75 6.89 12 6.89ZM12 9C14.76 9 17 11.01 17 13.5 17 15.99 14.76 18 12 18 9.24 18 7 15.99 7 13.5 7 11.01 9.24 9 12 9ZM12 10.8C10.34 10.8 9 12.01 9 13.5 9 14.99 10.34 16.2 12 16.2 13.66 16.2 15 14.99 15 13.5 15 12.01 13.66 10.8 12 10.8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaEyeShow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.01 3.55C14.87 3.72 16.58 4.36 18.17 5.38L19.93 6.71C20.25 6.98 20.55 7.27 20.85 7.58 21.72 8.45 22.47 9.38 23.11 10.31 23.49 10.87 23.75 11.31 23.89 11.58 24.04 11.84 24.04 12.16 23.89 12.42L23.78 12.63C23.63 12.89 23.4 13.26 23.11 13.69 22.47 14.62 21.72 15.55 20.85 16.42 18.34 18.96 15.38 20.5 12 20.5 8.62 20.5 5.66 18.96 3.15 16.42 2.28 15.55 1.53 14.62 0.89 13.69 0.51 13.13 0.25 12.69 0.11 12.42-0.04 12.16-0.04 11.84 0.11 11.58L0.22 11.37C0.37 11.11 0.6 10.74 0.89 10.31 1.53 9.38 2.28 8.45 3.15 7.58 3.45 7.27 3.75 6.98 4.07 6.71L5.83 5.38C7.42 4.36 9.15 3.71 11.01 3.54L13.01 3.55ZM12 5.39C9.25 5.39 6.78 6.68 4.6 8.87 3.83 9.65 3.15 10.49 2.57 11.33 2.47 11.48 2.38 11.62 2.29 11.75L2.14 12 2.17 12.05C2.25 12.18 2.34 12.31 2.43 12.45L2.57 12.67C3.15 13.51 3.83 14.35 4.6 15.13 6.78 17.32 9.25 18.61 12 18.61 14.75 18.61 17.22 17.32 19.4 15.13 20.17 14.35 20.85 13.51 21.43 12.67 21.53 12.52 21.62 12.38 21.71 12.25L21.86 12 21.83 11.95C21.75 11.82 21.66 11.69 21.57 11.55L21.43 11.33C20.85 10.49 20.17 9.65 19.4 8.87 17.22 6.68 14.75 5.39 12 5.39ZM12 7.5C14.76 7.5 17 9.51 17 12 17 14.49 14.76 16.5 12 16.5 9.24 16.5 7 14.49 7 12 7 9.51 9.24 7.5 12 7.5ZM12 9.3C10.34 9.3 9 10.51 9 12 9 13.49 10.34 14.7 12 14.7 13.66 14.7 15 13.49 15 12 15 10.51 13.66 9.3 12 9.3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFavorites: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.12 1.77C11.38 1.22 12.03 0.98 12.58 1.24 12.81 1.35 13 1.53 13.11 1.77L15.92 7.75 22.18 8.7C22.74 8.79 23.14 9.28 23.12 9.84L23.11 9.96C23.07 10.19 22.97 10.4 22.8 10.56L18.24 15.24 19.32 21.86C19.41 22.42 19.06 22.95 18.53 23.09L18.41 23.12C18.16 23.16 17.92 23.12 17.7 23L12.11 19.91 6.53 23C6.03 23.27 5.42 23.12 5.1 22.67L5.04 22.57C4.92 22.35 4.87 22.1 4.91 21.86L5.99 15.24 1.42 10.56C1.03 10.16 1.01 9.53 1.36 9.1L1.44 9C1.61 8.84 1.82 8.74 2.05 8.7L8.31 7.75 11.12 1.77ZM12.11 4.35L9.92 9.03C9.76 9.36 9.45 9.6 9.09 9.65L4.08 10.42 7.74 14.17C7.95 14.39 8.06 14.68 8.05 14.99L8.04 15.11 7.18 20.35 11.58 17.92C11.87 17.76 12.22 17.74 12.52 17.86L12.65 17.92 17.04 20.35 16.19 15.11C16.14 14.81 16.22 14.51 16.4 14.27L16.49 14.17 20.15 10.42 15.14 9.65C14.82 9.6 14.55 9.42 14.38 9.15L14.31 9.03 12.11 4.35Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFileCsv: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM12 18C12.55 18 13 18.45 13 19 13 19.55 12.55 20 12 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L12 18ZM7 2.63L4.63 5 7 5 7 2.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFileCsvLabel: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63ZM11.91 16C12.73 16.01 13.52 16.31 14.15 16.84 14.57 17.19 14.62 17.82 14.26 18.25 13.93 18.64 13.37 18.71 12.96 18.44L12.85 18.36C12.58 18.13 12.24 18 11.89 18 11.5 18 11.32 18.14 11.29 18.46L11.29 18.56C11.29 18.61 11.28 18.61 11.31 18.63L11.35 18.65C11.46 18.73 11.62 18.79 11.92 18.89L12.28 19C13.95 19.49 14.71 20.01 14.71 21.44 14.71 23.15 13.53 24 11.88 24 11.06 23.99 10.27 23.69 9.64 23.16 9.22 22.81 9.17 22.18 9.52 21.75 9.85 21.37 10.41 21.29 10.83 21.56L10.93 21.64C11.2 21.87 11.55 22 11.89 22 12.54 22 12.71 21.87 12.71 21.44 12.71 21.28 12.61 21.2 12.02 21.01L11.66 20.9C10 20.41 9.29 19.94 9.29 18.56 9.29 17.05 10.38 16 11.91 16ZM20.93 16.63C21.13 16.12 21.71 15.87 22.22 16.07 22.74 16.27 22.99 16.85 22.79 17.37L20.43 23.37C20.1 24.21 18.9 24.21 18.57 23.37L16.21 17.37C16.01 16.85 16.26 16.27 16.78 16.07 17.29 15.87 17.87 16.12 18.07 16.63L19.5 20.27 20.93 16.63ZM4.93 16C5.67 16 6.4 16.23 7 16.65 7.46 16.97 7.56 17.59 7.25 18.05 6.95 18.46 6.4 18.59 5.96 18.36L5.85 18.29C5.58 18.1 5.26 18 4.93 18 3.96 18 3.14 18.88 3.14 20 3.14 21.12 3.96 22 4.93 22 5.21 22 5.48 21.93 5.71 21.8L5.85 21.71C6.31 21.39 6.93 21.5 7.25 21.95 7.56 22.41 7.46 23.03 7 23.35 6.4 23.77 5.67 24 4.93 24 2.82 24 1.14 22.2 1.14 20 1.14 17.8 2.82 16 4.93 16Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFilePdf: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM14.5 13C16.43 13 18 14.57 18 16.5 18 18.43 16.43 20 14.5 20 12.57 20 11 18.43 11 16.5 11 14.57 12.57 13 14.5 13ZM14.5 15C13.67 15 13 15.67 13 16.5 13 17.33 13.67 18 14.5 18 15.33 18 16 17.33 16 16.5 16 15.67 15.33 15 14.5 15ZM7 2.63L4.63 5 7 5 7 2.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFilePdfLabel: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.78 16C5.55 16 7 17.4 7 19.14 7 20.89 5.55 22.29 3.78 22.29L3 22.29 3 23C3 23.51 2.61 23.94 2.12 23.99L2 24C1.45 24 1 23.55 1 23L1 17C1 16.45 1.45 16 2 16L3.78 16ZM3 20.29L3.78 20.29C4.46 20.29 5 19.77 5 19.14 5 18.52 4.46 18 3.78 18L3 18 3 20.29ZM11.82 16C14.12 16 16 17.78 16 20 16 22.22 14.12 24 11.82 24L10 24C9.45 24 9 23.55 9 23L9 17C9 16.45 9.45 16 10 16L11.82 16ZM11 22L11.82 22C13.04 22 14 21.09 14 20 14 18.91 13.04 18 11.82 18L11 18 11 22ZM22 16C22.55 16 23 16.45 23 17 23 17.55 22.55 18 22 18L20 18 20 23C20 23.51 19.61 23.94 19.12 23.99L19 24C18.45 24 18 23.55 18 23L18 17C18 16.45 18.45 16 19 16L22 16ZM4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63Z M21 19C21.55 19 22 19.45 22 20 22 20.55 21.55 21 21 21L19 21C18.45 21 18 20.55 18 20 18 19.45 18.45 19 19 19L21 19Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFileXls: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 0C21.1 0 22 0.9 22 2L22 22C22 23.1 21.1 24 20 24L4 24 3.85 23.99C2.82 23.92 2 23.05 2 22L2 4.59 6.58 0 20 0ZM20 2L9 2 9 7 4 7 4 22 20 22 20 2ZM16 14C16.55 14 17 14.45 17 15L17 19C17 19.55 16.55 20 16 20L8 20 7.88 19.99C7.39 19.94 7 19.51 7 19L7 15 7.01 14.88C7.06 14.39 7.49 14 8 14L16 14ZM11 16L9 16 9 18 11 18 11 16ZM15 16L13 16 13 18 15 18 15 16ZM7 2.63L4.63 5 7 5 7 2.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFileXlsLabel: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 0C2.9 0 2 0.9 2 2L2 13C2 13.55 2.45 14 3 14 3.55 14 4 13.55 4 13L4 2 15 2 15 6C15 6.51 15.39 6.94 15.88 6.99L16 7 20 7 20 13C20 13.55 20.45 14 21 14 21.55 14 22 13.55 22 13L22 4.59 17.41 0 4 0ZM17 2.63L19.37 5 17 5 17 2.63ZM11 16C11.55 16 12 16.45 12 17L12 22 15 22C15.51 22 15.94 22.39 15.99 22.88L16 23C16 23.55 15.55 24 15 24L11 24C10.45 24 10 23.55 10 23L10 17C10 16.45 10.45 16 11 16ZM19.19 16C20.01 16.01 20.8 16.31 21.43 16.84 21.85 17.19 21.91 17.82 21.55 18.25 21.22 18.63 20.66 18.71 20.24 18.44L20.14 18.36C19.87 18.13 19.52 18 19.18 18 18.79 18 18.61 18.14 18.58 18.46L18.57 18.56C18.57 18.62 18.56 18.61 18.63 18.65 18.75 18.73 18.9 18.79 19.21 18.89L19.57 19C21.24 19.49 22 20.01 22 21.44 22 23.15 20.81 24 19.17 24 18.34 23.99 17.55 23.69 16.93 23.16 16.5 22.81 16.45 22.18 16.81 21.75 17.14 21.37 17.7 21.29 18.12 21.56L18.22 21.64C18.49 21.87 18.83 22 19.18 22 19.78 22 19.97 21.89 20 21.52L20 21.44C20 21.28 19.9 21.2 19.31 21.01L18.95 20.9C17.29 20.41 16.57 19.94 16.57 18.56 16.57 17.05 17.66 16 19.19 16ZM7.87 16.19C8.32 16.51 8.42 17.13 8.1 17.58L6.37 20 8.1 22.42C8.42 22.87 8.32 23.49 7.87 23.81 7.42 24.13 6.79 24.03 6.47 23.58L5.14 21.72 3.81 23.58C3.49 24.03 2.87 24.13 2.42 23.81 1.97 23.49 1.87 22.87 2.19 22.42L3.91 20 2.19 17.58C1.87 17.13 1.97 16.51 2.42 16.19 2.87 15.87 3.49 15.97 3.81 16.42L5.14 18.28 6.47 16.42C6.79 15.97 7.42 15.87 7.87 16.19Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFilter: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 0L16 11 16 23 9 18 9 11 1 0 23 0ZM19 2L5 2 11 10 11 17 14 19 14 10 19 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFoodDrink: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C12.51 2 12.94 2.39 12.99 2.88L13 3 13 7C13 9.42 11.28 11.44 9 11.9L9 12 9 21C9 21.55 8.55 22 8 22 7.45 22 7 21.55 7 21L7 12 7 11.9C4.72 11.44 3 9.42 3 7L3 3C3 2.45 3.45 2 4 2 4.51 2 4.94 2.39 4.99 2.88L5 3 5 7C5 8.66 6.34 10 8 10 9.66 10 11 8.66 11 7L11 3C11 2.45 11.45 2 12 2ZM8 2C8.55 2 9 2.45 9 3L9 7C9 7.55 8.55 8 8 8 7.45 8 7 7.55 7 7L7 3C7 2.45 7.45 2 8 2ZM21 21C21 21.55 20.55 22 20 22 19.45 22 19 21.55 19 21L19 13C16.79 13 15 11.21 15 9L15 6C15 3.79 16.79 2 19 2L21 2 21 21ZM19 4L18.85 4.01C17.82 4.08 17 4.95 17 6L17 9C17 10.1 17.9 11 19 11L19 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaGameRoom: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 18C19.55 18 20 18.45 20 19 20 19.51 19.61 19.94 19.12 19.99L19 20 5 20C4.45 20 4 19.55 4 19 4 18.45 4.45 18 5 18L19 18ZM19 4C21.76 4 24 6.24 24 9L24 12C24 14.76 21.76 17 19 17L5 17C2.24 17 0 14.76 0 12L0 9C0 6.24 2.24 4 5 4L19 4ZM8 6L5 6C3.34 6 2 7.34 2 9L2 12C2 13.66 3.34 15 5 15L8 15 8 6ZM15 6L10 6 10 15 15 15 15 6ZM19 6L17 6 17 15 19 15C20.66 15 22 13.66 22 12L22 9C22 7.34 20.66 6 19 6ZM3.6 8L7.16 8 6.39 13.15 4.41 12.85 4.84 10 3.6 10 3.6 8ZM10.6 8L14.16 8 13.39 13.15 11.41 12.85 11.84 10 10.6 10 10.6 8ZM17.6 8L21.16 8 20.39 13.15 18.41 12.85 18.84 10 17.6 10 17.6 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHairdryer: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.33 2C7.57 2 7.81 2.01 8.04 2.04L23 3.5 23 12.5 13 13.48 13 19.5C13 21.43 11.43 23 9.5 23 7.57 23 6 21.43 6 19.5L6 13.87C3.16 13.3 1 10.92 1 8.06L1 7.94C1 4.65 3.86 2 7.33 2ZM11 19.5L11 13.67 8 13.97 8 19.5C8 20.33 8.67 21 9.5 21 10.33 21 11 20.33 11 19.5ZM7.33 4C4.93 4 3 5.79 3 7.94L3 8.06C3 10.21 4.93 12 7.33 12 7.5 12 7.67 11.99 7.84 11.97L21 10.69 21 5.31 7.84 4.03C7.76 4.02 7.67 4.01 7.59 4.01L7.33 4ZM7 5C8.66 5 10 6.34 10 8 10 9.66 8.66 11 7 11 5.34 11 4 9.66 4 8 4 6.34 5.34 5 7 5ZM7 7C6.45 7 6 7.45 6 8 6 8.55 6.45 9 7 9 7.55 9 8 8.55 8 8 8 7.49 7.61 7.06 7.12 7.01L7 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHamburger: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 5L18 5C18.55 5 19 5.45 19 6 19 6.55 18.55 7 18 7L3 7C2.45 7 2 6.55 2 6 2 5.45 2.45 5 3 5ZM3 11L21 11C21.55 11 22 11.45 22 12 22 12.55 21.55 13 21 13L3 13C2.45 13 2 12.55 2 12 2 11.45 2.45 11 3 11ZM3 17L13 17C13.55 17 14 17.45 14 18 14 18.55 13.55 19 13 19L3 19C2.45 19 2 18.55 2 18 2 17.45 2.45 17 3 17Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHandicapped: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 2C16 3.1 15.11 4 14 4 12.9 4 12 3.1 12 2 12 0.9 12.9 0 14 0 15.11 0 16 0.9 16 2ZM12 5C12.29 5 12.57 5.12 12.76 5.34 12.95 5.56 13.03 5.85 13 6.13L12.97 6.24 11.29 14 18.01 14C18.39 14 18.75 14.22 18.91 14.58L18.95 14.68 20.95 20.68C21.12 21.19 20.87 21.73 20.37 21.93 19.88 22.12 19.33 21.9 19.1 21.42L19.06 21.32 17.28 16 10 16C9.72 16 9.44 15.88 9.25 15.66 9.06 15.44 8.98 15.15 9.01 14.87L9.03 14.76 10.72 7 9.67 7C9.5 7 9.33 7.04 9.18 7.13L9.07 7.2 5.6 9.8C5.18 10.12 4.58 10.06 4.24 9.65 3.9 9.25 3.93 8.65 4.31 8.28L4.4 8.2 7.87 5.6C8.33 5.25 8.88 5.05 9.46 5.01L9.67 5 12 5ZM6.87 11.66C6.62 11.58 6.34 11.61 6.11 11.74 3.86 12.98 2.65 15.52 3.1 18.06 3.55 20.59 5.57 22.55 8.11 22.93 10.66 23.31 13.16 22.03 14.34 19.75 14.52 19.43 14.5 19.04 14.31 18.73 14.12 18.42 13.77 18.24 13.41 18.26 13.04 18.29 12.72 18.5 12.56 18.83 11.78 20.35 10.11 21.21 8.41 20.95 6.72 20.7 5.37 19.39 5.07 17.7 4.77 16.02 5.57 14.32 7.08 13.49 7.31 13.37 7.48 13.15 7.56 12.9 7.63 12.64 7.6 12.37 7.47 12.13 7.34 11.9 7.13 11.73 6.87 11.66Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHazardous: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.2 15C20.47 15.48 20.31 16.09 19.83 16.37L14 19.73 17.29 21.63C17.77 21.91 17.94 22.52 17.66 23 17.38 23.48 16.77 23.64 16.29 23.37L12 20.89 7.71 23.37C7.23 23.64 6.62 23.48 6.34 23 6.06 22.52 6.23 21.91 6.71 21.63L10 19.73 4.17 16.37C3.69 16.09 3.53 15.48 3.8 15 4.08 14.52 4.69 14.36 5.17 14.63L12 18.58 18.83 14.63C19.31 14.36 19.92 14.52 20.2 15ZM12 0C15.87 0 19 3.09 19 6.9 19 8.92 18.11 10.81 16.57 12.12L16.5 12.18 16.5 13C16.5 14.6 15.25 15.9 13.68 15.99L13.5 16 11 16C9.34 16 8 14.66 8 13L8 12.56 7.96 12.53C6.18 11.29 5.09 9.32 5.01 7.17L5 6.9C5 3.09 8.13 0 12 0ZM12 2C9.21 2 7 4.22 7 6.9 7 8.56 7.85 10.09 9.26 11L9.54 11.18C9.83 11.36 10 11.68 10 12.02L10 13C10 13.51 10.39 13.94 10.88 13.99L11 14 13.5 14C14.05 14 14.5 13.55 14.5 13L14.5 11.7C14.5 11.39 14.64 11.1 14.88 10.91L15.12 10.73C16.31 9.79 17 8.4 17 6.9 17 4.22 14.79 2 12 2ZM10 6C10.55 6 11 6.45 11 7 11 7.55 10.55 8 10 8 9.45 8 9 7.55 9 7 9 6.45 9.45 6 10 6ZM14 6C14.55 6 15 6.45 15 7 15 7.55 14.55 8 14 8 13.45 8 13 7.55 13 7 13 6.45 13.45 6 14 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHelp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C14.87 0 17.5 1.01 19.56 2.68L19.61 2.64 21.02 4.05 21 4.07C22.87 6.18 24 8.96 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM8.33 16.74L5.48 19.59C7.23 21.09 9.51 22 12 22 14.4 22 16.61 21.15 18.33 19.74L15.48 16.89C14.5 17.59 13.3 18 12 18 10.62 18 9.34 17.53 8.33 16.74ZM19.59 5.49L16.74 8.33C17.53 9.34 18 10.62 18 12 18 13.3 17.59 14.5 16.89 15.48L19.74 18.33C21.15 16.61 22 14.4 22 12 22 9.51 21.09 7.24 19.59 5.49ZM2 12C2 14.31 2.79 16.44 4.1 18.14L6.97 15.27C6.36 14.33 6 13.21 6 12 6 10.7 6.41 9.5 7.11 8.52L4.26 5.67C2.85 7.39 2 9.6 2 12ZM12 8C9.79 8 8 9.79 8 12 8 14.21 9.79 16 12 16 14.21 16 16 14.21 16 12 16 9.79 14.21 8 12 8ZM12 2C9.6 2 7.39 2.85 5.67 4.26L8.52 7.11C9.5 6.41 10.7 6 12 6 13.21 6 14.33 6.36 15.27 6.97L18.14 4.1C16.44 2.79 14.31 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHistory: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1.61C23.74 4.92 25.71 12.26 22.39 18 19.08 23.74 11.74 25.71 6 22.39 5.52 22.12 5.36 21.5 5.63 21.03 5.91 20.55 6.52 20.38 7 20.66 11.78 23.42 17.9 21.78 20.66 17 23.42 12.22 21.78 6.1 17 3.34 12.22 0.58 6.1 2.22 3.34 7L5 7C5.55 7 6 7.45 6 8 6 8.55 5.55 9 5 9L1 9C0.45 9 0 8.55 0 8L0 4C0 3.45 0.45 3 1 3 1.55 3 2 3.45 2 4L2 5.37C5.47 0.12 12.48-1.58 18 1.61ZM12 5C12.55 5 13 5.45 13 6L13 13.59 15.71 16.29C16.07 16.65 16.1 17.22 15.79 17.61L15.71 17.71C15.32 18.1 14.68 18.1 14.29 17.71L11.29 14.71C11.11 14.52 11 14.27 11 14L11 6C11 5.45 11.45 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHotel: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14.91 1.05C14.97 1.18 15 1.32 15 1.46L15 8.6 22.55 13.63C22.83 13.82 23 14.13 23 14.46L23 23C23 23.55 22.55 24 22 24L2 24C1.45 24 1 23.55 1 23L1 6.17 13.59 0.54C14.1 0.32 14.69 0.55 14.91 1.05ZM13 3L3 7.47 3 22 13 22 13 3ZM15 11L15 22 21 22 21 15 15 11ZM10 17C10.55 17 11 17.45 11 18 11 18.55 10.55 19 10 19L6 19C5.45 19 5 18.55 5 18 5 17.45 5.45 17 6 17L10 17ZM10 13C10.55 13 11 13.45 11 14 11 14.55 10.55 15 10 15L6 15C5.45 15 5 14.55 5 14 5 13.45 5.45 13 6 13L10 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHotelBed: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 11C22.66 11 24 12.34 24 14L24 24 22 24 22 19 2 19 2 24 0 24 0 14C0 12.34 1.34 11 3 11L3 4C3 2.34 4.34 1 6 1L18 1ZM21 13L3 13C2.45 13 2 13.45 2 14L2 17 22 17 22 14C22 13.45 21.55 13 21 13ZM18 3L6 3C5.45 3 5 3.45 5 4L5 11 7 11 7 10C7 8.34 8.34 7 10 7L12 7C13.66 7 15 8.34 15 10L15 11 19 11 19 4C19 3.45 18.55 3 18 3ZM12 9L10 9C9.45 9 9 9.45 9 10L9 11 13 11 13 10C13 9.45 12.55 9 12 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHumanHappy: MediumIcon = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C22.63 0 28 5.37 28 12 28 18.63 22.63 24 16 24 9.37 24 4 18.63 4 12 4 5.37 9.37 0 16 0ZM16 2C10.48 2 6 6.48 6 12 6 17.52 10.48 22 16 22 21.52 22 26 17.52 26 12 26 6.48 21.52 2 16 2ZM21.75 15.34C22.12 15.75 22.08 16.39 21.66 16.75 18.25 19.75 13.75 19.75 10.34 16.75 9.92 16.39 9.88 15.75 10.25 15.34 10.61 14.92 11.25 14.88 11.66 15.25 14.31 17.58 17.69 17.58 20.34 15.25 20.75 14.88 21.39 14.92 21.75 15.34ZM20.56 8.44C20.99 8.87 21.12 9.52 20.88 10.08 20.65 10.64 20.1 11 19.49 11 18.67 11 18 10.33 18 9.51 18 8.9 18.36 8.35 18.92 8.12 19.48 7.88 20.13 8.01 20.56 8.44ZM13.56 8.44C13.99 8.87 14.12 9.52 13.88 10.08 13.65 10.64 13.1 11 12.49 11 11.67 11 11 10.33 11 9.51 11 8.9 11.36 8.35 11.92 8.12 12.48 7.88 13.13 8.01 13.56 8.44Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaHumanSad: MediumIcon = {
  icon: [
    32,
    24,
    [],
    "",
    "M16 0C22.63 0 28 5.37 28 12 28 18.63 22.63 24 16 24 9.37 24 4 18.63 4 12 4 5.37 9.37 0 16 0ZM16 2C10.48 2 6 6.48 6 12 6 17.52 10.48 22 16 22 21.52 22 26 17.52 26 12 26 6.48 21.52 2 16 2ZM10.34 16.25C13.75 13.25 18.25 13.25 21.66 16.25 22.08 16.61 22.12 17.25 21.75 17.66 21.39 18.08 20.75 18.12 20.34 17.75 17.69 15.42 14.31 15.42 11.66 17.75 11.25 18.12 10.61 18.08 10.25 17.66 9.88 17.25 9.92 16.61 10.34 16.25ZM20.56 8.44C20.99 8.87 21.12 9.52 20.88 10.08 20.65 10.64 20.1 11 19.49 11 18.67 11 18 10.33 18 9.51 18 8.9 18.36 8.35 18.92 8.12 19.48 7.88 20.13 8.01 20.56 8.44ZM13.56 8.44C13.99 8.87 14.12 9.52 13.88 10.08 13.65 10.64 13.1 11 12.49 11 11.67 11 11 10.33 11 9.51 11 8.9 11.36 8.35 11.92 8.12 12.48 7.88 13.13 8.01 13.56 8.44Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaInfoCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 11C12.55 11 13 11.39 13 11.88L13 18.13C13 18.61 12.55 19 12 19 11.45 19 11 18.61 11 18.13L11 11.88C11 11.39 11.45 11 12 11ZM12 5C12.55 5 13 5.39 13 5.88L13 7.13C13 7.61 12.55 8 12 8 11.45 8 11 7.61 11 7.13L11 5.88C11 5.39 11.45 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaInfoCircleFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.5C18.35 0.5 23.5 5.65 23.5 12 23.5 18.35 18.35 23.5 12 23.5 5.65 23.5 0.5 18.35 0.5 12 0.5 5.65 5.65 0.5 12 0.5ZM12 10C11.48 10 11.05 10.3 11 10.69L11 10.75 11 16.25C11 16.66 11.45 17 12 17 12.52 17 12.95 16.7 13 16.31L13 16.25 13 10.75C13 10.34 12.55 10 12 10ZM12 7C11.45 7 11 7.45 11 8 11 8.55 11.45 9 12 9 12.55 9 13 8.55 13 8 13 7.45 12.55 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaInfoMegaphone: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M24 0.01L24 22.2 20.54 19.63 19.84 19.11C18.04 17.79 17.43 17.4 16.71 17.09 15.99 16.77 15.23 16.63 13.87 16.59L13.5 16.58 13.5 20.76C13.5 22.49 12.14 23.9 10.43 23.99L10.25 24C8.46 24 7 22.55 7 20.76L7 20.01 6.79 19.99C3.11 19.6 0 16.59 0 13 0 9.3 3.08 6.25 6.87 6L8.89 6 9.33 5.96C14.55 5.4 18.29 4.25 20.53 2.6L24 0.01ZM9 20.76C9 21.45 9.56 22 10.25 22 10.94 22 11.5 21.45 11.5 20.76L11.5 15.31C11.5 14.9 11.84 14.57 12.25 14.57L13.25 14.57 13.28 14.57 13.6 14.58 14.22 14.6C17.28 14.73 18.23 15.44 21.73 18.02L22 18.22 22 4 21.73 4.2C19.06 6.17 14.82 7.44 9 8L9 20.76ZM7 8C4.26 8.18 2 10.36 2 13 2 15.57 4.37 17.72 7 18L7 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaInfoSpeech: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 17C23 18.66 21.66 20 20 20L5.96 20 2.58 22.38C2.12 22.7 1.5 22.59 1.18 22.14 1.06 21.97 1 21.77 1 21.56L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 20 5.42 18 20 18C20.55 18 21 17.55 21 17L21 6C21 5.45 20.55 5 20 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaInfoSpeechAlert: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 17C23 18.66 21.66 20 20 20L5.96 20 2.58 22.38C2.12 22.7 1.5 22.59 1.18 22.14 1.06 21.97 1 21.77 1 21.56L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 20 5.42 18 20 18C20.55 18 21 17.55 21 17L21 6C21 5.45 20.55 5 20 5ZM12 13C12.83 13 13.5 13.67 13.5 14.5 13.5 15.33 12.83 16 12 16 11.17 16 10.5 15.33 10.5 14.5 10.5 13.67 11.17 13 12 13ZM12 7C12.55 7 13 7.42 13 7.94L13 11.06C13 11.58 12.55 12 12 12 11.45 12 11 11.58 11 11.06L11 7.94C11 7.42 11.45 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaIntermodal: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 16C14.21 16 16 17.79 16 20 16 22.21 14.21 24 12 24 9.79 24 8 22.21 8 20 8 17.79 9.79 16 12 16ZM12 18C10.9 18 10 18.9 10 20 10 21.1 10.9 22 12 22 13.1 22 14 21.1 14 20 14 18.9 13.1 18 12 18ZM12 7C12.55 7 13 7.45 13 8L13 13C13 13.55 12.55 14 12 14 11.45 14 11 13.55 11 13L11 8C11 7.45 11.45 7 12 7ZM4 0C6.21 0 8 1.79 8 4 8 6.21 6.21 8 4 8 1.79 8 0 6.21 0 4 0 1.79 1.79 0 4 0ZM20 0C22.21 0 24 1.79 24 4 24 6.21 22.21 8 20 8 17.79 8 16 6.21 16 4 16 1.79 17.79 0 20 0ZM4 2C2.9 2 2 2.9 2 4 2 5.1 2.9 6 4 6 5.1 6 6 5.1 6 4 6 2.9 5.1 2 4 2ZM20 2C18.9 2 18 2.9 18 4 18 5.1 18.9 6 20 6 21.1 6 22 5.1 22 4 22 2.9 21.1 2 20 2ZM17 3C17.55 3 18 3.45 18 4 18 4.55 17.55 5 17 5L7 5C6.45 5 6 4.55 6 4 6 3.45 6.45 3 7 3L17 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaKeyboard: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C12.55 0 13 0.45 13 1L13 5 21 5C22.66 5 24 6.34 24 8L24 17C24 18.66 22.66 20 21 20L3 20C1.34 20 0 18.66 0 17L0 8C0 6.34 1.34 5 3 5L11 5 11 1C11 0.45 11.45 0 12 0ZM21 7L3 7C2.45 7 2 7.45 2 8L2 17C2 17.55 2.45 18 3 18L21 18C21.55 18 22 17.55 22 17L22 8C22 7.45 21.55 7 21 7ZM16.5 14C16.78 14 17 14.22 17 14.5L17 15.5C17 15.78 16.78 16 16.5 16L15.5 16C15.22 16 15 15.78 15 15.5L15 14.5C15 14.22 15.22 14 15.5 14L16.5 14ZM13.5 14C13.78 14 14 14.22 14 14.5L14 15.5C14 15.78 13.78 16 13.5 16L12.5 16C12.22 16 12 15.78 12 15.5L12 14.5C12 14.22 12.22 14 12.5 14L13.5 14ZM19.5 14C19.78 14 20 14.22 20 14.5L20 15.5C20 15.78 19.78 16 19.5 16L18.5 16C18.22 16 18 15.78 18 15.5L18 14.5C18 14.22 18.22 14 18.5 14L19.5 14ZM16.5 11C16.78 11 17 11.22 17 11.5L17 12.5C17 12.78 16.78 13 16.5 13L15.5 13C15.22 13 15 12.78 15 12.5L15 11.5C15 11.22 15.22 11 15.5 11L16.5 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaKeycard: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C19.21 0 21 1.79 21 4L21 20C21 22.21 19.21 24 17 24L7 24C4.79 24 3 22.21 3 20L3 4C3 1.79 4.79 0 7 0L17 0ZM17 2L7 2C5.9 2 5 2.9 5 4L5 20C5 21.1 5.9 22 7 22L17 22C18.1 22 19 21.1 19 20L19 4C19 2.9 18.1 2 17 2ZM12 6C13.66 6 15 7.34 15 9 15 10.31 14.16 11.43 12.99 11.83 13 11.89 13 11.94 13 12L13 13 14 13C14.55 13 15 13.45 15 14 15 14.55 14.55 15 14 15L13 15 13 16 14 16C14.55 16 15 16.45 15 17 15 17.55 14.55 18 14 18L12 18C11.45 18 11 17.55 11 17L11 12C11 11.94 11 11.89 11.01 11.83 9.84 11.43 9 10.31 9 9 9 7.34 10.34 6 12 6ZM12 8C11.45 8 11 8.45 11 9 11 9.55 11.45 10 12 10 12.55 10 13 9.55 13 9 13 8.49 12.61 8.06 12.12 8.01L12 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaKeycardPin: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C19.21 0 21 1.79 21 4L21 20C21 22.21 19.21 24 17 24L7 24C4.79 24 3 22.21 3 20L3 4C3 1.79 4.79 0 7 0L17 0ZM17 2L7 2C5.9 2 5 2.9 5 4L5 20C5 21.1 5.9 22 7 22L17 22C18.1 22 19 21.1 19 20L19 4C19 2.9 18.1 2 17 2ZM12 8C13.66 8 15 9.34 15 11 15 12.31 14.16 13.43 12.99 13.83 13 13.89 13 13.94 13 14L13 15 14 15C14.55 15 15 15.45 15 16 15 16.55 14.55 17 14 17L13 17 13 18 14 18C14.55 18 15 18.45 15 19 15 19.55 14.55 20 14 20L12 20C11.45 20 11 19.55 11 19L11 14C11 13.94 11 13.89 11.01 13.83 9.84 13.43 9 12.31 9 11 9 9.34 10.34 8 12 8ZM12 10C11.45 10 11 10.45 11 11 11 11.55 11.45 12 12 12 12.55 12 13 11.55 13 11 13 10.49 12.61 10.06 12.12 10.01L12 10ZM12.22 4.17C12.32 4.22 12.4 4.3 12.45 4.39L13.14 5.78C13.26 6.02 13.16 6.32 12.91 6.45 12.85 6.48 12.77 6.5 12.69 6.5L11.31 6.5C11.03 6.5 10.81 6.28 10.81 6 10.81 5.92 10.83 5.85 10.86 5.78L11.55 4.39C11.68 4.15 11.98 4.05 12.22 4.17Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaKeycardWifi: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.5 0C19.43 0 21 1.57 21 3.5L21 20.5C21 22.43 19.43 24 17.5 24L6.5 24C4.57 24 3 22.43 3 20.5L3 3.5C3 1.57 4.57 0 6.5 0L17.5 0ZM17.5 2L6.5 2C5.67 2 5 2.67 5 3.5L5 20.5C5 21.33 5.67 22 6.5 22L17.5 22C18.33 22 19 21.33 19 20.5L19 3.5C19 2.67 18.33 2 17.5 2ZM12.01 16C12.56 16 13.01 16.45 13.01 17 13.01 17.51 12.62 17.94 12.13 17.99L12 18C11.45 18 11 17.55 11 17 11 16.49 11.39 16.06 11.88 16.01L12.01 16ZM14.74 13.91C15.11 14.32 15.08 14.95 14.67 15.32 14.27 15.7 13.63 15.67 13.26 15.26 12.55 14.49 11.45 14.49 10.74 15.26 10.37 15.67 9.73 15.7 9.33 15.32 8.92 14.95 8.89 14.32 9.26 13.91 10.76 12.27 13.24 12.27 14.74 13.91ZM12 9.59C13.78 9.59 15.49 10.36 16.74 11.72 17.11 12.13 17.08 12.76 16.67 13.14 16.27 13.51 15.63 13.48 15.26 13.07 14.39 12.12 13.22 11.59 12 11.59 10.78 11.59 9.61 12.12 8.74 13.07 8.37 13.48 7.73 13.51 7.33 13.14 6.92 12.76 6.89 12.13 7.26 11.72 8.51 10.36 10.22 9.59 12 9.59ZM12.22 4.17C12.32 4.22 12.4 4.3 12.45 4.39L13.14 5.78C13.26 6.02 13.16 6.32 12.91 6.45 12.85 6.48 12.77 6.5 12.69 6.5L11.31 6.5C11.03 6.5 10.81 6.28 10.81 6 10.81 5.92 10.83 5.85 10.86 5.78L11.55 4.39C11.68 4.15 11.98 4.05 12.22 4.17Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaKidsRoom: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 8C12.1 7.36 12.56 6.6 12.94 5.85L13.2 5.32C13.43 4.88 13.7 4.46 14.01 4.08 15.27 2.54 16.53 1.58 17.41 1.11 17.82 0.9 18.32 0.99 18.62 1.33L22.75 5.94C22.91 6.12 23 6.36 23 6.6L23 9.31C23 9.99 22.33 10.48 21.69 10.26L18.3 9.15 18.25 9.25C18.08 9.58 17.95 9.94 17.85 10.33L17.78 10.63C17.53 11.75 17.54 12.98 17.71 14.14L17.75 14.41C17.78 14.58 17.8 14.7 17.82 14.77 17.97 15.4 17.49 16 16.85 16L16.32 16 18.42 20C18.83 19.85 19.23 19.69 19.61 19.51 20.3 19.19 20.87 18.86 21.33 18.52L21.53 18.37C21.59 18.33 21.64 18.29 21.69 18.25L21.82 18.13C22.21 17.74 22.84 17.74 23.23 18.13 23.62 18.53 23.62 19.16 23.23 19.55 22.76 20.02 21.84 20.69 20.45 21.33 18.18 22.38 15.37 23 12 23 8.63 23 5.82 22.38 3.55 21.33 2.16 20.69 1.24 20.02 0.77 19.55 0.38 19.16 0.38 18.53 0.77 18.13 1.13 17.77 1.69 17.75 2.09 18.05L2.31 18.25C2.4 18.32 2.52 18.42 2.67 18.52 3.13 18.86 3.7 19.19 4.39 19.51 4.77 19.69 5.17 19.85 5.58 20L7.68 16 6.55 16C6.19 16 5.85 15.81 5.68 15.5L5.53 15.23C5.33 14.84 5.08 14.27 4.83 13.58 4.42 12.42 4.14 11.22 4.04 10L3 10C2.45 10 2 9.55 2 9 2 8.45 2.45 8 3 8L12 8ZM14.16 16L9.84 16C9.83 16.14 9.8 16.28 9.73 16.41L7.55 20.55C8.88 20.84 10.36 21 12 21 13.64 21 15.12 20.84 16.45 20.55L14.27 16.41C14.2 16.28 14.17 16.14 14.16 16ZM21 6.99L17.7 3.3 17.52 3.44C16.85 3.94 16.19 4.58 15.56 5.34 15.34 5.61 15.14 5.92 14.98 6.24 14.66 6.85 14.45 7.52 14.33 8.19 14.26 8.59 14.24 8.89 14.24 9.04 14.24 9.59 13.79 10.04 13.24 10.04L6.05 10.04 6.09 10.34C6.18 11.06 6.35 11.78 6.57 12.48L6.71 12.9C6.83 13.23 6.96 13.54 7.08 13.82L7.16 14 15.68 14 15.63 13.59C15.55 12.61 15.57 11.61 15.74 10.62L15.82 10.2C16.05 9.13 16.46 8.17 17.08 7.35 17.34 7.01 17.79 6.88 18.19 7.01L21 7.93 21 6.99Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLanguage: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM16.98 13L7.02 13C7.28 18.05 9.41 22 12 22 14.59 22 16.72 18.05 16.98 13ZM21.95 13L18.98 13C18.85 15.99 18.12 18.71 16.94 20.7 19.6 19.18 21.5 16.48 21.91 13.32L21.95 13ZM5.02 13L2.05 13C2.38 16.3 4.31 19.13 7.06 20.7 5.94 18.81 5.23 16.27 5.05 13.47L5.02 13ZM7.06 3.3L6.88 3.41C4.23 4.99 2.37 7.77 2.05 11L5.02 11C5.15 8.01 5.88 5.29 7.06 3.3ZM12 2C9.41 2 7.28 5.95 7.02 11L16.98 11C16.73 6.05 14.68 2.16 12.16 2L12 2ZM16.94 3.3L17.03 3.46C18.16 5.43 18.85 8.09 18.98 11L21.95 11C21.62 7.7 19.69 4.87 16.94 3.3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 19.16C12.55 19.16 13 19.6 13 20.16V22.16C13 22.71 12.55 23.16 12 23.16 11.45 23.16 11 22.71 11 22.16V20.16C11 19.6 11.45 19.16 12 19.16ZM5.53 17.06C5.92 16.67 6.55 16.67 6.94 17.06 7.33 17.45 7.33 18.08 6.94 18.47L5.53 19.89C5.13 20.28 4.5 20.28 4.11 19.89 3.72 19.5 3.72 18.87 4.11 18.47L5.53 17.06ZM17.06 17.06C17.45 16.67 18.08 16.67 18.47 17.06L19.89 18.47C20.28 18.87 20.28 19.5 19.89 19.89 19.5 20.28 18.87 20.28 18.47 19.89L17.06 18.47C16.67 18.08 16.67 17.45 17.06 17.06ZM12 6C15.31 6 18 8.69 18 12 18 15.31 15.31 18 12 18 8.69 18 6 15.31 6 12 6 8.69 8.69 6 12 6ZM12 8C9.79 8 8 9.79 8 12 8 14.21 9.79 16 12 16 14.21 16 16 14.21 16 12 16 9.79 14.21 8 12 8ZM3.84 11C4.4 11 4.84 11.45 4.84 12 4.84 12.55 4.4 13 3.84 13H1.84C1.29 13 0.84 12.55 0.84 12 0.84 11.45 1.29 11 1.84 11H3.84ZM22.16 11C22.71 11 23.16 11.45 23.16 12 23.16 12.55 22.71 13 22.16 13H20.16C19.6 13 19.16 12.55 19.16 12 19.16 11.45 19.6 11 20.16 11H22.16ZM4.11 4.11C4.5 3.72 5.13 3.72 5.53 4.11L6.94 5.53C7.33 5.92 7.33 6.55 6.94 6.94 6.55 7.33 5.92 7.33 5.53 6.94L4.11 5.53C3.72 5.13 3.72 4.5 4.11 4.11ZM18.47 4.11C18.87 3.72 19.5 3.72 19.89 4.11 20.28 4.5 20.28 5.13 19.89 5.53L18.47 6.94C18.08 7.33 17.45 7.33 17.06 6.94 16.67 6.55 16.67 5.92 17.06 5.53L18.47 4.11ZM12 0.84C12.55 0.84 13 1.29 13 1.84V3.84C13 4.4 12.55 4.84 12 4.84 11.45 4.84 11 4.4 11 3.84V1.84C11 1.29 11.45 0.84 12 0.84Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLightbulb: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 13.06C19 14.95 18.26 16.71 16.94 18.03 16.01 18.92 15.5 21.06 15.5 22.26L15.5 22.56C15.5 23.41 14.85 24.06 14 24.06L10 24.06C9.15 24.06 8.5 23.41 8.5 22.56L8.5 22.46C8.5 21.18 7.95 18.92 6.99 17.92 5.68 16.6 4.94 14.77 5 12.89 5.06 9.22 8.02 6.18 11.7 6.01 15.72 5.83 19 9.03 19 13.06ZM12.01 8L11.79 8.01C9.17 8.13 7.04 10.31 7 12.94 6.96 14.28 7.48 15.57 8.42 16.52 9.59 17.74 10.32 20.26 10.47 21.86L10.49 22.06 13.5 22.06 13.51 21.97C13.58 20.42 14.23 17.95 15.33 16.81L15.54 16.6C16.48 15.67 17 14.41 17 13.06 17 10.31 14.89 8.11 12.22 8.01L12.01 8ZM22.27 3.23C22.66 3.62 22.66 4.26 22.27 4.65L20.15 6.77C19.76 7.16 19.12 7.16 18.73 6.77 18.34 6.38 18.34 5.74 18.73 5.35L20.85 3.23C21.24 2.84 21.88 2.84 22.27 3.23ZM3.15 3.23L5.27 5.35C5.66 5.74 5.66 6.38 5.27 6.77 4.88 7.16 4.24 7.16 3.85 6.77L1.73 4.65C1.34 4.26 1.34 3.62 1.73 3.23 2.12 2.84 2.76 2.84 3.15 3.23ZM12 0C12.55 0 13 0.45 13 1L13 3C13 3.55 12.55 4 12 4 11.45 4 11 3.55 11 3L11 1C11 0.45 11.45 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLighthouse: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.79 1.89L15.34 2.67C16.36 3.18 17 4.22 17 5.35L17 8C17.55 8 18 8.45 18 9 18 9.5 17.64 9.91 17.16 9.99L18.85 21 19 21C19.55 21 20 21.45 20 22 20 22.55 19.55 23 19 23L5 23C4.45 23 4 22.55 4 22 4 21.45 4.45 21 5 21L5.14 21 6.84 9.99C6.36 9.91 6 9.5 6 9 6 8.45 6.45 8 7 8L7 4.74C7 3.98 7.43 3.29 8.11 2.95L10.21 1.89C11.34 1.33 12.66 1.33 13.79 1.89ZM15.15 10L8.86 10 7.17 21 16.83 21 15.15 10ZM19.77 6.13L23.23 8.13C23.71 8.41 23.87 9.02 23.6 9.5 23.32 9.98 22.71 10.14 22.23 9.87L18.77 7.87C18.29 7.59 18.13 6.98 18.4 6.5 18.68 6.02 19.29 5.86 19.77 6.13ZM5.6 6.5C5.87 6.98 5.71 7.59 5.23 7.87L1.77 9.87C1.29 10.14 0.68 9.98 0.4 9.5 0.13 9.02 0.29 8.41 0.77 8.13L4.23 6.13C4.71 5.86 5.32 6.02 5.6 6.5ZM10.89 3.74L9.44 4.7C9.17 4.89 9 5.2 9 5.53L8.99 8 15 8 15 5.54C15 5.2 14.83 4.89 14.55 4.7L13.11 3.74C12.44 3.29 11.56 3.29 10.89 3.74ZM23.6 0.5C23.87 0.98 23.71 1.59 23.23 1.87L19.77 3.87C19.29 4.14 18.68 3.98 18.4 3.5 18.13 3.02 18.29 2.41 18.77 2.13L22.23 0.13C22.71-0.14 23.32 0.02 23.6 0.5ZM1.77 0.13L5.23 2.13C5.71 2.41 5.87 3.02 5.6 3.5 5.32 3.98 4.71 4.14 4.23 3.87L0.77 1.87C0.29 1.59 0.13 0.98 0.4 0.5 0.68 0.02 1.29-0.14 1.77 0.13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLightning: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.75 0C16.39 0 16.86 0.59 16.73 1.22L15 9 19 9C19.77 9 20.24 9.82 19.88 10.47L19.82 10.57 10.82 23.57C10.23 24.42 8.9 23.92 9.01 22.89L10.06 13 5.26 13C4.66 13 4.2 12.47 4.27 11.89L4.29 11.78 6.83 0.78C6.93 0.32 7.33 0 7.8 0L15.75 0ZM14.5 2L8.6 2 6.52 11 11.17 11C11.72 11 12.16 11.45 12.17 11.99L12.16 12.11 11.41 19.21 17.09 11 13.75 11C13.15 11 12.7 10.48 12.75 9.9L12.77 9.78 14.5 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLineDotted: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 11C4.55 11 5 11.45 5 12 5 12.55 4.55 13 4 13 3.45 13 3 12.55 3 12 3 11.45 3.45 11 4 11ZM12 11C12.55 11 13 11.45 13 12 13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11ZM20 11C20.55 11 21 11.45 21 12 21 12.55 20.55 13 20 13 19.45 13 19 12.55 19 12 19 11.45 19.45 11 20 11ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLineSlash: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 5.07C16.48 5.35 16.64 5.96 16.37 6.44L9.37 18.56C9.09 19.04 8.48 19.2 8 18.93 7.52 18.65 7.36 18.04 7.63 17.56L14.63 5.44C14.91 4.96 15.52 4.8 16 5.07Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLineStraight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 11H20A1 1 0 0 1 21 12V12A1 1 0 0 1 20 13H4A1 1 0 0 1 3 12V12A1 1 0 0 1 4 11z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLink: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.67 10.03C9.11 10.47 9.11 11.18 8.67 11.62L6.02 14.27C4.99 15.29 4.99 16.96 6.02 17.98 7.04 19.01 8.71 19.01 9.73 17.98L12.38 15.33C12.82 14.89 13.53 14.89 13.97 15.33 14.41 15.77 14.41 16.48 13.97 16.92L11.32 19.57C9.42 21.48 6.33 21.48 4.43 19.57 2.52 17.67 2.52 14.58 4.43 12.68L7.08 10.03C7.52 9.59 8.23 9.59 8.67 10.03ZM19.57 4.43C21.48 6.33 21.48 9.42 19.57 11.32L16.92 13.97C16.48 14.41 15.77 14.41 15.33 13.97 14.89 13.53 14.89 12.82 15.33 12.38L17.98 9.73C19.01 8.71 19.01 7.04 17.98 6.02 16.96 4.99 15.29 4.99 14.27 6.02L11.62 8.67C11.18 9.11 10.47 9.11 10.03 8.67 9.59 8.23 9.59 7.52 10.03 7.08L12.68 4.43C14.58 2.52 17.67 2.52 19.57 4.43Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLoadingPref: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 17C23 18.66 21.66 20 20 20L5.96 20 2.58 22.38C2.12 22.7 1.5 22.59 1.18 22.14 1.06 21.97 1 21.77 1 21.56L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 20 5.42 18 20 18C20.55 18 21 17.55 21 17L21 6C21 5.45 20.55 5 20 5ZM17.18 7.32C17.61 7.76 17.61 8.46 17.18 8.89L11.51 14.68C11.28 14.91 10.97 15.02 10.66 15 10.36 15.02 10.04 14.91 9.81 14.68L7.32 12.11C6.89 11.68 6.89 10.97 7.32 10.54 7.74 10.11 8.43 10.11 8.86 10.54L10.66 12.41 15.64 7.32C16.07 6.89 16.76 6.89 17.18 7.32Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLockClosed: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C14.76 0 17 2.24 17 5L17 9 18 9C19.66 9 21 10.34 21 12L21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 12C3 10.34 4.34 9 6 9L7 9 7 5C7 2.31 9.12 0.12 11.78 0L12 0ZM18 11L6 11C5.45 11 5 11.45 5 12L5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 12C19 11.45 18.55 11 18 11ZM12 2C10.34 2 9 3.34 9 5L9 9 15 9 15 5C15 3.34 13.66 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLockOpen: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.5 0C14.91 0 16.88 1.9 17 4.29L17 4.53C17 5.08 16.55 5.53 16 5.53 15.49 5.53 15.06 5.14 15.01 4.65L15 4.5C15 3.12 13.88 2 12.5 2 11.12 2 10 3.12 10 4.5L10 9 18 9C19.66 9 21 10.34 21 12L21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 12C3 10.34 4.34 9 6 9L8 9 8 4.5C8 2.01 10.01 0 12.5 0ZM18 11L6 11C5.45 11 5 11.45 5 12L5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 12C19 11.45 18.55 11 18 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLogoPlus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.99 11L16 11C15.45 11 15 11.45 15 12L15.01 12.12C15.06 12.61 15.49 13 16 13L21.99 13 21.99 12 21.99 11ZM16 9L21.27 9C21.2 8.93 21.14 8.86 21.07 8.8 20.58 8.38 19.95 8.16 19.3 8.18L17.45 8.18C17 8.13 16.57 7.92 16.27 7.58 15.96 7.24 15.79 6.8 15.79 6.34L15.79 4.65C15.79 3.94 15.51 3.27 15.01 2.77 14.52 2.28 13.84 2 13.14 2L10.8 2C10.1 2 9.42 2.28 8.93 2.77 8.43 3.27 8.15 3.94 8.15 4.65L8.15 6.35C8.15 6.8 7.98 7.23 7.69 7.57 7.39 7.91 6.98 8.12 6.53 8.18L4.65 8.18C3.95 8.18 3.28 8.46 2.78 8.95 2.28 9.45 2 10.12 2 10.83L2 13.17C2 13.88 2.28 14.55 2.78 15.05 3.28 15.54 3.95 15.82 4.65 15.82L6.53 15.82C6.98 15.88 7.39 16.09 7.69 16.43 7.98 16.77 8.15 17.2 8.15 17.65L8.15 19.35C8.15 20.06 8.43 20.73 8.93 21.23 9.42 21.72 10.1 22 10.8 22L13.14 22C13.84 22 14.52 21.72 15.01 21.23 15.51 20.73 15.79 20.06 15.79 19.35L15.79 17.66C15.79 17.2 15.96 16.76 16.27 16.42 16.57 16.08 17 15.87 17.45 15.82L19.3 15.82C19.95 15.84 20.58 15.62 21.07 15.2 21.14 15.14 21.2 15.07 21.27 15L16 15C14.34 15 13 13.66 13 12 13 10.34 14.34 9 16 9ZM22 13L23.25 13 23.28 13C23.67 13.03 23.96 13.37 23.93 13.76 23.79 14.91 23.24 15.96 22.37 16.71L22.18 16.87C21.41 17.46 20.46 17.8 19.49 17.82L17.79 17.82 17.79 19.35C17.79 20.59 17.3 21.77 16.43 22.64 15.55 23.51 14.37 24 13.14 24L10.8 24C9.57 24 8.39 23.51 7.51 22.64L7.34 22.46C6.58 21.61 6.15 20.51 6.15 19.36L6.15 17.82 4.65 17.82C3.42 17.82 2.24 17.33 1.37 16.46 0.49 15.59 0 14.41 0 13.18L0 10.82C0 9.59 0.49 8.41 1.37 7.54 2.24 6.67 3.42 6.18 4.65 6.18L6.15 6.18 6.15 4.64C6.15 3.49 6.58 2.39 7.34 1.54L7.51 1.36C8.39 0.49 9.57 0 10.8 0L13.14 0C14.37 0 15.55 0.49 16.43 1.36 17.3 2.23 17.79 3.41 17.79 4.65L17.79 6.18 19.24 6.18C20.31 6.15 21.34 6.49 22.18 7.13L22.37 7.29C23.24 8.04 23.79 9.09 23.93 10.24 23.96 10.63 23.67 10.97 23.28 11L23.22 11 22 11 22 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaLogout: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 2C14.66 2 16 3.34 16 5L16 8C16 8.55 15.55 9 15 9 14.45 9 14 8.55 14 8L14 5C14 4.45 13.55 4 13 4L4 4C3.45 4 3 4.45 3 5L3 19C3 19.55 3.45 20 4 20L13 20C13.55 20 14 19.55 14 19L14 16C14 15.45 14.45 15 15 15 15.55 15 16 15.45 16 16L16 19C16 20.66 14.66 22 13 22L4 22C2.34 22 1 20.66 1 19L1 5C1 3.34 2.34 2 4 2L13 2ZM20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMail: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM2 18C2 18.55 2.45 19 3 19L21 19C21.55 19 22 18.55 22 18L22 9.19 13.57 14.38C12.61 14.97 11.39 14.97 10.43 14.38L2 9.19 2 18ZM2 6.85L11.48 12.68C11.8 12.88 12.2 12.88 12.52 12.68L22 6.84 22 6C22 5.45 21.55 5 21 5L3 5C2.45 5 2 5.45 2 6L2 6.85Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMapNavigation: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.63 1.07C7.85 0.98 8.09 0.98 8.32 1.05L15.97 4.94 21.63 3.07C21.94 2.95 22.29 2.99 22.56 3.17 22.84 3.36 23 3.67 23 4L23 20C23 20.41 22.75 20.78 22.37 20.93L16.37 22.93C16.15 23.02 15.91 23.02 15.68 22.95L8.03 19.06 2.37 20.93C2.06 21.05 1.71 21.01 1.44 20.83 1.16 20.64 1 20.33 1 20L1 4C1 3.59 1.25 3.22 1.63 3.07L7.63 1.07ZM9 3.39L9 17.28 15 20.61 15 6.72 9 3.39ZM21 5.48L17 6.68 17 20.52 21 19.32 21 5.48ZM7 3.48L3 4.68 3 18.52 7 17.32 7 3.48Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMinus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 11H19A1 1 0 0 1 20 12V12A1 1 0 0 1 19 13H5A1 1 0 0 1 4 12V12A1 1 0 0 1 5 11z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMinusCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17 11C17.55 11 18 11.45 18 12 18 12.55 17.55 13 17 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L17 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMobile: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C18.66 0 20 1.34 20 3L20 21C20 22.66 18.66 24 17 24L7 24C5.34 24 4 22.66 4 21L4 3C4 1.34 5.34 0 7 0L17 0ZM17 2L7 2C6.45 2 6 2.45 6 3L6 21C6 21.55 6.45 22 7 22L17 22C17.55 22 18 21.55 18 21L18 3C18 2.45 17.55 2 17 2ZM12 18C12.55 18 13 18.45 13 19 13 19.55 12.55 20 12 20 11.45 20 11 19.55 11 19 11 18.45 11.45 18 12 18Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMoonFilled: MediumIcon = {
  icon: [
    16,
    16,
    [],
    "",
    "M8.45 1.66C8.47 1.65 8.48 1.65 8.49 1.65 8.5 1.66 8.52 1.68 8.54 1.73 8.62 1.89 8.62 2.13 8.5 2.33 7.36 4.22 6.98 6.53 7.67 8.73 8.37 10.93 9.99 12.55 12 13.35 12.18 13.42 12.31 13.61 12.34 13.78 12.36 13.86 12.34 13.9 12.34 13.91 12.34 13.92 12.33 13.92 12.33 13.92 12.33 13.93 12.31 13.94 12.28 13.95 8.7 15.2 4.99 13.43 3.94 10.08 2.87 6.71 4.86 2.92 8.45 1.66ZM8.49 1.65C8.49 1.65 8.49 1.65 8.49 1.65 8.49 1.65 8.49 1.65 8.49 1.65Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMouse: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.42 0 20 3.58 20 8L20 16C20 20.42 16.42 24 12 24 7.58 24 4 20.42 4 16L4 8C4 3.58 7.58 0 12 0ZM12 2C8.69 2 6 4.69 6 8L6 16C6 19.31 8.69 22 12 22 15.31 22 18 19.31 18 16L18 8C18 4.69 15.31 2 12 2ZM12 4C12.55 4 13 4.45 13 5L13 9C13 9.55 12.55 10 12 10 11.45 10 11 9.55 11 9L11 5C11 4.45 11.45 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMove: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 13L4.27 13 5.53 14.29C5.87 14.65 5.9 15.22 5.61 15.61L5.53 15.71C5.15 16.1 4.55 16.1 4.17 15.71L1.28 12.71C0.91 12.32 0.91 11.68 1.28 11.29L4.17 8.29C4.55 7.9 5.15 7.9 5.53 8.29L5.58 8.36C5.9 8.75 5.88 9.34 5.53 9.71L4.27 11 11 11 11 4.11 9.71 5.38C9.34 5.74 8.75 5.76 8.36 5.44L8.29 5.38C7.9 5 7.9 4.39 8.29 4.01L11.29 1.09C11.68 0.71 12.32 0.71 12.71 1.09L15.71 4.01C16.1 4.39 16.1 5 15.71 5.38 15.32 5.76 14.68 5.76 14.29 5.38L13 4.11 13 11 19.54 11 18.28 9.71C17.93 9.34 17.91 8.75 18.22 8.36L18.28 8.29C18.65 7.9 19.26 7.9 19.63 8.29L22.53 11.29C22.9 11.68 22.9 12.32 22.53 12.71L19.63 15.71C19.26 16.1 18.65 16.1 18.28 15.71 17.91 15.32 17.91 14.68 18.28 14.29L19.54 13 13 13 13 19.51 14.29 18.24C14.65 17.89 15.22 17.86 15.61 18.16L15.71 18.24C16.1 18.61 16.1 19.23 15.71 19.6L12.71 22.52C12.32 22.9 11.68 22.9 11.29 22.52L8.29 19.6C7.9 19.23 7.9 18.61 8.29 18.24L8.36 18.18C8.75 17.86 9.34 17.88 9.71 18.24L11 19.51 11 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMoveIn: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM6 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L6 22 6 2ZM21 2L8 2 8 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM14.53 8.29C14.9 8.68 14.9 9.32 14.53 9.71L13.27 11 18.81 11C19.36 11 19.81 11.45 19.81 12 19.81 12.55 19.36 13 18.81 13L13.27 13 14.53 14.29C14.88 14.66 14.9 15.25 14.58 15.64L14.53 15.71C14.15 16.1 13.55 16.1 13.17 15.71L10.28 12.71C9.91 12.32 9.91 11.68 10.28 11.29L13.17 8.29C13.55 7.9 14.15 7.9 14.53 8.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMoveOut: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM16 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L16 22 16 2ZM21 2L18 2 18 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM10.63 8.29L13.53 11.29C13.9 11.68 13.9 12.32 13.53 12.71L10.63 15.71C10.26 16.1 9.65 16.1 9.28 15.71 8.91 15.32 8.91 14.68 9.28 14.29L10.54 13 5 13C4.45 13 4 12.55 4 12 4 11.45 4.45 11 5 11L10.5 11 10.54 11 9.28 9.71C8.93 9.34 8.91 8.75 9.22 8.36L9.28 8.29C9.65 7.9 10.26 7.9 10.63 8.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMovieTheatre: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.98 4.76C22.99 4.88 23 5.01 23 5.14L23 18.86C23 20.52 21.66 21.86 20 21.86 19.87 21.86 19.75 21.86 19.62 21.84L3.62 19.81C2.12 19.62 1 18.34 1 16.83L1 7.17C1 5.66 2.12 4.38 3.62 4.19L19.62 2.16C21.27 1.95 22.77 3.11 22.98 4.76ZM19.99 4.13L19.87 4.14 3.87 6.17C3.37 6.24 3 6.66 3 7.17L3 16.83C3 17.34 3.37 17.76 3.87 17.83L19.87 19.86C19.92 19.86 19.96 19.86 20 19.86 20.55 19.86 21 19.42 21 18.86L21 5.14C21 5.09 21 5.05 20.99 5.01 20.93 4.54 20.56 4.19 20.1 4.14L19.99 4.13ZM11.5 10.31C11.58 10.31 11.65 10.33 11.72 10.36L14.11 11.55C14.35 11.68 14.45 11.98 14.33 12.22 14.28 12.32 14.2 12.4 14.11 12.45L11.72 13.64C11.48 13.76 11.18 13.66 11.05 13.41 11.02 13.35 11 13.27 11 13.19L11 10.81C11 10.53 11.22 10.31 11.5 10.31Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaOverview: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 24C3.34 24 2 22.66 2 21L2 4C2 1.79 3.79 0 6 0L20 0C21.1 0 22 0.9 22 2L22 19 21.5 19C20.67 19 20 19.67 20 20.5 20 21.33 20.67 22 21.5 22L22 22 22 23C22 23.55 21.55 24 21 24L5 24ZM18.34 19L5.5 19C4.67 19 4 19.67 4 20.5 4 21.33 4.67 22 5.5 22L18.34 22C18.12 21.55 18 21.04 18 20.5 18 19.96 18.12 19.45 18.34 19ZM20 2L6 2C4.9 2 4 2.9 4 4L4 17.34C4.45 17.12 4.96 17 5.5 17L20 17 20 2ZM12 5C12.55 5 13 5.45 13 6 13 6.55 12.55 7 12 7L7 7C6.45 7 6 6.55 6 6 6 5.45 6.45 5 7 5L12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaParking: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.65 0.49L21.63 5.72C22.49 6.27 23 7.23 23 8.25L23 20.98C23 22.65 21.65 24 19.99 24L4.01 24C2.35 24 1 22.65 1 20.98L1 8.25C1 7.23 1.51 6.27 2.37 5.72L10.35 0.49C11.35-0.16 12.65-0.16 13.65 0.49ZM11.45 2.16L3.46 7.4C3.17 7.58 3 7.9 3 8.24L3 20.99C3 21.55 3.45 22 4.01 22L19.99 22C20.55 22 21 21.55 21 20.99L21 8.24C21 7.9 20.83 7.58 20.54 7.4L12.55 2.16C12.22 1.95 11.78 1.95 11.45 2.16ZM13.48 9C15.34 9 16.7 10.34 16.7 12.09 16.7 13.84 15.34 15.22 13.48 15.22L10.99 15.22 10.99 18.52 9 18.52 9 9 13.48 9ZM13.19 10.72L10.99 10.72 10.99 13.49 13.19 13.49C13.97 13.49 14.71 13.1 14.71 12.11 14.71 11.13 13.97 10.72 13.19 10.72Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPen: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.42 1.12C21.62 1.44 22.56 2.38 22.88 3.58 23.2 4.78 22.86 6.06 21.98 6.94L7.38 21.54C7.25 21.67 7.09 21.76 6.92 21.8L2.24 22.97C1.51 23.15 0.85 22.49 1.03 21.76L2.2 17.08C2.24 16.91 2.33 16.75 2.46 16.62L17.06 2.02C17.94 1.14 19.22 0.8 20.42 1.12ZM15.75 6.16L4.07 17.84 3.37 20.63 6.16 19.93 17.84 8.25 15.75 6.16ZM18.48 3.43L17.16 4.75 19.25 6.84 20.57 5.52C20.9 5.19 21.06 4.71 20.98 4.25L20.95 4.1C20.81 3.59 20.42 3.19 19.91 3.05 19.4 2.91 18.85 3.06 18.48 3.43Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPercentage: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.63 3.87C21.02 4.26 21.02 4.89 20.63 5.28L5.08 20.84C4.68 21.23 4.05 21.23 3.66 20.84 3.27 20.45 3.27 19.82 3.66 19.42L19.22 3.87C19.61 3.48 20.24 3.48 20.63 3.87ZM18 14C19.66 14 21 15.34 21 17 21 18.66 19.66 20 18 20 16.34 20 15 18.66 15 17 15 15.34 16.34 14 18 14ZM18 16C17.45 16 17 16.45 17 17 17 17.55 17.45 18 18 18 18.55 18 19 17.55 19 17 19 16.49 18.61 16.06 18.12 16.01L18 16ZM7 4C8.66 4 10 5.34 10 7 10 8.66 8.66 10 7 10 5.34 10 4 8.66 4 7 4 5.34 5.34 4 7 4ZM7 6C6.45 6 6 6.45 6 7 6 7.55 6.45 8 7 8 7.55 8 8 7.55 8 7 8 6.49 7.61 6.06 7.12 6.01L7 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPerformance: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM19.67 7.75C19.94 8.23 19.78 8.84 19.3 9.12L14.98 11.61C14.99 11.74 15 11.87 15 12 15 13.66 13.66 15 12 15 10.34 15 9 13.66 9 12 9 10.34 10.34 9 12 9 12.8 9 13.53 9.31 14.07 9.83L18.3 7.38C18.78 7.11 19.39 7.27 19.67 7.75ZM12 4C12.55 4 13 4.45 13 5 13 5.55 12.55 6 12 6 8.69 6 6 8.69 6 12 6 12.55 5.55 13 5 13 4.45 13 4 12.55 4 12 4 7.58 7.58 4 12 4ZM12 11C11.45 11 11 11.45 11 12 11 12.55 11.45 13 12 13 12.55 13 13 12.55 13 12 13 11.49 12.61 11.06 12.12 11.01L12 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPets: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.47 1.29L16.47 2.28C16.46 2.29 16.46 2.29 16.45 2.3L13 5.71 12.9 5.79C12.73 5.93 12.51 6 12.29 6L4.46 6 2.73 4.29 2.63 4.21C2.21 3.89 1.61 3.94 1.25 4.34 0.9 4.74 0.92 5.33 1.3 5.71L3.03 7.41 3.03 12.59 1.89 13.71 1.75 13.85C1.27 14.4 1 15.1 1 15.83L1 22 1.01 22.12C1.07 22.64 1.54 23.03 2.07 23 2.61 22.97 3.02 22.53 3.03 22L3.03 15.83 3.03 15.7C3.06 15.48 3.16 15.28 3.32 15.12L4.46 14 4.58 13.87C4.88 13.51 5.05 13.06 5.05 12.59L5.05 8 12.29 8 12.49 7.99C13.22 7.94 13.91 7.64 14.44 7.12L17.25 4.34 20.72 7.08 20.38 7.42 20.29 7.5C20.02 7.71 19.67 7.77 19.35 7.66L18.46 7.37 18.31 7.32C17.28 7.07 16.23 7.64 15.9 8.63L15.24 11.59C15.17 11.89 15.17 12.19 15.24 12.49L15.58 14 7.26 14 7.09 14.01 6.93 14.03C6.4 14.11 5.92 14.41 5.61 14.84 5.3 15.27 5.17 15.81 5.26 16.33L6.08 22.16 6.1 22.28C6.25 22.79 6.78 23.09 7.3 22.98 7.82 22.86 8.16 22.36 8.07 21.84L7.26 16 16.03 16 17.2 22.22 17.23 22.33C17.41 22.83 17.95 23.1 18.46 22.96 18.98 22.81 19.29 22.3 19.18 21.78L17.21 12.05 17.82 9.26 18.71 9.56 18.9 9.61C19.94 9.88 21.05 9.59 21.82 8.83L22.56 8.1 22.66 7.99C23.15 7.39 23.11 6.52 22.56 5.98 22.49 5.92 22.49 5.92 22.43 5.87L18.69 2.92 18.9 2.71 18.99 2.61C19.3 2.21 19.27 1.65 18.9 1.29 18.51 0.9 17.87 0.9 17.47 1.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPhone: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4 1L6.99 1C8.49 0.99 9.78 2.09 9.99 3.59 10.11 4.47 10.32 5.34 10.63 6.18 11.05 7.27 10.78 8.51 9.96 9.35L9.24 10.06 9.31 10.18C10.46 11.94 11.95 13.43 13.71 14.57L13.82 14.65 14.54 13.93C15.33 13.15 16.47 12.87 17.51 13.19L17.71 13.25C18.54 13.57 19.41 13.78 20.31 13.9 21.82 14.11 22.93 15.42 22.89 16.94L22.89 16.92 22.89 19.92C22.89 20.76 22.54 21.57 21.92 22.14 21.29 22.71 20.46 22.99 19.6 22.91 16.37 22.56 13.26 21.46 10.54 19.69 8 18.08 5.85 15.93 4.24 13.39 2.46 10.65 1.36 7.53 1.01 4.27 0.94 3.43 1.22 2.6 1.78 1.98 2.35 1.36 3.15 1 4 1ZM4 3C3.72 3 3.45 3.12 3.26 3.33 3.07 3.53 2.98 3.81 3 4.07 3.31 7.01 4.31 9.83 5.92 12.31 7.38 14.61 9.32 16.55 11.62 18.01 14.09 19.61 16.89 20.61 19.8 20.92 20.08 20.95 20.36 20.86 20.56 20.66 20.77 20.47 20.89 20.21 20.89 19.92L20.89 16.9C20.9 16.39 20.53 15.95 20.04 15.88 19 15.74 17.99 15.49 17.01 15.13 16.64 14.99 16.23 15.08 15.96 15.35L14.69 16.62C14.37 16.94 13.88 17 13.48 16.78 10.82 15.27 8.62 13.06 7.11 10.4 6.89 10.01 6.95 9.52 7.27 9.2L8.54 7.94C8.81 7.66 8.9 7.25 8.76 6.88 8.4 5.9 8.14 4.89 8.01 3.86 7.94 3.36 7.51 2.99 7 3L4 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPhoto: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.6 1C21.03 1 23 2.97 23 5.4L23 18.6C23 21.03 21.03 23 18.6 23L5.4 23C2.97 23 1 21.03 1 18.6L1 5.4C1 2.97 2.97 1 5.4 1L18.6 1ZM18.75 3L5.25 3C4.01 3 3 4.01 3 5.25L3 18.75C3 19.99 4.01 21 5.25 21L18.75 21C19.99 21 21 19.99 21 18.75L21 5.25C21 4.01 19.99 3 18.75 3ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9ZM17.5 5C18.33 5 19 5.67 19 6.5 19 7.33 18.33 8 17.5 8 16.67 8 16 7.33 16 6.5 16 5.67 16.67 5 17.5 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPhotobooth: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 16C3.55 16 4 16.45 4 17L4 18C4 19.13 4.87 20 6 20L7 20C7.55 20 8 20.45 8 21 8 21.55 7.55 22 7 22L6 22C3.8 22 2 20.2 2 18L2 17C2 16.45 2.45 16 3 16ZM21 16C21.55 16 22 16.45 22 17L22 18C22 20.2 20.2 22 18 22L17 22C16.45 22 16 21.55 16 21 16 20.45 16.45 20 17 20L18 20C19.13 20 20 19.13 20 18L20 17C20 16.45 20.45 16 21 16ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9ZM7 2C7.55 2 8 2.45 8 3 8 3.55 7.55 4 7 4L6 4C4.87 4 4 4.87 4 6L4 7C4 7.55 3.55 8 3 8 2.45 8 2 7.55 2 7L2 6C2 3.8 3.8 2 6 2L7 2ZM18 2C20.2 2 22 3.8 22 6L22 7C22 7.55 21.55 8 21 8 20.45 8 20 7.55 20 7L20 6C20 4.87 19.13 4 18 4L17 4C16.45 4 16 3.55 16 3 16 2.45 16.45 2 17 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPin: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C15.31 2 18 4.69 18 8 18 10.97 15.84 13.44 13 13.92L13 13.96 13 21C13 21.55 12.55 22 12 22 11.45 22 11 21.55 11 21L11 14 11 13.92C8.16 13.44 6 10.97 6 8 6 4.69 8.69 2 12 2ZM12 4C9.79 4 8 5.79 8 8 8 10.21 9.79 12 12 12 14.21 12 16 10.21 16 8 16 5.79 14.21 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPlayRoom: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.09 3C19 3 23 6 23 8.21L23 18C23 19.66 21.66 21 20 21L19.14 21C18.12 21 17.17 20.48 16.62 19.61L14.84 17.46C14.66 17.17 14.34 17 14 17L9.6 17C9.26 17 8.94 17.17 8.75 17.46L7.38 19.61C6.83 20.48 5.88 21 4.85 21L4 21C2.34 21 1 19.66 1 18L1 8.21C1 6 5.17 3 12.09 3ZM12.09 5C6.17 5 3 8 3 9L3 18C3 18.55 3.45 19 4 19L4.85 19C5.2 19 5.51 18.83 5.7 18.54L7.07 16.39C7.62 15.52 8.57 15 9.6 15L14 15C15.02 15 15.98 15.52 16.53 16.39L18.3 18.54C18.49 18.83 18.8 19 19.14 19L20 19C20.55 19 21 18.55 21 18L21 9C21 8 18 5 12.09 5ZM8 8C8.55 8 9 8.45 9 9L9 10 10 10C10.55 10 11 10.45 11 11 11 11.55 10.55 12 10 12L9 12 9 13C9 13.55 8.55 14 8 14 7.45 14 7 13.55 7 13L7 12 6 12C5.45 12 5 11.55 5 11 5 10.45 5.45 10 6 10L7 10 7 9C7 8.45 7.45 8 8 8ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11ZM18 9C18.55 9 19 9.45 19 10 19 10.55 18.55 11 18 11 17.45 11 17 10.55 17 10 17 9.45 17.45 9 18 9ZM15 8C15.55 8 16 8.45 16 9 16 9.55 15.55 10 15 10 14.45 10 14 9.55 14 9 14 8.45 14.45 8 15 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPlugin: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 0C15.55 0 16 0.45 16 1L16 4 17 4C18.1 4 19 4.9 19 6L19 11.53 19 11.69C18.9 14.65 16.47 17 13.5 17L13 17 13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 17 10.47 17 10.31 17C7.35 16.9 5 14.47 5 11.5L5 6C5 4.9 5.9 4 7 4L8 4 8 1C8 0.45 8.45 0 9 0 9.55 0 10 0.45 10 1L10 4 14 4 14 1C14 0.45 14.45 0 15 0ZM17 6L7 6 7 11.5C7 13.39 8.5 14.93 10.38 15L10.5 15 13.5 15C15.39 15 16.93 13.5 17 11.62L17 11.5 17 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPluginCheck: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C12.55 0 13 0.45 13 1L13 4 14 4C15.1 4 16 4.9 16 6L16 11.53 16 11.69C15.9 14.65 13.47 17 10.5 17L10 17 10 23C10 23.55 9.55 24 9 24 8.45 24 8 23.55 8 23L8 17 7.47 17 7.31 17C4.35 16.9 2 14.47 2 11.5L2 6C2 4.9 2.9 4 4 4L5 4 5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 4 11 4 11 1C11 0.45 11.45 0 12 0ZM21.54 16.23C21.93 16.62 21.93 17.26 21.54 17.65L17.42 21.77C17.21 21.98 16.92 22.08 16.64 22.06 16.36 22.08 16.07 21.98 15.85 21.77L13.73 19.65C13.34 19.26 13.34 18.62 13.73 18.23 14.12 17.84 14.76 17.84 15.15 18.23L16.64 19.72 20.13 16.23C20.52 15.84 21.15 15.84 21.54 16.23ZM14 6L4 6 4 11.5C4 13.39 5.5 14.93 7.38 15L7.5 15 10.5 15C12.39 15 13.93 13.5 14 11.62L14 11.5 14 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPlus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 4L13 11 20 11C20.55 11 21 11.45 21 12 21 12.55 20.55 13 20 13L13 13 13 20C13 20.55 12.55 21 12 21 11.45 21 11 20.55 11 20L11 13 4 13C3.45 13 3 12.55 3 12 3 11.45 3.45 11 4 11L11 11 11 4C11 3.45 11.45 3 12 3 12.55 3 13 3.45 13 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPlusCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 5.83C12.55 5.83 13 6.28 13 6.83L13 11 17.17 11C17.72 11 18.17 11.45 18.17 12 18.17 12.55 17.72 13 17.17 13L13 13 13 17.17C13 17.72 12.55 18.17 12 18.17 11.45 18.17 11 17.72 11 17.17L11 13 6.83 13C6.28 13 5.83 12.55 5.83 12 5.83 11.45 6.28 11 6.83 11L11 11 11 6.83C11 6.28 11.45 5.83 12 5.83Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPlusSmall: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 8L13 11 16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L13 13 13 16C13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16L11 13 8 13C7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11L11 11 11 8C11 7.45 11.45 7 12 7 12.55 7 13 7.45 13 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaPrint: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C19.1 0 20 0.9 20 2L20 7 21 7C22.66 7 24 8.34 24 10L24 16C24 17.66 22.66 19 21 19L20 19 20 22C20 23.1 19.1 24 18 24L6 24C4.9 24 4 23.1 4 22L4 19 3 19C1.34 19 0 17.66 0 16L0 10C0 8.34 1.34 7 3 7L4 7 4 2C4 0.9 4.9 0 6 0L18 0ZM18 16L6 16 6 22 18 22 18 16ZM21 9L3 9C2.45 9 2 9.45 2 10L2 16C2 16.55 2.45 17 3 17L4 17 4 16C4 14.9 4.9 14 6 14L18 14C19.1 14 20 14.9 20 16L20 17 21 17C21.55 17 22 16.55 22 16L22 10C22 9.45 21.55 9 21 9ZM18 2L6 2 6 7 18 7 18 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaQuestionBubble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 2C21.66 2 23 3.34 23 5L23 17C23 18.66 21.66 20 20 20L6.96 20 1 23.49 1 5C1 3.34 2.34 2 4 2L20 2ZM20 4L4 4C3.45 4 3 4.45 3 5L3 20 6.42 18 20 18C20.55 18 21 17.55 21 17L21 5C21 4.45 20.55 4 20 4ZM12 14C12.55 14 13 14.45 13 15 13 15.55 12.55 16 12 16 11.45 16 11 15.55 11 15 11 14.45 11.45 14 12 14ZM12 6C13.66 6 15 7.34 15 9 15 10.31 14.17 11.42 13 11.83L13 12C13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12L11 11C11 10.49 11.39 10.06 11.88 10.01L12 10C12.55 10 13 9.55 13 9 13 8.45 12.55 8 12 8 11.49 8 11.06 8.39 11.01 8.88L11 9C11 9.55 10.55 10 10 10 9.45 10 9 9.55 9 9 9 7.34 10.34 6 12 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaQuestionCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 17C12.55 17 13 17.45 13 18 13 18.55 12.55 19 12 19 11.45 19 11 18.55 11 18 11 17.45 11.45 17 12 17ZM12 5C14.21 5 16 6.79 16 9 16 10.86 14.73 12.43 13 12.87L13 14C13 14.55 12.55 15 12 15 11.45 15 11 14.55 11 14L11 12C11 11.49 11.39 11.06 11.88 11.01L12 11C13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7 10.9 7 10 7.9 10 9 10 9.55 9.55 10 9 10 8.45 10 8 9.55 8 9 8 6.79 9.79 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaQuestionCircleFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 17C11.45 17 11 17.45 11 18 11 18.55 11.45 19 12 19 12.55 19 13 18.55 13 18 13 17.45 12.55 17 12 17ZM12 5C9.79 5 8 6.79 8 9 8 9.55 8.45 10 9 10 9.55 10 10 9.55 10 9 10 7.9 10.9 7 12 7 13.1 7 14 7.9 14 9 14 10.1 13.1 11 12 11L11.88 11.01C11.39 11.06 11 11.49 11 12L11 14C11 14.55 11.45 15 12 15 12.55 15 13 14.55 13 14L13 12.87C14.73 12.43 16 10.86 16 9 16 6.79 14.21 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRain: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.67 14.93C3.67 19.53 7.4 23.26 12 23.26 16.6 23.26 20.33 19.53 20.33 14.93 20.33 12 18.07 7.83 13.58 2.04L12 0 10.11 2.44C5.82 8.03 3.67 12.07 3.67 14.93ZM18.33 14.93C18.33 18.43 15.5 21.26 12 21.26 8.5 21.26 5.67 18.43 5.67 14.93 5.67 12.71 7.58 9.08 11.41 4.03L12 3.26C16.22 8.71 18.33 12.6 18.33 14.93Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRateThumbDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 3C4.6 3 3.45 4.2 3.15 5.6L2.05 11.5C1.75 12.9 2.75 14.3 4.15 14.6L8.25 15.4 8.25 19.2C8.25 20 8.55 20.7 9.05 21.3 9.45 21.8 10.15 22 10.75 22L11.15 22C11.95 21.9 12.65 21.3 13.05 20.5L16.05 14 19.75 14C20.55 14 21.15 13.4 21.15 12.6L21.15 4.6C21.15 3.8 20.7 3 20 3L6 3ZM11.45 19.8C11.35 20.1 11.15 20.2 10.95 20.2 10.85 20.2 10.65 20.2 10.45 20 10.25 19.8 10.15 19.5 10.15 19.1L10.15 15.4C10.15 14.6 9.55 13.8 8.75 13.6L4.55 12.7C4.05 12.6 3.85 12.2 3.85 11.7L4.95 5.8C5.05 5.4 5.45 5 6.05 5L14.95 5 14.95 12.3 11.45 19.8ZM17 12L17 5 19 5 19 12 17 12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRateThumbUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 22C4.6 22 3.45 20.8 3.15 19.4L2.05 13.5C1.75 12.1 2.75 10.7 4.15 10.4L8.25 9.6 8.25 5.8C8.25 5 8.55 4.3 9.05 3.7 9.45 3.2 10.15 3 10.75 3L11.15 3C11.95 3.1 12.65 3.7 13.05 4.5L16.05 11 19.75 11C20.55 11 21.15 11.6 21.15 12.4L21.15 20.4C21.15 21.2 20.7 22 20 22L6 22ZM11.45 5.2C11.35 4.9 11.15 4.8 10.95 4.8 10.85 4.8 10.65 4.8 10.45 5 10.25 5.2 10.15 5.5 10.15 5.9L10.15 9.6C10.15 10.4 9.55 11.2 8.75 11.4L4.55 12.3C4.05 12.4 3.85 12.8 3.85 13.3L4.95 19.2C5.05 19.6 5.45 20 6.05 20L14.95 20 14.95 12.7 11.45 5.2ZM17 13L17 20 19 20 19 13 17 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRefresh: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C18.63 1 24 6.37 24 13 24 16.64 22.96 19.34 20.88 21L23 21C23.55 21 24 21.45 24 22 24 22.55 23.55 23 23 23L18 23C17.45 23 17 22.55 17 22L17 17C17 16.45 17.45 16 18 16 18.55 16 19 16.45 19 17L19 19.87C20.99 18.69 22 16.45 22 13 22 7.48 17.52 3 12 3 6.48 3 2 7.48 2 13 2 13.55 1.55 14 1 14 0.45 14 0 13.55 0 13 0 6.37 5.37 1 12 1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRegNo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.8 4C23.02 4 24 4.98 24 6.2L24 17.8C24 19.02 23.02 20 21.8 20L2.2 20C0.98 20 0 19.02 0 17.8L0 6.2C0 4.98 0.98 4 2.2 4L21.8 4ZM2.2 6C2.09 6 2 6.09 2 6.2L2 17.8C2 17.91 2.09 18 2.2 18L4 18 4 6 2.2 6ZM18 11C18.55 11 19 11.45 19 12 19 12.55 18.55 13 18 13 17.45 13 17 12.55 17 12 17 11.45 17.45 11 18 11ZM14 11C14.55 11 15 11.45 15 12 15 12.55 14.55 13 14 13 13.45 13 13 12.55 13 12 13 11.45 13.45 11 14 11ZM10 11C10.55 11 11 11.45 11 12 11 12.55 10.55 13 10 13 9.45 13 9 12.55 9 12 9 11.45 9.45 11 10 11ZM6 18L21.8 18C21.91 18 22 17.91 22 17.8L22 6.2C22 6.09 21.91 6 21.8 6L6 6 6 18Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRestrooms: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 0C7.21 0 9 1.79 9 4 9 5.12 8.54 6.13 7.8 6.86 9.13 7.75 10 9.28 10 11L10 18 8 19 8 23C8 23.55 7.55 24 7 24L3 24C2.45 24 2 23.55 2 23L2 19 0 18 0 11C0 9.28 0.87 7.75 2.2 6.86L2.04 6.69C1.39 5.98 1 5.04 1 4 1 1.79 2.79 0 5 0ZM5 8C3.34 8 2 9.34 2 11L2 16.76 4 17.76 4 22 6 22 6 17.76 8 16.76 8 11C8 9.4 6.75 8.1 5.18 8.01L5 8ZM5 2C3.9 2 3 2.9 3 4 3 5.1 3.9 6 5 6 6.1 6 7 5.1 7 4 7 2.9 6.1 2 5 2ZM18 0C20.21 0 22 1.79 22 4 22 5.14 21.52 6.17 20.75 6.9 21.72 7.61 22.41 8.69 22.61 9.95L23.82 17.85C23.91 18.39 23.53 18.9 22.99 18.99 22.94 19 22.89 19 22.83 19L21.78 19C21.32 19 20.92 19.31 20.81 19.76L20 23C20 23.55 19.55 24 19 24L17 24C16.45 24 16 23.55 16 23L15.19 19.76C15.08 19.31 14.68 19 14.22 19L13.17 19C12.61 19 12.17 18.55 12.17 18 12.17 17.95 12.17 17.9 12.18 17.85L13.39 9.95C13.59 8.69 14.28 7.61 15.25 6.9L15.36 7C14.52 6.27 14 5.2 14 4 14 1.79 15.79 0 18 0ZM18 8C16.69 8 15.57 8.96 15.37 10.26L14.33 17 14.4 17.01C15.64 17.08 16.71 17.91 17.08 19.1L17.13 19.27 17.81 22 18.19 22 18.87 19.27C19.19 17.99 20.3 17.08 21.6 17.01L21.67 17 20.63 10.26C20.44 9.02 19.41 8.08 18.17 8.01L18 8ZM18 2C16.9 2 16 2.9 16 4 16 5.1 16.9 6 18 6 19.1 6 20 5.1 20 4 20 2.9 19.1 2 18 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRestroomsGents: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C14.21 0 16 1.79 16 4 16 5.12 15.54 6.13 14.8 6.86 16.13 7.75 17 9.28 17 11V18L15 19V23C15 23.55 14.55 24 14 24H10C9.45 24 9 23.55 9 23V19L7 18V11C7 9.28 7.87 7.75 9.2 6.86L9.04 6.69C8.39 5.98 8 5.04 8 4 8 1.79 9.79 0 12 0ZM12 8C10.34 8 9 9.34 9 11V16.76L11 17.76V22H13V17.76L15 16.76V11C15 9.4 13.75 8.1 12.18 8.01L12 8ZM12 2C10.9 2 10 2.9 10 4 10 5.1 10.9 6 12 6 13.1 6 14 5.1 14 4 14 2.9 13.1 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRestroomsLadies: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.83 0C14.04 0 15.83 1.79 15.83 4 15.83 5.14 15.36 6.17 14.59 6.9 15.56 7.61 16.25 8.69 16.44 9.95L17.66 17.85C17.74 18.39 17.37 18.9 16.82 18.99 16.77 19 16.72 19 16.67 19H15.62C15.16 19 14.76 19.31 14.64 19.76L13.83 23C13.83 23.55 13.39 24 12.83 24H10.83C10.28 24 9.83 23.55 9.83 23L9.02 19.76C8.91 19.31 8.51 19 8.05 19H7C6.45 19 6 18.55 6 18 6 17.95 6 17.9 6.01 17.85L7.23 9.95C7.42 8.69 8.11 7.61 9.08 6.9L9.19 7C8.36 6.27 7.83 5.2 7.83 4 7.83 1.79 9.63 0 11.83 0ZM11.83 8C10.52 8 9.4 8.96 9.2 10.26L8.16 17 8.23 17.01C9.47 17.08 10.54 17.91 10.92 19.1L10.96 19.27 11.65 22H12.02L12.7 19.27C13.02 18 14.14 17.08 15.44 17.01L15.5 17 14.47 10.26C14.27 9.02 13.24 8.08 12 8.01L11.83 8ZM11.83 2C10.73 2 9.83 2.9 9.83 4 9.83 5.1 10.73 6 11.83 6 12.94 6 13.83 5.1 13.83 4 13.83 2.9 12.94 2 11.83 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRobot: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 4C21.76 4 24 6.24 24 9L24 17C24 19.76 21.76 22 19 22L5 22C2.24 22 0 19.76 0 17L0 9C0 6.24 2.24 4 5 4L19 4ZM19 6L5 6C3.34 6 2 7.34 2 9L2 17C2 18.66 3.34 20 5 20L19 20C20.66 20 22 18.66 22 17L22 9C22 7.34 20.66 6 19 6ZM14 17C14.55 17 15 17.45 15 18 15 18.51 14.61 18.94 14.12 18.99L14 19 10 19C9.45 19 9 18.55 9 18 9 17.45 9.45 17 10 17L14 17ZM7 8C8.66 8 10 9.34 10 11 10 12.66 8.66 14 7 14 5.34 14 4 12.66 4 11 4 9.34 5.34 8 7 8ZM17 8C18.66 8 20 9.34 20 11 20 12.66 18.66 14 17 14 15.34 14 14 12.66 14 11 14 9.34 15.34 8 17 8ZM7 10C6.45 10 6 10.45 6 11 6 11.55 6.45 12 7 12 7.55 12 8 11.55 8 11 8 10.49 7.61 10.06 7.12 10.01L7 10ZM17 10C16.45 10 16 10.45 16 11 16 11.55 16.45 12 17 12 17.55 12 18 11.55 18 11 18 10.49 17.61 10.06 17.12 10.01L17 10ZM12 1C13.86 1 15.43 2.27 15.87 4L13.73 4C13.39 3.4 12.74 3 12 3 11.26 3 10.61 3.4 10.27 4L8.13 4C8.57 2.27 10.14 1 12 1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaRunningPerson: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.93 5L13.99 5 14.13 5.01 14.26 5.03 14.39 5.08 14.5 5.14 14.61 5.21 14.71 5.29 14.78 5.38 14.87 5.51 16.45 8.66 19.55 7.11C20.01 6.88 20.56 7.03 20.84 7.45L20.89 7.55C21.14 8.05 20.94 8.65 20.45 8.89L16.45 10.89C15.95 11.14 15.35 10.94 15.11 10.45L14.26 8.75 13.12 12.71 16.71 16.29C16.83 16.41 16.91 16.56 16.96 16.71L16.99 16.84 17.99 22.84C18.08 23.38 17.71 23.9 17.16 23.99 16.62 24.08 16.1 23.71 16.01 23.16L15.07 17.48 11.29 13.71C11.06 13.48 10.96 13.16 11.01 12.84L11.04 12.73 12.59 7.3 9.82 7.86 8.97 11.24C8.85 11.74 8.37 12.06 7.87 11.99L7.76 11.97C7.22 11.84 6.9 11.29 7.03 10.76L8.03 6.76C8.12 6.38 8.43 6.1 8.8 6.02L13.85 5.01 13.93 5ZM11.45 15.11C11.94 15.35 12.14 15.95 11.89 16.45L9.89 20.45C9.76 20.72 9.5 20.92 9.2 20.98L4.2 21.98C3.65 22.09 3.13 21.74 3.02 21.2 2.91 20.65 3.26 20.13 3.8 20.02L8.32 19.11 10.11 15.55C10.35 15.06 10.95 14.86 11.45 15.11ZM16 4C17.1 4 18 3.1 18 2 18 0.9 17.1 0 16 0 14.9 0 14 0.9 14 2 14 3.1 14.9 4 16 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingBus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 22C20 23.1 19.1 24 18 24L16 24C14.9 24 14 23.1 14 22L14 21 10 21 10 22C10 23.1 9.1 24 8 24L6 24C4.9 24 4 23.1 4 22L4 19 4.02 19C3.38 18.17 3 17.13 3 16L3 7 2 7 2 8C2 8.55 1.55 9 1 9 0.45 9 0 8.55 0 8L0 6C0 5.45 0.45 5 1 5L3 5C3 2.24 5.29 0 8 0L16 0C18.71 0 21 2.24 21 5L23 5C23.55 5 24 5.45 24 6L24 8C24 8.55 23.55 9 23 9 22.45 9 22 8.55 22 8L22 7 21 7 21 16C21 17.13 20.62 18.17 19.98 19L20 19 20 22ZM18 20.57C17.45 20.82 16.84 20.97 16.21 21L16 21 16 22 18 22 18 20.57ZM6 20.57L6 22 8 22 8 21C7.29 21 6.62 20.85 6 20.57ZM19 13C16.67 13.67 14.33 14 12 14 9.67 14 7.33 13.67 5 13L5 16C5 17.66 6.38 19 8 19L16 19C17.62 19 19 17.66 19 16L19 13ZM9 15C9.55 15 10 15.45 10 16 10 16.55 9.55 17 9 17 8.45 17 8 16.55 8 16 8 15.45 8.45 15 9 15ZM15 15C15.55 15 16 15.45 16 16 16 16.55 15.55 17 15 17 14.45 17 14 16.55 14 16 14 15.45 14.45 15 15 15ZM16 2L8 2C6.38 2 5 3.34 5 5L5 11C7.33 11.67 9.67 12 12 12 14.33 12 16.67 11.67 19 11L19 5C19 3.34 17.62 2 16 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingCar: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.29 2C19.61 2 20.77 2.89 21.13 4.18L21.8 7.12C22.01 7.04 22.25 7 22.5 7 23.33 7 24 7.45 24 8 24 8.55 23.33 9 22.5 9 22.41 9 22.31 8.99 22.22 8.98L22.29 9.29C23.3 9.78 24 10.81 24 12L24 19.92C24 21.05 23.12 22 22 22L19 22C17.88 22 17 21.05 17 19.92L17 19 7 19 7 19.92C7 21.05 6.12 22 5 22L2 22C0.88 22 0 21.05 0 19.92L0 12C0 10.87 0.63 9.88 1.55 9.37L1.64 8.99 1.5 9C0.72 9 0.08 8.61 0.01 8.1L0 8C0 7.45 0.67 7 1.5 7 1.71 7 1.9 7.03 2.08 7.08L2.74 4.18C2.79 4.02 2.85 3.87 2.91 3.72 3 3.54 3.1 3.38 3.21 3.22 3.33 3.06 3.46 2.91 3.64 2.75L3.82 2.6 4 2.47 4.26 2.32 4.43 2.24 4.6 2.18 4.83 2.1 5.02 2.06 5.17 2.03C5.3 2.01 5.43 2 5.56 2L18.29 2ZM22 18.23L21.89 18.29C20.99 18.74 20.01 18.98 19 19L19 19.92C19 19.98 19.02 20 19 20L22 20C21.98 20 22 19.98 22 19.92L22 18.23ZM2 18.24L2 19.92C2 19.98 2.02 20 2 20L5 20C4.98 20 5 19.98 5 19.92L5 19 4.77 18.99C3.84 18.94 2.94 18.7 2.11 18.29L2 18.24ZM21 11L3 11C2.45 11 2 11.45 2 12L2 15.38C2 15.76 2.21 16.11 2.55 16.28L3 16.5C3.66 16.83 4.38 17 5.12 17L18.88 17C19.62 17 20.34 16.83 21 16.5L21.45 16.28C21.79 16.11 22 15.76 22 15.38L22 12C22 11.45 21.55 11 21 11ZM5 13C5.55 13 6 13.45 6 14 6 14.55 5.55 15 5 15 4.45 15 4 14.55 4 14 4 13.45 4.45 13 5 13ZM19 13C19.55 13 20 13.45 20 14 20 14.55 19.55 15 19 15 18.45 15 18 14.55 18 14 18 13.45 18.45 13 19 13ZM18.28 4L5.58 4 5.49 4 5.43 4.01 5.38 4.02 5.29 4.05 5.21 4.08 5.1 4.14 5.05 4.17 4.96 4.25C4.91 4.29 4.87 4.34 4.83 4.4 4.79 4.45 4.76 4.5 4.73 4.56 4.7 4.61 4.69 4.67 4.67 4.72L3.75 9 20.11 9 19.21 4.72C19.1 4.33 18.78 4.05 18.39 4.01L18.28 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingCargo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.5 1C18.27 1 19.01 1.31 19.56 1.85L22.15 4.44C22.69 4.99 23 5.73 23 6.5L23 20.09C23 21.7 21.7 23 20.09 23L2.91 23C1.36 23 1.02 21.79 1 20.26L1 6.5C1 5.73 1.31 4.99 1.85 4.44L4.44 1.85C4.99 1.31 5.73 1 6.5 1L17.5 1ZM10 13L9.88 12.99C9.39 12.94 9 12.51 9 12L9 9 3 9 3 20.09C3 20.59 3.41 21 3.91 21L20.09 21C20.59 21 21 20.59 21 20.09L21 9 15 9 15 12C15 12.55 14.55 13 14 13L10 13ZM13 9L11 9 11 11 13 11 13 9ZM17.5 3L6.5 3C6.26 3 6.03 3.1 5.86 3.27L3.27 5.86C3.1 6.03 3 6.26 3 6.5L3 7 21 7 21 6.5C21 6.26 20.9 6.03 20.73 5.86L18.14 3.27C17.97 3.1 17.74 3 17.5 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingCrane: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.44 15C20.26 15 21.03 15.41 21.5 16.08L23.56 19.08C24.34 20.22 24.06 21.77 22.93 22.55 22.51 22.84 22.01 23 21.5 23L2.5 23C1.12 23 0 21.88 0 20.5 0 19.99 0.15 19.5 0.44 19.08L2.5 16.08C2.97 15.41 3.74 15 4.56 15L19.44 15ZM19.44 17L4.56 17C4.4 17 4.24 17.08 4.15 17.22L2.09 20.22C2.03 20.3 2 20.4 2 20.5 2 20.78 2.22 21 2.5 21L21.5 21C21.6 21 21.7 20.97 21.79 20.91 22.01 20.75 22.07 20.44 21.91 20.22L19.85 17.22C19.76 17.08 19.6 17 19.44 17ZM11 1C11 0.45 11.45 0 12 0 12.55 0 13 0.45 13 1L13 9.5 13 9.54 15.29 7.28C15.66 6.93 16.25 6.91 16.64 7.22L16.71 7.28C17.1 7.65 17.1 8.26 16.71 8.63L12.71 12.53C12.32 12.9 11.68 12.9 11.29 12.53L7.29 8.63C6.9 8.26 6.9 7.65 7.29 7.28 7.68 6.91 8.32 6.91 8.71 7.28L11 9.54 11 1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingGate: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 2C7.66 2 9 3.34 9 5L9 6 20 6C21.66 6 23 7.34 23 9L23 10C23 11.66 21.66 13 20 13L9 13 9 20C9 21.66 7.66 23 6 23L4 23C2.34 23 1 21.66 1 20L1 5C1 3.34 2.34 2 4 2L6 2ZM6 4L4 4C3.45 4 3 4.45 3 5L3 20C3 20.55 3.45 21 4 21L6 21C6.55 21 7 20.55 7 20L7 5C7 4.45 6.55 4 6 4ZM20 8L9 8 9 11 20 11C20.55 11 21 10.55 21 10L21 9C21 8.45 20.55 8 20 8Z M6 7A1 1 0 0 1 5 8 1 1 0 0 1 4 7 1 1 0 0 1 6 7z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingImportExport: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 11L15 8C15 7.08 16.14 6.65 16.75 7.34L23.75 15.34C24.1 15.74 24.08 16.33 23.71 16.71L16.71 23.71 16.62 23.78C15.99 24.3 15 23.85 15 23L15 20 13 20C12.45 20 12 19.55 12 19 12 18.45 12.45 18 13 18L16 18 16.12 18.01C16.61 18.06 17 18.49 17 19L17 20.59 21.63 15.95 17 10.66 17 12C17 12.55 16.55 13 16 13L9 13 9 16C9 16.88 7.95 17.32 7.33 16.74L7.25 16.66 0.25 8.66C-0.1 8.26-0.08 7.67 0.29 7.29L7.29 0.29C7.92-0.34 9 0.11 9 1L9 4 11 4C11.51 4 11.94 4.39 11.99 4.88L12 5C12 5.55 11.55 6 11 6L8 6C7.45 6 7 5.55 7 5L7 3.41 2.37 8.05 7 13.34 7 12C7 11.49 7.39 11.06 7.88 11.01L8 11 15 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingLocation: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C16.6 0 20.33 3.73 20.33 8.33 20.33 11.2 18.18 15.24 13.89 20.82L12 23.26 10.42 21.23C5.93 15.43 3.67 11.27 3.67 8.33 3.67 3.73 7.4 0 12 0ZM12 2C8.5 2 5.67 4.84 5.67 8.33 5.67 10.67 7.78 14.55 12 20L12.59 19.23C16.42 14.19 18.33 10.55 18.33 8.33 18.33 4.84 15.5 2 12 2ZM12 5C13.66 5 15 6.34 15 8 15 9.66 13.66 11 12 11 10.34 11 9 9.66 9 8 9 6.34 10.34 5 12 5ZM12 7C11.45 7 11 7.45 11 8 11 8.55 11.45 9 12 9 12.55 9 13 8.55 13 8 13 7.49 12.61 7.06 12.12 7.01L12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingNoTicket: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.46 0.47L18.57 0.48C18.72 0.49 18.86 0.53 19 0.61 19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.21 23.3 5.94 23.47 5.65 23.51L5.54 23.53C5.36 23.53 5.17 23.49 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.81 0.67 18.13 0.49 18.46 0.47ZM14.59 4L13.36 6 10 6 10 11.43 8 14.67 8 6 2 6 2 9C3.66 9 5 10.34 5 12 5 13.66 3.66 15 2 15L2 18 5.95 18 4.71 20 1.5 20C0.67 20 0 19.37 0 18.59L0 14 0.01 13.88C0.06 13.39 0.49 13 1 13L2 13C2.55 13 3 12.55 3 12 3 11.45 2.55 11 2 11L1 11 0.88 10.99C0.39 10.94 0 10.51 0 10L0 5.41C0 4.63 0.67 4 1.5 4L14.59 4ZM19.29 4L22.5 4C23.33 4 24 4.63 24 5.41L24 18.59C24 19.37 23.33 20 22.5 20L9.41 20 10.64 18 22 18 22 6 18.05 6 19.29 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingOffpeak: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingOnQuay: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.1 1C15.65 1 16.1 1.45 16.1 2L16.1 4 19.1 4C19.65 4 20.1 4.45 20.1 5L20.1 7 21.1 7C21.65 7 22.1 7.45 22.1 8L22.1 12.39 23.37 12.9C23.86 13.09 24.11 13.63 23.95 14.13L21.16 22 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L1 24C0.45 24 0 23.55 0 23L0 17C0 16.45 0.45 16 1 16 1.55 16 2 16.45 2 17L2 22 5.03 22 2.05 14.15C1.88 13.64 2.14 13.09 2.63 12.9L4.1 12.31 4.1 8C4.1 7.45 4.55 7 5.1 7 5.14 7 5.18 7 5.22 7.01L6.1 7 6.1 5 6.11 4.88C6.16 4.39 6.59 4 7.1 4 7.14 4 7.18 4 7.22 4.01L8.39 4.02 10.1 4.02 10.1 2C10.1 1.49 10.49 1.06 10.98 1.01L11.1 1 15.1 1ZM21.77 14.41L13 10.9 4.25 14.4 7.05 21.68C7.08 21.79 7.1 21.89 7.1 22L19.1 22C19.1 21.9 19.11 21.8 19.15 21.7L21.77 14.41ZM14.22 3L12.1 3 12.1 5C12.1 5.38 11.65 5.88 11.22 5.92L8.1 6 8.1 8C8.1 8.38 7.61 8.96 7.18 9L7.1 9 6.1 9 6.1 11.51 12.63 8.9 12.71 8.87 12.83 8.84 12.91 8.83 13 8.82 13.09 8.83 13.19 8.84 13.3 8.87 13.37 8.9 20.1 11.59 20.1 9 19.1 9C18.66 9 18.14 8.44 18.1 8.07L18.1 8 18.1 6 15.06 5.92C14.62 5.92 14.26 5.63 14.22 5.26L14.22 5.19 14.22 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingOnRoute: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.34 2C4.27 2 5.09 2.62 5.36 3.51L6.08 6 12.93 6C13.82 6 14.62 6.56 14.93 7.44L15.17 8.17C15.66 9.58 16.09 10.67 16.46 11.44L16.61 11.73 16.75 12 23 12C23.67 12 23.79 12.34 23.36 13.01L19.01 18.43 19.23 18.55C19.49 18.68 19.75 18.82 20.05 18.99L21.07 19.59 21.35 19.74C21.59 19.87 21.74 19.94 21.86 19.97L22 19.99 23 20C23.55 20 24 20.45 24 21 24 21.55 23.55 22 23 22L21.98 22 21.89 22C21.73 21.99 21.59 21.98 21.45 21.94L21.3 21.9C20.8 21.78 20.3 21.52 19.62 21.09L18.95 20.66 18.68 20.5 18.44 20.36C17.98 20.14 17.61 20.03 17.27 20L17.18 20C16.73 20.02 16.34 20.19 15.59 20.66L14.92 21.09C13.96 21.7 13.07 21.95 12.24 21.99L12.07 22 11.93 22 11.76 21.99C10.93 21.95 10.03 21.7 9.07 21.09L8.41 20.66C7.71 20.22 7.32 20.05 6.91 20.01L6.8 20 6.75 20C6.4 20.02 6.04 20.13 5.57 20.35 5.42 20.44 5.25 20.54 5.05 20.66L4.38 21.09C3.75 21.49 3.28 21.73 2.82 21.87L2.68 21.9C2.52 21.96 2.37 21.98 2.2 21.99L2 22 1 22C0.45 22 0 21.55 0 21L0 8.1 0 8 0 2 3.34 2ZM12.93 8L2.1 8 2.06 8.01C2.03 8.02 2 8.06 2 8.1L2 20C2.05 19.99 2.09 19.98 2.13 19.98 2.31 19.93 2.57 19.8 3.1 19.49L3.73 19.12C4.12 18.89 4.46 18.7 4.79 18.54 5.5 18.15 6.02 18 6.73 18L6.85 18C7.73 18 8.38 18.24 9.64 18.9L10.34 19.28 10.74 19.49C11.24 19.74 11.59 19.88 11.9 19.95L12 19.97C12.41 19.9 12.88 19.69 13.66 19.28L14.35 18.9C15.44 18.33 16.07 18.07 16.79 18.01L20 14 16 14C15.34 14 14.35 12.02 13.03 8.07 13.01 8.03 12.98 8 12.93 8ZM10 10C10.55 10 11 10.45 11 11 11 11.55 10.55 12 10 12L6 12C5.45 12 5 11.55 5 11 5 10.45 5.45 10 6 10L10 10ZM3.34 4L2 4 2 6 4 6 3.44 4.07C3.42 4.03 3.38 4 3.34 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingOnRouteArrow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.63 0.29L20.53 2.29C20.9 2.68 20.9 3.32 20.53 3.71L18.63 5.71C18.26 6.1 17.65 6.1 17.28 5.71 16.91 5.32 16.91 4.68 17.28 4.29L17.54 4 3 4C2.45 4 2 4.45 2 5L3.34 5C4.27 5 5.09 5.62 5.36 6.51L6.08 9 12.93 9C13.82 9 14.62 9.56 14.93 10.44L15.17 11.17C15.5 12.11 16.02 13.05 16.75 14L23 14C23.67 14 23.79 14.34 23.36 15.01L19.01 20.43 19.23 20.55C19.49 20.68 19.75 20.82 20.05 20.99L21.07 21.59 21.35 21.74 21.56 21.85C21.69 21.92 21.78 21.95 21.86 21.97L22 21.99 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L21.89 24C21.73 23.99 21.59 23.98 21.45 23.94L21.3 23.9C20.8 23.78 20.3 23.52 19.62 23.09L18.95 22.66 18.68 22.5 18.44 22.36C17.98 22.14 17.61 22.03 17.27 22L17.18 22C16.73 22.02 16.34 22.19 15.59 22.66L14.92 23.09C13.96 23.7 13.07 23.95 12.24 23.99L12.07 24 11.93 24 11.76 23.99C10.93 23.95 10.03 23.7 9.07 23.09L8.41 22.66C7.71 22.22 7.32 22.05 6.91 22.01L6.8 22 6.75 22C6.4 22.02 6.04 22.13 5.57 22.35 5.42 22.44 5.25 22.54 5.05 22.66L4.38 23.09C3.75 23.49 3.28 23.73 2.82 23.87L2.68 23.9C2.52 23.96 2.37 23.98 2.2 23.99L2 24 1 24C0.45 24 0 23.55 0 23L0 11.1 0 11 0 5C0 3.34 1.34 2 3 2L17.54 2 17.28 1.71C16.93 1.34 16.91 0.75 17.22 0.36L17.28 0.29C17.65-0.1 18.26-0.1 18.63 0.29ZM12.93 11L2.1 11 2.06 11.01C2.03 11.02 2 11.06 2 11.1L2 22C2.05 21.99 2.09 21.98 2.13 21.98 2.31 21.93 2.57 21.8 3.1 21.49L3.73 21.12C4.12 20.89 4.46 20.7 4.79 20.54 5.5 20.15 6.02 20 6.73 20L6.85 20C7.73 20 8.38 20.24 9.64 20.9L10.34 21.28 10.74 21.49C11.24 21.74 11.59 21.88 11.9 21.95L12 21.97C12.41 21.9 12.88 21.69 13.66 21.28L14.35 20.9C15.44 20.33 16.07 20.07 16.79 20.01L20 16 16 16C15.34 16 14.35 15.02 13.03 11.07 13.01 11.03 12.98 11 12.93 11ZM10 14C10.55 14 11 14.45 11 15 11 15.55 10.55 16 10 16L6 16C5.45 16 5 15.55 5 15 5 14.45 5.45 14 6 14L10 14ZM3.34 7L2 7 2 9 4 9 3.44 7.07C3.42 7.03 3.38 7 3.34 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingOnRouteArrowFlipped: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.37 0.29L3.47 2.29C3.1 2.68 3.1 3.32 3.47 3.71L5.37 5.71C5.74 6.1 6.35 6.1 6.72 5.71 7.09 5.32 7.09 4.68 6.72 4.29L6.46 4 21 4C21.55 4 22 4.45 22 5L20.66 5C19.73 5 18.91 5.62 18.64 6.51L17.92 9 11.07 9C10.18 9 9.38 9.56 9.07 10.44L8.83 11.17C8.5 12.11 7.98 13.05 7.25 14L1 14C0.33 14 0.21 14.34 0.64 15.01L4.99 20.43 4.77 20.55C4.51 20.68 4.25 20.82 3.95 20.99L2.93 21.59 2.65 21.74 2.44 21.85 2.27 21.93C2.22 21.95 2.18 21.96 2.14 21.97L2 21.99 1 22C0.45 22 0 22.45 0 23 0 23.55 0.45 24 1 24L2.11 24C2.27 23.99 2.41 23.98 2.55 23.94L2.7 23.9C3.2 23.78 3.7 23.52 4.38 23.09L5.05 22.66 5.32 22.5 5.56 22.36C6.02 22.14 6.39 22.03 6.73 22L6.82 22C7.27 22.02 7.66 22.19 8.41 22.66L9.08 23.09C10.04 23.7 10.93 23.95 11.76 23.99L11.93 24 12.07 24 12.24 23.99C13.07 23.95 13.97 23.7 14.93 23.09L15.59 22.66C16.29 22.22 16.68 22.05 17.09 22.01L17.2 22 17.25 22C17.6 22.02 17.96 22.13 18.43 22.35 18.58 22.44 18.75 22.54 18.95 22.66L19.62 23.09C20.25 23.49 20.72 23.73 21.18 23.87L21.32 23.9C21.48 23.96 21.63 23.98 21.8 23.99L22 24 23 24C23.55 24 24 23.55 24 23L24 11.1 24 11 24 5C24 3.34 22.66 2 21 2L6.46 2 6.72 1.71C7.07 1.34 7.09 0.75 6.78 0.36L6.72 0.29C6.35-0.1 5.74-0.1 5.37 0.29ZM11.07 11L21.91 11 21.94 11.01C21.97 11.02 22 11.06 22 11.1L22 22C21.95 21.99 21.91 21.98 21.87 21.98 21.69 21.93 21.43 21.8 20.9 21.49L20.27 21.12C19.88 20.89 19.54 20.7 19.21 20.54 18.5 20.15 17.98 20 17.27 20L17.15 20C16.27 20 15.62 20.24 14.36 20.9L13.66 21.28 13.26 21.49C12.76 21.74 12.41 21.88 12.1 21.95L12 21.97C11.59 21.9 11.12 21.69 10.34 21.28L9.65 20.9C8.56 20.33 7.93 20.07 7.21 20.01L4 16 8 16C8.66 16 9.65 15.02 10.97 11.07 10.99 11.03 11.02 11 11.07 11ZM14 14C13.45 14 13 14.45 13 15 13 15.55 13.45 16 14 16L18 16C18.55 16 19 15.55 19 15 19 14.45 18.55 14 18 14L14 14ZM20.66 7L22 7 22 9 20 9 20.56 7.07C20.58 7.03 20.62 7 20.66 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingPeak: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12 4C16.42 4 20 7.58 20 12 20 16.42 16.42 20 12 20L11.75 20C7.45 19.86 4 16.33 4 12 4 7.58 7.58 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingRoute: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM18.35 7.48L15.17 14.2C15.07 14.41 14.91 14.57 14.7 14.67L7.98 17.85C7.13 18.26 6.24 17.37 6.65 16.52L9.83 9.8C9.93 9.59 10.09 9.43 10.3 9.33L17.02 6.15C17.87 5.74 18.76 6.63 18.35 7.48ZM15.35 9.15L11.48 10.98 9.65 14.85 13.52 13.02 15.35 9.15Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingRouteAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6.5 13C5.12 13 4 14.12 4 15.5 4 16.88 5.12 18 6.5 18L18.54 18 17.28 16.71C16.93 16.34 16.91 15.75 17.22 15.36L17.28 15.29C17.65 14.9 18.26 14.9 18.63 15.29L21.53 18.29C21.9 18.68 21.9 19.32 21.53 19.71L18.63 22.71C18.26 23.1 17.65 23.1 17.28 22.71 16.91 22.32 16.91 21.68 17.28 21.29L18.54 20 6.5 20C4.01 20 2 17.99 2 15.5 2 13.01 4.01 11 6.5 11L17.5 11C18.88 11 20 9.88 20 8.5 20 7.12 18.88 6 17.5 6L9.87 6C9.43 7.73 7.86 9 6 9 3.79 9 2 7.21 2 5 2 2.79 3.79 1 6 1 7.86 1 9.43 2.27 9.87 4L17.5 4C19.99 4 22 6.01 22 8.5 22 10.99 19.99 13 17.5 13L6.5 13ZM6 3C4.9 3 4 3.9 4 5 4 6.1 4.9 7 6 7 7.1 7 8 6.1 8 5 8 3.9 7.1 3 6 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingShip: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 0C14.55 0 15 0.45 15 1L15 3 18 3C18.55 3 19 3.45 19 4L19 6 20 6C20.55 6 21 6.45 21 7L21 11.39 22.27 11.9C22.76 12.09 23.01 12.63 22.85 13.13L20.06 21 21.07 21.59C21.48 21.82 21.7 21.93 21.86 21.97L22 21.99 23 22C23.55 22 24 22.45 24 23 24 23.55 23.55 24 23 24L21.98 24 21.89 24C21.73 23.99 21.59 23.98 21.45 23.94L21.3 23.9C20.8 23.78 20.3 23.52 19.62 23.09L18.95 22.66 18.68 22.5 18.44 22.36C17.98 22.14 17.61 22.03 17.27 22L17.18 22C16.73 22.02 16.34 22.19 15.59 22.66L14.92 23.09C13.96 23.7 13.07 23.95 12.24 23.99L12.07 24 11.93 24 11.76 23.99C10.93 23.95 10.03 23.7 9.07 23.09L8.41 22.66C7.71 22.22 7.32 22.05 6.91 22.01L6.8 22 6.75 22C6.4 22.02 6.04 22.13 5.57 22.35 5.42 22.44 5.25 22.54 5.05 22.66L4.38 23.09C3.75 23.49 3.28 23.73 2.82 23.87L2.68 23.9C2.52 23.96 2.37 23.98 2.2 23.99L2 24 1 24C0.45 24 0 23.55 0 23 0 22.45 0.45 22 1 22L2 22C2.05 21.99 2.09 21.98 2.13 21.98 2.31 21.93 2.57 21.8 3.1 21.49L3.93 21 0.95 13.15C0.78 12.64 1.04 12.09 1.53 11.9L3 11.31 3 7C3 6.45 3.45 6 4 6 4.04 6 4.08 6 4.12 6.01L5 6 5 4 5.01 3.88C5.06 3.39 5.49 3 6 3 6.04 3 6.08 3 6.12 3.01L7.29 3.02 9 3.02 9 1C9 0.49 9.39 0.06 9.88 0.01L10 0 14 0ZM11.9 9.9L3.15 13.4 5.74 20.13C6.05 20.04 6.37 20 6.73 20L6.85 20C7.73 20 8.38 20.24 9.64 20.9L10.34 21.28 10.74 21.49C11.24 21.74 11.59 21.88 11.9 21.95L12 21.97C12.41 21.9 12.88 21.69 13.66 21.28L14.35 20.9C15.54 20.27 16.19 20.03 17 20L17.27 20C17.63 20 17.94 20.04 18.25 20.13L20.67 13.41 11.9 9.9ZM13.12 2L11 2 11 4C11 4.38 10.55 4.88 10.12 4.92L7 5 7 7C7 7.38 6.51 7.96 6.08 8L6 8 5 8 5 10.51 11.53 7.9 11.65 7.86 11.76 7.83 11.9 7.82 11.99 7.83 12.09 7.84 12.2 7.87 12.27 7.9 19 10.59 19 8 18 8C17.56 8 17.04 7.44 17 7.07L17 7 17 5 13.96 4.92C13.52 4.92 13.16 4.63 13.12 4.26L13.12 4.19 13.12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingShoulder: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM13.01 4.06C16.96 4.31 20 7.92 20 12 20 16.07 16.96 19.68 13.03 19.93 12 20 12 20 12 19 12 13.51 12 7.86 12 5 12 4 12 4 13.01 4.06Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTaxi: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 0C15.4 0 15.77 0.24 15.92 0.62L16.92 3 18.29 3C19.61 3 20.77 3.89 21.13 5.18L21.8 8.12C22.01 8.04 22.25 8 22.5 8 23.33 8 24 8.45 24 9 24 9.55 23.33 10 22.5 10 22.41 10 22.31 9.99 22.22 9.98L22.29 10.29C23.3 10.78 24 11.81 24 13L24 20.92C24 22.05 23.12 23 22 23L19 23C17.88 23 17 22.05 17 20.92L17 20 7 20 7 20.92C7 22.05 6.12 23 5 23L2 23C0.88 23 0 22.05 0 20.92L0 13C0 11.87 0.63 10.88 1.55 10.37L1.64 9.99 1.5 10C0.72 10 0.08 9.61 0.01 9.1L0 9C0 8.45 0.67 8 1.5 8 1.71 8 1.9 8.03 2.08 8.08L2.74 5.18C2.79 5.02 2.85 4.87 2.91 4.72 3 4.54 3.1 4.38 3.21 4.22 3.33 4.06 3.46 3.91 3.64 3.75L3.82 3.6 4 3.47 4.26 3.32 4.43 3.24 4.6 3.18 4.83 3.1 5.02 3.06 5.17 3.03C5.3 3.01 5.43 3 5.56 3L7.05 3 7.06 2.95 8.08 0.6C8.24 0.24 8.6 0 9 0L15 0ZM22 19.23L21.89 19.29C20.99 19.74 20.01 19.98 19 20L19 20.92C19 20.98 19.02 21 19 21L22 21C21.98 21 22 20.98 22 20.92L22 19.23ZM2 19.24L2 20.92C2 20.98 2.02 21 2 21L5 21C4.98 21 5 20.98 5 20.92L5 20 4.77 19.99C3.84 19.94 2.94 19.7 2.11 19.29L2 19.24ZM21 12L3 12C2.45 12 2 12.45 2 13L2 16.38C2 16.76 2.21 17.11 2.55 17.28L3 17.5C3.66 17.83 4.38 18 5.12 18L18.88 18C19.62 18 20.34 17.83 21 17.5L21.45 17.28C21.79 17.11 22 16.76 22 16.38L22 13C22 12.45 21.55 12 21 12ZM5 14C5.55 14 6 14.45 6 15 6 15.55 5.55 16 5 16 4.45 16 4 15.55 4 15 4 14.45 4.45 14 5 14ZM19 14C19.55 14 20 14.45 20 15 20 15.55 19.55 16 19 16 18.45 16 18 15.55 18 15 18 14.45 18.45 14 19 14ZM18.28 5L5.58 5 5.49 5 5.43 5.01 5.38 5.02 5.29 5.05 5.21 5.08 5.1 5.14 5.05 5.17 4.96 5.25C4.91 5.29 4.87 5.34 4.83 5.4 4.79 5.45 4.76 5.5 4.73 5.56 4.7 5.61 4.69 5.67 4.67 5.72L3.75 10 20.11 10 19.21 5.72C19.1 5.33 18.78 5.05 18.39 5.01L18.28 5ZM14.33 2L9.65 2 9.22 3 14.75 3 14.33 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTicket: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.5 4C23.33 4 24 4.63 24 5.41L24 18.59C24 19.37 23.33 20 22.5 20L1.5 20C0.67 20 0 19.37 0 18.59L0 14 0.01 13.88C0.06 13.39 0.49 13 1 13L2 13C2.55 13 3 12.55 3 12 3 11.45 2.55 11 2 11L1 11 0.88 10.99C0.39 10.94 0 10.51 0 10L0 5.41C0 4.63 0.67 4 1.5 4L22.5 4ZM8 6L2 6 2 9C3.66 9 5 10.34 5 12 5 13.66 3.66 15 2 15L2 18 8 18 8 6ZM22 6L10 6 10 18 22 18 22 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTicketFilled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 5C22.33 5 23 5.67 23 6.5L23 18.5C23 19.33 22.33 20 21.5 20L2.5 20C1.67 20 1 19.33 1 18.5L1 15.04 1.63 14.78C2.93 14.26 3.5 13.58 3.5 12.5 3.5 11.42 2.93 10.74 1.63 10.22L1 9.96 1 6.5C1 5.67 1.67 5 2.5 5L21.5 5ZM9 7C8.45 7 8 7.45 8 8L8 17C8 17.55 8.45 18 9 18 9.55 18 10 17.55 10 17L10 8C10 7.45 9.55 7 9 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTrailer: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 4 22 15 22 18C22 18.89 21.61 19.69 21 20.24L21 22C21 23.1 20.1 24 19 24L17 24C15.9 24 15 23.1 15 22L15 21 9 21 9 22C9 23.1 8.1 24 7 24L5 24C3.9 24 3 23.1 3 22L3 20.24C2.39 19.69 2 18.89 2 18L2 3C2 1.34 3.34 0 5 0L19 0ZM19 21L17 21 17 22 19 22 19 21ZM7 21L5 21 5 22 7 22 7 21ZM19 2L5 2C4.49 2 4.06 2.39 4.01 2.88L4 3 4 18C4 18.55 4.45 19 5 19L19 19C19.55 19 20 18.55 20 18L20 3C20 2.45 19.55 2 19 2ZM12 2.5C12.55 2.5 13 2.95 13 3.5L13 17.5C13 18.05 12.55 18.5 12 18.5 11.45 18.5 11 18.05 11 17.5L11 3.5C11 2.95 11.45 2.5 12 2.5ZM17 13C17.55 13 18 13.45 18 14 18 14.55 17.55 15 17 15L16 15C15.45 15 15 14.55 15 14 15 13.45 15.45 13 16 13L17 13ZM8 13C8.55 13 9 13.45 9 14 9 14.55 8.55 15 8 15L7 15C6.45 15 6 14.55 6 14 6 13.45 6.45 13 7 13L8 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTrailerDo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 3C22.88 3 24 4.12 24 5.5L24 15.5C24 16.88 22.88 18 21.5 18L15.24 18 15.07 18.34C14.59 19.3 13.64 19.92 12.58 19.99L12.38 20 10.87 20C10.78 20.35 10.64 20.7 10.45 21.02L10.35 21.19 10.28 21.29 10.19 21.41 10.09 21.54 9.97 21.68 9.86 21.8 9.75 21.91 9.64 22.01 9.53 22.1 9.39 22.2 9.24 22.31 9.1 22.4 8.97 22.48 8.84 22.55 8.7 22.62 8.56 22.68 8.41 22.74 8.29 22.79 8.08 22.85 7.93 22.89 7.76 22.93 7.58 22.96 7.41 22.98 7.25 22.99 7.23 22.99 7.17 23 7 23C6.89 23 6.78 23 6.61 22.98L6.41 22.96 6.15 22.91 5.99 22.87 5.83 22.82 5.67 22.77 5.53 22.72 5.38 22.66 5.24 22.59 5.08 22.51 4.92 22.41 4.77 22.32 4.65 22.24 4.53 22.14 4.4 22.04 4.31 21.96 4.15 21.81 4.06 21.71 3.97 21.61 3.89 21.52 3.8 21.4 3.69 21.25 3.61 21.13 3.54 21.01C3.36 20.69 3.22 20.35 3.13 20L0 20 0 5.5C0 4.12 1.12 3 2.5 3L21.5 3ZM7 17C6.94 17 6.88 17 6.81 17.01L6.69 17.02 6.54 17.05 6.33 17.11 6.13 17.2 6.05 17.24C5.96 17.29 5.88 17.34 5.8 17.4L5.65 17.52 5.53 17.65 5.42 17.77 5.36 17.86 5.27 18C5.1 18.29 5 18.64 5 19 5 19.37 5.1 19.71 5.27 20L5.32 20.08 5.43 20.24 5.51 20.33 5.6 20.43 5.67 20.5 5.8 20.6 5.92 20.68 6.08 20.78 6.23 20.85 6.37 20.9 6.54 20.95 6.69 20.98 6.75 20.99 6.91 21 7.09 21 7.17 20.99 7.13 20.99 7.25 20.99 7.43 20.95 7.58 20.91 7.67 20.89 7.81 20.83 7.95 20.76 8.08 20.68 8.23 20.57 8.35 20.48 8.45 20.37 8.57 20.23 8.66 20.12 8.71 20.03 8.73 20C8.9 19.71 9 19.37 9 19 9 18.72 8.94 18.45 8.84 18.21 8.81 18.14 8.77 18.07 8.73 18L8.68 17.91 8.58 17.77 8.43 17.61 8.33 17.51 8.28 17.46 8.2 17.4 8.08 17.32 7.92 17.22 7.77 17.15 7.63 17.1 7.46 17.05 7.31 17.02 7.17 17.01 7.08 17 7 17ZM21.5 5L2.5 5C2.22 5 2 5.22 2 5.5L2 18 3.13 18C3.22 17.64 3.37 17.28 3.58 16.93L3.67 16.79 3.75 16.67 3.81 16.58 3.9 16.47 4 16.35 4.12 16.23 4.24 16.1 4.38 15.98 4.52 15.86 4.59 15.81C4.75 15.69 4.92 15.58 5.13 15.46L5.22 15.42 5.36 15.35 5.56 15.27 5.76 15.2 5.97 15.14 6.15 15.09 6.3 15.06 6.44 15.04 6.63 15.02C6.75 15.01 6.88 15 7.04 15L7.21 15.01 7.29 15.01 7.55 15.04 7.7 15.06 7.85 15.09 8.01 15.13 8.17 15.18 8.33 15.23 8.47 15.28 8.62 15.34 8.76 15.41 8.92 15.49 9.08 15.59 9.23 15.68 9.35 15.76 9.45 15.84 9.64 15.99 9.71 16.06 9.82 16.16 9.94 16.29 10.08 16.45 10.2 16.61 10.31 16.75 10.38 16.87 10.46 17C10.64 17.31 10.78 17.65 10.87 18L12.38 18C12.76 18 13.11 17.79 13.28 17.45L13.72 16.55C13.89 16.21 14.24 16 14.62 16L21.5 16C21.78 16 22 15.78 22 15.5L22 5.5C22 5.22 21.78 5 21.5 5ZM16.9 7.1C17.46 7.1 17.9 7.54 17.9 8.1L17.9 10.64 18.2 10.38C18.57 10.02 19.15 10 19.55 10.32L19.61 10.38C20 10.75 20 11.36 19.61 11.73L17.61 13.62C17.22 14 16.59 14 16.2 13.62L14.2 11.73C13.81 11.36 13.81 10.75 14.2 10.38 14.59 10 15.22 10 15.61 10.38L15.9 10.64 15.9 8.1C15.9 7.54 16.35 7.1 16.9 7.1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTrailerPu: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.5 3C22.88 3 24 4.12 24 5.5L24 15.5C24 16.88 22.88 18 21.5 18L15.24 18 15.07 18.34C14.59 19.3 13.64 19.92 12.58 19.99L12.38 20 10.87 20C10.78 20.35 10.64 20.7 10.45 21.02L10.35 21.19 10.28 21.29 10.19 21.41 10.09 21.54 9.97 21.68 9.86 21.8 9.75 21.91 9.64 22.01 9.53 22.1 9.39 22.2 9.24 22.31 9.1 22.4 8.97 22.48 8.84 22.55 8.7 22.62 8.56 22.68 8.41 22.74 8.29 22.79 8.08 22.85 7.93 22.89 7.76 22.93 7.58 22.96 7.41 22.98 7.25 22.99 7.23 22.99 7.17 23 7 23C6.89 23 6.78 23 6.61 22.98L6.41 22.96 6.15 22.91 5.99 22.87 5.83 22.82 5.67 22.77 5.53 22.72 5.38 22.66 5.24 22.59 5.08 22.51 4.92 22.41 4.77 22.32 4.65 22.24 4.53 22.14 4.4 22.04 4.31 21.96 4.15 21.81 4.06 21.71 3.97 21.61 3.89 21.52 3.8 21.4 3.69 21.25 3.61 21.13 3.54 21.01C3.36 20.69 3.22 20.35 3.13 20L0 20 0 5.5C0 4.12 1.12 3 2.5 3L21.5 3ZM7 17C6.94 17 6.88 17 6.81 17.01L6.69 17.02 6.54 17.05 6.33 17.11 6.13 17.2 6.05 17.24C5.96 17.29 5.88 17.34 5.8 17.4L5.65 17.52 5.53 17.65 5.42 17.77 5.36 17.86 5.27 18C5.1 18.29 5 18.64 5 19 5 19.37 5.1 19.71 5.27 20L5.32 20.08 5.43 20.24 5.51 20.33 5.6 20.43 5.67 20.5 5.8 20.6 5.92 20.68 6.08 20.78 6.23 20.85 6.37 20.9 6.54 20.95 6.69 20.98 6.75 20.99 6.91 21 7.09 21 7.17 20.99 7.13 20.99 7.25 20.99 7.43 20.95 7.58 20.91 7.67 20.89 7.81 20.83 7.95 20.76 8.08 20.68 8.23 20.57 8.35 20.48 8.45 20.37 8.57 20.23 8.66 20.12 8.71 20.03 8.73 20C8.9 19.71 9 19.37 9 19 9 18.72 8.94 18.45 8.84 18.21 8.81 18.14 8.77 18.07 8.73 18L8.68 17.91 8.58 17.77 8.43 17.61 8.33 17.51 8.28 17.46 8.2 17.4 8.08 17.32 7.92 17.22 7.77 17.15 7.63 17.1 7.46 17.05 7.31 17.02 7.17 17.01 7.08 17 7 17ZM21.5 5L2.5 5C2.22 5 2 5.22 2 5.5L2 18 3.13 18C3.22 17.64 3.37 17.28 3.58 16.93L3.67 16.79 3.75 16.67 3.81 16.58 3.9 16.47 4 16.35 4.12 16.23 4.24 16.1 4.38 15.98 4.52 15.86 4.59 15.81C4.75 15.69 4.92 15.58 5.13 15.46L5.22 15.42 5.36 15.35 5.56 15.27 5.76 15.2 5.97 15.14 6.15 15.09 6.3 15.06 6.44 15.04 6.63 15.02C6.75 15.01 6.88 15 7.04 15L7.21 15.01 7.29 15.01 7.55 15.04 7.7 15.06 7.85 15.09 8.01 15.13 8.17 15.18 8.33 15.23 8.47 15.28 8.62 15.34 8.76 15.41 8.92 15.49 9.08 15.59 9.23 15.68 9.35 15.76 9.45 15.84 9.64 15.99 9.71 16.06 9.82 16.16 9.94 16.29 10.08 16.45 10.2 16.61 10.31 16.75 10.38 16.87 10.46 17C10.64 17.31 10.78 17.65 10.87 18L12.38 18C12.76 18 13.11 17.79 13.28 17.45L13.72 16.55C13.89 16.21 14.24 16 14.62 16L21.5 16C21.78 16 22 15.78 22 15.5L22 5.5C22 5.22 21.78 5 21.5 5ZM16.2 7.38C16.59 7 17.22 7 17.61 7.38L19.61 9.27C20 9.64 20 10.25 19.61 10.62L19.55 10.68C19.15 11 18.57 10.98 18.2 10.62L17.9 10.36 17.9 12.9C17.9 13.46 17.46 13.9 16.9 13.9 16.35 13.9 15.9 13.46 15.9 12.9L15.9 10.36 15.61 10.62C15.22 11 14.59 11 14.2 10.62 13.81 10.25 13.81 9.64 14.2 9.27L16.2 7.38Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTrain: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 0C18.71 0 21 2.24 21 5L21 15C21 17.05 19.74 18.8 17.99 19.58L19.95 21.54C20.34 21.93 20.34 22.56 19.95 22.95 19.56 23.34 18.93 23.34 18.54 22.95L15.71 20.12C15.67 20.08 15.63 20.04 15.6 20L9.05 20C9.02 20.04 8.99 20.08 8.95 20.12L6.12 22.95C5.73 23.34 5.1 23.34 4.71 22.95 4.32 22.56 4.32 21.93 4.71 21.54L6.48 19.76C4.49 19.11 3 17.23 3 15L3 5C3 2.24 5.29 0 8 0L16 0ZM19 7L5 7 5 15C5 16.66 6.38 18 8 18L16 18C17.62 18 19 16.66 19 15L19 7ZM15 14C15.55 14 16 14.45 16 15 16 15.55 15.55 16 15 16L9 16C8.45 16 8 15.55 8 15 8 14.45 8.45 14 9 14L15 14ZM16 2L8 2C6.38 2 5 3.34 5 5L19 5C19 3.34 17.62 2 16 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTram: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 3C17.71 3 20 5.24 20 8L20 16C20 18.05 18.74 19.8 16.99 20.58L18.95 22.54C19.34 22.93 19.34 23.56 18.95 23.95 18.56 24.34 17.93 24.34 17.54 23.95L14.71 21.12C14.67 21.08 14.63 21.04 14.6 21L10.05 21C10.02 21.04 9.99 21.08 9.95 21.12L7.12 23.95C6.73 24.34 6.1 24.34 5.71 23.95 5.32 23.56 5.32 22.93 5.71 22.54L7.48 20.76C5.49 20.11 4 18.23 4 16L4 8C4 5.24 6.29 3 9 3L15 3ZM18 10L6 10 6 16C6 17.66 7.38 19 9 19L15 19C16.62 19 18 17.66 18 16L18 10ZM9 15C9.55 15 10 15.45 10 16 10 16.55 9.55 17 9 17 8.45 17 8 16.55 8 16 8 15.45 8.45 15 9 15ZM15 15C15.55 15 16 15.45 16 16 16 16.55 15.55 17 15 17 14.45 17 14 16.55 14 16 14 15.45 14.45 15 15 15ZM15 5L9 5C7.38 5 6 6.34 6 8L18 8C18 6.34 16.62 5 15 5ZM10 0L14 0C14.55 0 15 0.45 15 1 15 1.55 14.55 2 14 2L10 2C9.45 2 9 1.55 9 1 9 0.45 9.45 0 10 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTruckAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.19 0C10.68 0 12 1.15 12 2.71L12 6 17.38 6C18.54 6 19.63 6.59 20.23 7.59L23.72 13.45C23.9 13.76 24 14.11 24 14.47L24 19C24 20.05 23.18 20.92 22.15 20.99L22 21 20.96 21C20.72 22.7 19.26 24 17.5 24 15.74 24 14.28 22.7 14.04 21L0 21 0 19 10 19 10 2.71C10 2.32 9.64 2 9.19 2L0 2 0 0 9.19 0ZM17.5 19C16.68 19 16.01 19.66 16 20.48L16 20.52 16.01 20.64C16.08 21.41 16.72 22 17.5 22 18.33 22 19 21.33 19 20.5 19 19.67 18.33 19 17.5 19ZM17.38 8L12 8 12 19 14.34 19C14.9 17.82 16.1 17 17.5 17 18.9 17 20.1 17.82 20.66 19L22 19 22 15.02C22 14.66 21.9 14.31 21.72 14L18.51 8.61 18.51 8.61C18.28 8.24 17.85 8 17.38 8ZM17 10C17.55 10 18 10.45 18 11 18 11.55 17.55 12 17 12L15 12C14.45 12 14 11.55 14 11 14 10.45 14.45 10 15 10L17 10Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingTruckSide: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 0C11.31 0 12.42 0.83 12.83 2L17.81 2C19.68 2 21.29 3.29 21.71 5.11L22.44 8.3C22.95 10.57 23.17 12.89 23.09 15.22L23 18C23 20.21 21.21 22 19 22L18.46 22C17.77 23.2 16.48 24 15 24 13.52 24 12.23 23.2 11.54 22L1 22 1 0 10 0ZM15 18C13.9 18 13 18.9 13 20 13 21.1 13.9 22 15 22 16.1 22 17 21.1 17 20 17 18.95 16.18 18.08 15.15 18.01L15 18ZM11.54 18L3 18 3 20 11 20C11 19.27 11.19 18.59 11.54 18ZM18.46 18C18.77 18.53 18.96 19.15 19 19.8L19 20C20.1 20 21 19.1 21 18L18.46 18ZM17.81 4L13 4 13 16 21.07 16 21.1 15.15C21.16 13.21 21 11.27 20.62 9.37L20.49 8.74 19.76 5.56C19.55 4.65 18.74 4 17.81 4ZM10 2L3 2 3 16 11 16 11 2.99 10.99 2.88C10.94 2.39 10.51 2 10 2ZM18 8C18.55 8 19 8.45 19 9 19 9.55 18.55 10 18 10L15 10C14.45 10 14 9.55 14 9 14 8.45 14.45 8 15 8L18 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingVehicle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 8C22.55 8 23 8.45 23 9L23 11C23 11.55 22.55 12 22 12L22 18C22 18.89 21.61 19.69 21 20.24L21 22C21 23.1 20.1 24 19 24L17 24C15.9 24 15 23.1 15 22L15 21 9 21 9 22C9 23.1 8.1 24 7 24L5 24C3.9 24 3 23.1 3 22L3 20.24C2.39 19.69 2 18.89 2 18L2 12C1.45 12 1 11.55 1 11L1 9C1 8.45 1.45 8 2 8L2 3C2 1.34 3.34 0 5 0L19 0ZM19 21L17 21 17 22 19 22 19 21ZM7 21L5 21 5 22 7 22 7 21ZM20 13L4 13 4 18C4 18.55 4.45 19 5 19L19 19C19.55 19 20 18.55 20 18L20 13ZM14 15C14.55 15 15 15.45 15 16 15 16.55 14.55 17 14 17L10 17C9.45 17 9 16.55 9 16 9 15.45 9.45 15 10 15L14 15ZM19 6L5 6C4.45 6 4 6.45 4 7L4 11 20 11 20 7C20 6.45 19.55 6 19 6ZM19 2L5 2C4.45 2 4 2.45 4 3L4 4.17C4.31 4.06 4.65 4 5 4L19 4C19.35 4 19.69 4.06 20 4.17L20 3C20 2.45 19.55 2 19 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSave: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12 0C12.55 0 13 0.45 13 1L13 13.54 14.29 12.28C14.68 11.91 15.32 11.91 15.71 12.28 16.1 12.65 16.1 13.26 15.71 13.63L12.71 16.53C12.32 16.9 11.68 16.9 11.29 16.53L8.29 13.63C7.9 13.26 7.9 12.65 8.29 12.28L8.36 12.22C8.75 11.91 9.34 11.93 9.71 12.28L11 13.54 11 1C11 0.45 11.45 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSearch: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C17.52 2 22 6.48 22 12 22 14.4 21.15 16.61 19.74 18.33L22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L18.33 19.74C16.61 21.15 14.4 22 12 22 6.48 22 2 17.52 2 12 2 6.48 6.48 2 12 2ZM12 4C7.58 4 4 7.58 4 12 4 16.42 7.58 20 12 20 16.42 20 20 16.42 20 12 20 7.58 16.42 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSearchError: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM10.83 9.41L12.24 10.83 13.66 9.41C14.05 9.02 14.68 9.02 15.07 9.41 15.46 9.8 15.46 10.44 15.07 10.83L13.66 12.24 15.07 13.66C15.46 14.05 15.46 14.68 15.07 15.07 14.68 15.46 14.05 15.46 13.66 15.07L12.24 13.66 10.83 15.07C10.44 15.46 9.8 15.46 9.41 15.07 9.02 14.68 9.02 14.05 9.41 13.66L10.83 12.24 9.41 10.83C9.02 10.44 9.02 9.8 9.41 9.41 9.8 9.02 10.44 9.02 10.83 9.41Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSearchMinus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L9 13C8.45 13 8 12.55 8 12 8 11.45 8.45 11 9 11L15 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSearchPlus: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 3C16.97 3 21 7.03 21 12 21 14.13 20.26 16.08 19.03 17.62L19.09 17.67 22.97 21.56C23.37 21.95 23.37 22.58 22.97 22.97 22.58 23.37 21.95 23.37 21.56 22.97L17.67 19.09 17.62 19.03C16.08 20.26 14.13 21 12 21 7.03 21 3 16.97 3 12 3 7.03 7.03 3 12 3ZM12 5C8.13 5 5 8.13 5 12 5 15.87 8.13 19 12 19 15.87 19 19 15.87 19 12 19 8.13 15.87 5 12 5ZM13 9L13 11 15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L13 13 13 15C13 15.55 12.55 16 12 16 11.45 16 11 15.55 11 15L11 13 9 13C8.45 13 8 12.55 8 12 8 11.45 8.45 11 9 11L11 11 11 9C11 8.45 11.45 8 12 8 12.55 8 13 8.45 13 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSendPlane: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.94 2.33L15.94 22.33C15.64 23.19 14.45 23.23 14.09 22.41L10.24 13.76 1.59 9.91C0.81 9.56 0.81 8.47 1.55 8.1L1.67 8.06 21.67 1.06C22.46 0.78 23.22 1.54 22.94 2.33ZM20.37 3.63L4.71 9.11 10.78 11.81 15.29 7.29C15.68 6.9 16.32 6.9 16.71 7.29 17.1 7.68 17.1 8.32 16.71 8.71L12.19 13.22 14.89 19.29 20.37 3.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaService: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 22C23 22.55 22.55 23 22 23 21.45 23 21 22.55 21 22L21 17C21 16.45 20.55 16 20 16L4 16C3.45 16 3 16.45 3 17L3 22C3 22.55 2.55 23 2 23 1.45 23 1 22.55 1 22L1 17C1 15.34 2.34 14 4 14L5 14C5 11.79 6.79 10 9 10L15 10C17.21 10 19 11.79 19 14L20 14C21.66 14 23 15.34 23 17L23 22ZM18 18C18.55 18 19 18.45 19 19 19 19.55 18.55 20 18 20L16 20C15.45 20 15 19.55 15 19 15 18.45 15.45 18 16 18L18 18ZM15 12L9 12C7.9 12 7 12.9 7 14L17 14C17 12.9 16.1 12 15 12ZM12 1C14.21 1 16 2.79 16 5 16 7.21 14.21 9 12 9 9.79 9 8 7.21 8 5 8 2.79 9.79 1 12 1ZM12 3C10.9 3 10 3.9 10 5 10 6.1 10.9 7 12 7 13.1 7 14 6.1 14 5 14 3.9 13.1 3 12 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSettings: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.5 0C21.54 0 24 2.46 24 5.5 24 8.54 21.54 11 18.5 11L5.5 11C2.46 11 0 8.54 0 5.5 0 2.46 2.46 0 5.5 0L18.5 0ZM18.5 2L5.5 2C3.57 2 2 3.57 2 5.5 2 7.43 3.57 9 5.5 9L18.5 9C20.43 9 22 7.43 22 5.5 22 3.57 20.43 2 18.5 2ZM5.5 4C6.33 4 7 4.67 7 5.5 7 6.33 6.33 7 5.5 7 4.67 7 4 6.33 4 5.5 4 4.67 4.67 4 5.5 4ZM18.5 13C21.54 13 24 15.46 24 18.5 24 21.54 21.54 24 18.5 24L5.5 24C2.46 24 0 21.54 0 18.5 0 15.46 2.46 13 5.5 13L18.5 13ZM18.5 15L5.5 15C3.57 15 2 16.57 2 18.5 2 20.43 3.57 22 5.5 22L18.5 22C20.43 22 22 20.43 22 18.5 22 16.57 20.43 15 18.5 15ZM18.5 17C19.33 17 20 17.67 20 18.5 20 19.33 19.33 20 18.5 20 17.67 20 17 19.33 17 18.5 17 17.67 17.67 17 18.5 17Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaShare: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 6C6.55 6 7 6.45 7 7 7 7.51 6.61 7.94 6.12 7.99L6 8 4 8C3.45 8 3 8.45 3 9L3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 9C21 8.45 20.55 8 20 8L18 8C17.45 8 17 7.55 17 7 17 6.45 17.45 6 18 6L20 6C21.66 6 23 7.34 23 9L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 9C1 7.34 2.34 6 4 6L6 6ZM12.71 0.28L15.71 3.17C16.1 3.55 16.1 4.15 15.71 4.53 15.32 4.9 14.68 4.9 14.29 4.53L13 3.27 13 16.81C13 17.36 12.55 17.81 12 17.81 11.45 17.81 11 17.36 11 16.81L11 3.31 11 3.27 9.71 4.53C9.34 4.88 8.75 4.9 8.36 4.58L8.29 4.53C7.9 4.15 7.9 3.55 8.29 3.17L11.29 0.28C11.68-0.09 12.32-0.09 12.71 0.28Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaShareAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 9C1 8.45 1.45 8 2 8 2.51 8 2.94 8.39 2.99 8.88L3 9 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 9C21 8.45 21.45 8 22 8 22.55 8 23 8.45 23 9L23 21ZM12.71 0.28L16.71 4.17C17.1 4.55 17.1 5.15 16.71 5.53 16.32 5.9 15.68 5.9 15.29 5.53L13 3.27 13 16.81C13 17.36 12.55 17.81 12 17.81 11.45 17.81 11 17.36 11 16.81L11 3.27 8.71 5.53C8.34 5.88 7.75 5.9 7.36 5.58L7.29 5.53C6.9 5.15 6.9 4.55 7.29 4.17L11.29 0.28C11.68-0.09 12.32-0.09 12.71 0.28Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaShield: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0.82L12.48 0.94 20.48 2.93 22.19 3.35 21.99 5.1 20.93 14.3C20.65 16.78 19.35 19.02 17.35 20.5L13.68 23.23 13.58 23.31 13.46 23.37C12.43 23.95 11.16 23.87 10.21 23.16L6.64 20.5C4.64 19.02 3.35 16.78 3.07 14.31L2.01 5.1 1.81 3.35 3.52 2.93 11.52 0.94 12 0.82ZM12 2.88L4 4.87 5.06 14.08C5.28 16 6.28 17.74 7.83 18.9L11.4 21.56C11.72 21.79 12.15 21.82 12.49 21.63L16.16 18.9C17.72 17.74 18.72 16 18.94 14.08L20 4.87 12 2.88Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaShower: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 2C20.66 2 22 3.34 22 5L22 21C22 21.55 21.55 22 21 22 20.45 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L11 4C10.45 4 10 4.45 10 5L10 6 14 6C14.55 6 15 6.45 15 7 15 7.55 14.55 8 14 8L4 8C3.45 8 3 7.55 3 7 3 6.45 3.45 6 4 6L8 6 8 5C8 3.34 9.34 2 11 2L19 2ZM7.09 16L7.21 16.01C7.67 16.07 8.02 16.38 8 16.75L7.87 19.31C7.85 19.7 7.44 20 6.94 20L6.9 20C6.39 19.98 5.98 19.65 6 19.26L6.12 16.69C6.14 16.29 6.58 15.99 7.09 16ZM3.17 16L3.31 16.02C3.49 16.05 3.66 16.13 3.78 16.24 3.94 16.39 4.01 16.58 4 16.77L3.77 19.33C3.73 19.71 3.35 20 2.89 20L2.83 20C2.59 19.99 2.37 19.9 2.22 19.76 2.06 19.61 1.98 19.42 2 19.23L2.24 16.64C2.29 16.26 2.7 15.98 3.17 16ZM10.94 16C11.46 16 11.88 16.31 11.89 16.7L12 19.27C12.01 19.66 11.6 19.99 11.09 20L11.05 20C10.54 20 10.12 19.69 10.11 19.31L10 16.73C9.99 16.34 10.4 16.01 10.92 16ZM14.83 16C15.07 15.99 15.3 16.06 15.48 16.18 15.66 16.3 15.77 16.48 15.78 16.67L16 19.24C16.03 19.63 15.66 19.97 15.17 20L15.11 20C14.64 20 14.25 19.71 14.22 19.33L14 16.77C13.99 16.58 14.06 16.39 14.22 16.24 14.38 16.1 14.6 16.01 14.83 16ZM7.09 10L7.21 10.01C7.67 10.07 8.02 10.38 8 10.75L7.87 13.31C7.85 13.7 7.44 14 6.94 14L6.9 14C6.39 13.98 5.98 13.65 6 13.26L6.12 10.69C6.14 10.29 6.58 9.99 7.09 10ZM3.17 10L3.31 10.02C3.49 10.05 3.66 10.13 3.78 10.24 3.94 10.39 4.01 10.58 4 10.77L3.77 13.33C3.73 13.71 3.35 14 2.89 14L2.83 14C2.59 13.99 2.37 13.9 2.22 13.76 2.06 13.61 1.98 13.42 2 13.23L2.24 10.64C2.29 10.26 2.7 9.98 3.17 10ZM10.94 10C11.46 10 11.88 10.31 11.89 10.7L12 13.27C12.01 13.66 11.6 13.99 11.09 14L11.05 14C10.54 14 10.12 13.69 10.11 13.31L10 10.73C9.99 10.34 10.4 10.01 10.92 10ZM14.83 10C15.07 9.99 15.3 10.06 15.48 10.18 15.66 10.3 15.77 10.48 15.78 10.67L16 13.24C16.03 13.63 15.66 13.97 15.17 14L15.11 14C14.64 14 14.25 13.71 14.22 13.33L14 10.77C13.99 10.58 14.06 10.39 14.22 10.24 14.38 10.1 14.6 10.01 14.83 10Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSignIn: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 2C21.66 2 23 3.34 23 5L23 19C23 20.66 21.66 22 20 22L10 22C8.34 22 7 20.66 7 19L7 16C7 15.45 7.45 15 8 15 8.55 15 9 15.45 9 16L9 19C9 19.55 9.45 20 10 20L20 20C20.55 20 21 19.55 21 19L21 5C21 4.45 20.55 4 20 4L10 4C9.45 4 9 4.45 9 5L9 8C9 8.55 8.55 9 8 9 7.45 9 7 8.55 7 8L7 5C7 3.34 8.34 2 10 2L20 2ZM14.13 8.29L17.03 11.29C17.4 11.68 17.4 12.32 17.03 12.71L14.13 15.71C13.76 16.1 13.15 16.1 12.78 15.71 12.41 15.32 12.41 14.68 12.78 14.29L14.04 13 1.5 13C0.95 13 0.5 12.55 0.5 12 0.5 11.45 0.95 11 1.5 11L14 11 14.04 11 12.78 9.71C12.43 9.34 12.41 8.75 12.72 8.36L12.78 8.29C13.15 7.9 13.76 7.9 14.13 8.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSignOut: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 2C14.66 2 16 3.34 16 5L16 8C16 8.55 15.55 9 15 9 14.45 9 14 8.55 14 8L14 5C14 4.45 13.55 4 13 4L4 4C3.45 4 3 4.45 3 5L3 19C3 19.55 3.45 20 4 20L13 20C13.55 20 14 19.55 14 19L14 16C14 15.45 14.45 15 15 15 15.55 15 16 15.45 16 16L16 19C16 20.66 14.66 22 13 22L4 22C2.34 22 1 20.66 1 19L1 5C1 3.34 2.34 2 4 2L13 2ZM20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSliders: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 0C3.55 0 4 0.45 4 1L4 5.17C5.17 5.58 6 6.69 6 8 6 9.31 5.17 10.42 4 10.83L4 23C4 23.55 3.55 24 3 24 2.45 24 2 23.55 2 23L2 10.83C0.83 10.42 0 9.31 0 8 0 6.69 0.83 5.58 2 5.17L2 1C2 0.45 2.45 0 3 0ZM3 7C2.45 7 2 7.45 2 8 2 8.55 2.45 9 3 9 3.55 9 4 8.55 4 8 4 7.49 3.61 7.06 3.12 7.01L3 7ZM12 0C12.55 0 13 0.45 13 1L13 13.17C14.17 13.58 15 14.69 15 16 15 17.31 14.17 18.42 13 18.83L13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 18.83C9.83 18.42 9 17.31 9 16 9 14.69 9.83 13.58 11 13.17L11 1C11 0.45 11.45 0 12 0ZM12 15C11.45 15 11 15.45 11 16 11 16.55 11.45 17 12 17 12.55 17 13 16.55 13 16 13 15.49 12.61 15.06 12.12 15.01L12 15ZM21 0C21.55 0 22 0.45 22 1L22 5.17C23.17 5.58 24 6.69 24 8 24 9.31 23.17 10.42 22 10.83L22 23C22 23.55 21.55 24 21 24 20.45 24 20 23.55 20 23L20 10.83C18.83 10.42 18 9.31 18 8 18 6.69 18.83 5.58 20 5.17L20 1C20 0.45 20.45 0 21 0ZM21 7C20.45 7 20 7.45 20 8 20 8.55 20.45 9 21 9 21.55 9 22 8.55 22 8 22 7.49 21.61 7.06 21.12 7.01L21 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSlidersMini: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 3C20.21 3 22 4.79 22 7 22 9.21 20.21 11 18 11 15.79 11 14 9.21 14 7 14 4.79 15.79 3 18 3ZM18 5C16.9 5 16 5.9 16 7 16 8.1 16.9 9 18 9 19.1 9 20 8.1 20 7 20 5.9 19.1 5 18 5ZM6 13C3.79 13 2 14.79 2 17 2 19.21 3.79 21 6 21 8.21 21 10 19.21 10 17 10 14.79 8.21 13 6 13ZM6 15C7.1 15 8 15.9 8 17 8 18.1 7.1 19 6 19 4.9 19 4 18.1 4 17 4 15.9 4.9 15 6 15ZM21 16L13 16C12.45 16 12 16.45 12 17 12 17.55 12.45 18 13 18L21 18C21.55 18 22 17.55 22 17 22 16.45 21.55 16 21 16ZM3 6L11 6C11.55 6 12 6.45 12 7 12 7.55 11.55 8 11 8L3 8C2.45 8 2 7.55 2 7 2 6.45 2.45 6 3 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSmokingNo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.37 2.45L12.91 12 14.7 12C14.87 12 15 12.13 15 12.3L15 14.09 16 15.09 16 12.3C16 12.13 16.13 12 16.3 12L17.7 12C17.87 12 18 12.13 18 12.3L18 17.09 21.75 20.84C22.14 21.23 22.14 21.86 21.75 22.25 21.36 22.64 20.73 22.64 20.34 22.25L15 16.91 15 17.7C15 17.87 14.87 18 14.7 18L3.3 18C3.13 18 3 17.87 3 17.7L3 12.3C3 12.13 3.13 12 3.3 12L10.08 12 1.95 3.87C1.56 3.48 1.56 2.84 1.95 2.45 2.34 2.06 2.98 2.06 3.37 2.45ZM20.7 12C20.87 12 21 12.13 21 12.3L21 17.7C21 17.87 20.87 18 20.7 18L19.3 18C19.13 18 19 17.87 19 17.7L19 12.3C19 12.13 19.13 12 19.3 12L20.7 12ZM12.09 14L5 14 5 16 12.7 16C12.87 16 13 15.87 13 15.7L13 14.91 12.09 14ZM14.75 4C14.89 4 15 4.13 15 4.28L15 5.44C15 6.45 15.49 6.34 16.24 6.92 17.34 7.77 18 8.17 18 9.67L18 10.72C18 10.88 17.89 11 17.75 11L16.25 11C16.11 11 16 10.88 16 10.72L16 9.67C16 8.72 15.59 8.83 14.88 8.29 13.77 7.42 13 7.1 13 5.58L13 4.28C13 4.13 13.11 4 13.25 4L14.75 4ZM17.75 4C17.89 4 18 4.13 18 4.28L18 4.44C18 5.45 18.49 5.34 19.24 5.92 20.34 6.77 21 7.17 21 8.67L21 10.72C21 10.88 20.89 11 20.75 11L19.25 11C19.11 11 19 10.88 19 10.72L19 8.67C19 7.72 18.59 7.83 17.88 7.29 16.77 6.42 16 6.1 16 4.58L16 4.28C16 4.13 16.11 4 16.25 4L17.75 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSms: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20 3C21.66 3 23 4.34 23 6L23 18C23 19.66 21.66 21 20 21L6.96 21 2.5 23.61C2.03 23.88 1.42 23.72 1.14 23.25 1.05 23.09 1 22.92 1 22.74L1 6C1 4.34 2.34 3 4 3L20 3ZM20 5L4 5C3.45 5 3 5.45 3 6L3 21 6.42 19 20 19C20.55 19 21 18.55 21 18L21 6C21 5.45 20.55 5 20 5ZM8 11C8.55 11 9 11.45 9 12 9 12.55 8.55 13 8 13 7.45 13 7 12.55 7 12 7 11.45 7.45 11 8 11ZM12 11C12.55 11 13 11.45 13 12 13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11ZM16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13 15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSoap: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 4.2L12.2 4.2C13.06 4.2 13.89 4.47 14.52 4.98 15.21 5.52 15.6 6.3 15.6 7.12L15.6 8 16 8C18.21 8 20 9.79 20 12L20 22 0 22 0 12C0 9.79 1.79 8 4 8L4 7.13C4 6.3 4.39 5.52 5.08 4.98 5.71 4.47 6.54 4.2 7.4 4.2L9 4.2 9 2 7.4 2C6.85 2 6.4 1.55 6.4 1 6.4 0.45 6.85 0 7.4 0L13.8 0C15.19 0 16.4 0.97 16.4 2.28 16.4 2.83 15.95 3.28 15.4 3.28 14.85 3.28 14.4 2.83 14.4 2.28 14.4 2.18 14.17 2 13.8 2L11 2 11 4.2ZM16 10L4 10C2.9 10 2 10.9 2 12L2 20 18 20 18 12C18 10.95 17.18 10.08 16.15 10.01L16 10ZM12.2 6.2L7.4 6.2C6.98 6.2 6.59 6.33 6.32 6.54 6.1 6.72 6 6.92 6 7.12L6 8 13.6 8 13.6 7.11C13.6 6.92 13.5 6.72 13.28 6.54 13.01 6.33 12.62 6.2 12.2 6.2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSortDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 4.01C6 3.45 6.45 3 7 3 7.55 3 8 3.45 8 4.01L8 17.65 8 17.69 9.29 16.42C9.66 16.06 10.25 16.04 10.64 16.36L10.71 16.42C11.1 16.8 11.1 17.41 10.71 17.79L7.71 20.72C7.32 21.09 6.68 21.09 6.29 20.72L3.29 17.79C2.9 17.41 2.9 16.8 3.29 16.42 3.68 16.04 4.32 16.04 4.71 16.42L6 17.7 6 4.01ZM12 3L20 3C20.55 3 21 3.45 21 4 21 4.55 20.55 5 20 5L12 5C11.45 5 11 4.55 11 4 11 3.45 11.45 3 12 3ZM12 7L18 7C18.55 7 19 7.45 19 8 19 8.55 18.55 9 18 9L12 9C11.45 9 11 8.55 11 8 11 7.45 11.45 7 12 7ZM12 11L16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L12 13C11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSortDownMini: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 6L17 6C17.55 6 18 6.45 18 7 18 7.55 17.55 8 17 8L7 8C6.45 8 6 7.55 6 7 6 6.45 6.45 6 7 6ZM7 11L15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11ZM7 16L13 16C13.55 16 14 16.45 14 17 14 17.55 13.55 18 13 18L7 18C6.45 18 6 17.55 6 17 6 16.45 6.45 16 7 16Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSortUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6 19.99C6 20.55 6.45 21 7 21 7.55 21 8 20.55 8 19.99L8 6.35 8 6.31 9.29 7.58C9.66 7.94 10.25 7.96 10.64 7.64L10.71 7.58C11.1 7.2 11.1 6.59 10.71 6.21L7.71 3.28C7.32 2.91 6.68 2.91 6.29 3.28L3.29 6.21C2.9 6.59 2.9 7.2 3.29 7.58 3.68 7.96 4.32 7.96 4.71 7.58L6 6.3 6 19.99ZM12 19L20 19C20.55 19 21 19.45 21 20 21 20.55 20.55 21 20 21L12 21C11.45 21 11 20.55 11 20 11 19.45 11.45 19 12 19ZM12 15L18 15C18.55 15 19 15.45 19 16 19 16.55 18.55 17 18 17L12 17C11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM12 11L16 11C16.55 11 17 11.45 17 12 17 12.55 16.55 13 16 13L12 13C11.45 13 11 12.55 11 12 11 11.45 11.45 11 12 11Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSortUpMini: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 16L17 16C17.55 16 18 16.45 18 17 18 17.55 17.55 18 17 18L7 18C6.45 18 6 17.55 6 17 6 16.45 6.45 16 7 16ZM7 11L15 11C15.55 11 16 11.45 16 12 16 12.55 15.55 13 15 13L7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11ZM7 6L13 6C13.55 6 14 6.45 14 7 14 7.55 13.55 8 13 8L7 8C6.45 8 6 7.55 6 7 6 6.45 6.45 6 7 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSpa: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.51 7L2.51 7C1.43 6.99 0.47 7.68 0.13 8.7-0.21 9.72 0.14 10.85 1.01 11.49L1.01 14.49C1.02 17.27 2.77 19.74 5.39 20.67L7.55 21 16.47 21 18.63 20.62C21.25 19.69 23 17.22 23.01 14.44L23.01 11.44C23.83 10.79 24.15 9.69 23.82 8.69 23.48 7.7 22.56 7.02 21.51 7ZM2.51 9L21.51 9C21.78 9 22.01 9.22 22.01 9.5 22.01 9.78 21.78 10 21.51 10L2.51 10C2.23 10 2.01 9.78 2.01 9.5 2.01 9.22 2.23 9 2.51 9ZM21.01 14.44C21 16.96 18.96 18.99 16.45 19L7.57 19C5.05 18.99 3.01 16.96 3.01 14.44L3.01 12 21.01 12 21.01 14.44ZM8 1C8.55 1 9 1.45 9 2L9 5C9 5.55 8.55 6 8 6 7.45 6 7 5.55 7 5L7 2C7 1.45 7.45 1 8 1ZM12 1C12.55 1 13 1.45 13 2L13 5C13 5.55 12.55 6 12 6 11.45 6 11 5.55 11 5L11 2C11 1.45 11.45 1 12 1ZM16 1C16.55 1 17 1.45 17 2L17 5C17 5.55 16.55 6 16 6 15.45 6 15 5.55 15 5L15 2C15 1.45 15.45 1 16 1Z M7.41 19.59H7.41A1 1 0 0 1 7.41 21L6 22.41A1 1 0 0 1 4.59 22.41H4.59A1 1 0 0 1 4.59 21L6 19.59A1 1 0 0 1 7.41 19.59z M16.59 19.59H16.59A1 1 0 0 0 16.59 21L18 22.41A1 1 0 0 0 19.41 22.41H19.41A1 1 0 0 0 19.41 21L18 19.59A1 1 0 0 0 16.59 19.59z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSpeechBubbles: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 0C14.66 0 16 1.34 16 3V7H21C22.6 7 23.9 8.25 24 9.82L24 10V21.56C24 22.11 23.55 22.56 23 22.56 22.79 22.56 22.59 22.5 22.42 22.38L19.04 20H11C9.34 20 8 18.66 8 17V13H4.96L1.58 15.38C1.12 15.7 0.5 15.59 0.18 15.14 0.06 14.97 0 14.77 0 14.56V3C0 1.34 1.34 0 3 0H13ZM11 9C10.45 9 10 9.45 10 10V17C10 17.55 10.45 18 11 18H19.58L22 20V10C22 9.45 21.55 9 21 9H11ZM3 2C2.45 2 2 2.45 2 3V13L4.42 11H8V10C8 8.4 9.25 7.1 10.82 7L11 7H14V3C14 2.45 13.55 2 13 2H3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStack: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 1C19.66 1 21 2.34 21 4L21 20C21 21.66 19.66 23 18 23L6 23C4.34 23 3 21.66 3 20L3 4C3 2.34 4.34 1 6 1L18 1ZM18 3L6 3C5.45 3 5 3.45 5 4L5 20C5 20.55 5.45 21 6 21L18 21C18.55 21 19 20.55 19 20L19 4C19 3.45 18.55 3 18 3ZM16 17C16.55 17 17 17.45 17 18 17 18.51 16.61 18.94 16.12 18.99L16 19 8 19C7.45 19 7 18.55 7 18 7 17.45 7.45 17 8 17L16 17ZM16 13C16.55 13 17 13.45 17 14 17 14.51 16.61 14.94 16.12 14.99L16 15 8 15C7.45 15 7 14.55 7 14 7 13.45 7.45 13 8 13L16 13ZM16 9C16.55 9 17 9.45 17 10 17 10.51 16.61 10.94 16.12 10.99L16 11 8 11C7.45 11 7 10.55 7 10 7 9.45 7.45 9 8 9L16 9ZM16 5C16.55 5 17 5.45 17 6 17 6.51 16.61 6.94 16.12 6.99L16 7 8 7C7.45 7 7 6.55 7 6 7 5.45 7.45 5 8 5L16 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStackCheck: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.1 17.29C22.49 17.68 22.49 18.32 22.1 18.71L17.98 22.83C17.77 23.04 17.48 23.14 17.2 23.12 16.92 23.14 16.63 23.04 16.41 22.83L14.29 20.71C13.9 20.32 13.9 19.68 14.29 19.29 14.68 18.9 15.32 18.9 15.71 19.29L17.2 20.78 20.69 17.29C21.08 16.9 21.71 16.9 22.1 17.29ZM18 1C19.66 1 21 2.34 21 4L21 14C21 14.55 20.55 15 20 15 19.45 15 19 14.55 19 14L19 4C19 3.45 18.55 3 18 3L6 3C5.45 3 5 3.45 5 4L5 20C5 20.55 5.45 21 6 21L12 21C12.55 21 13 21.45 13 22 13 22.55 12.55 23 12 23L6 23C4.34 23 3 21.66 3 20L3 4C3 2.34 4.34 1 6 1L18 1ZM16 9C16.55 9 17 9.45 17 10 17 10.51 16.61 10.94 16.12 10.99L16 11 8 11C7.45 11 7 10.55 7 10 7 9.45 7.45 9 8 9L16 9ZM16 5C16.55 5 17 5.45 17 6 17 6.51 16.61 6.94 16.12 6.99L16 7 8 7C7.45 7 7 6.55 7 6 7 5.45 7.45 5 8 5L16 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStar: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.12 1.77C11.38 1.22 12.03 0.98 12.58 1.24 12.81 1.35 13 1.53 13.11 1.77L15.92 7.75 22.18 8.7C22.74 8.79 23.14 9.28 23.12 9.84L23.11 9.96C23.07 10.19 22.97 10.4 22.8 10.56L18.24 15.24 19.32 21.86C19.41 22.42 19.06 22.95 18.53 23.09L18.41 23.12C18.16 23.16 17.92 23.12 17.7 23L12.11 19.91 6.53 23C6.03 23.27 5.42 23.12 5.1 22.67L5.04 22.57C4.92 22.35 4.87 22.1 4.91 21.86L5.99 15.24 1.42 10.56C1.03 10.16 1.01 9.53 1.36 9.1L1.44 9C1.61 8.84 1.82 8.74 2.05 8.7L8.31 7.75 11.12 1.77ZM12.11 4.35L9.92 9.03C9.76 9.36 9.45 9.6 9.09 9.65L4.08 10.42 7.74 14.17C7.95 14.39 8.06 14.68 8.05 14.99L8.04 15.11 7.18 20.35 11.58 17.92C11.87 17.76 12.22 17.74 12.52 17.86L12.65 17.92 17.04 20.35 16.19 15.11C16.14 14.81 16.22 14.51 16.4 14.27L16.49 14.17 20.15 10.42 15.14 9.65C14.82 9.6 14.55 9.42 14.38 9.15L14.31 9.03 12.11 4.35Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatisticsBar: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5 12C5.55 12 6 12.45 6 13L6 23C6 23.55 5.55 24 5 24 4.45 24 4 23.55 4 23L4 13C4 12.45 4.45 12 5 12ZM12 7.2C12.55 7.2 13 7.65 13 8.2L13 23C13 23.55 12.55 24 12 24 11.45 24 11 23.55 11 23L11 8.2C11 7.65 11.45 7.2 12 7.2ZM19 0C19.55 0 20 0.45 20 1L20 23C20 23.55 19.55 24 19 24 18.45 24 18 23.55 18 23L18 1C18 0.45 18.45 0 19 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatisticsLine: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 4C23.55 4 24 4.45 24 5L24 10C24 10.55 23.55 11 23 11 22.45 11 22 10.55 22 10L22 7.41 12.71 16.71C12.32 17.1 11.68 17.1 11.29 16.71L8 13.41 1.71 19.71C1.35 20.07 0.78 20.1 0.39 19.79L0.29 19.71C-0.1 19.32-0.1 18.68 0.29 18.29L7.29 11.29C7.68 10.9 8.32 10.9 8.71 11.29L12 14.59 20.58 6 18 6C17.45 6 17 5.55 17 5 17 4.45 17.45 4 18 4L23 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatisticsPie: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM2 12C2 17.52 6.48 22 12 22 17.18 22 21.45 18.05 21.95 13L12 13C11.45 13 11 12.55 11 12L11 2.05C5.95 2.55 2 6.81 2 12ZM13 2.05L13 11 21.95 11C21.49 6.37 17.87 2.67 13.28 2.08L13 2.05Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusActive: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusBlock: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.77 18.6L20.91 20.04C18.72 22.47 15.54 24 12 24 11.32 24 10.65 23.94 10 23.83L10 22 12 22C14.29 22 16.45 21.23 18.21 19.84L19.77 18.6ZM1.87 13.23L2.5 15.13C3.21 17.27 4.62 19.11 6.5 20.35L8.17 21.45 7.16 22.98C3.47 21.36 0.76 17.93 0.14 13.81L1.87 13.23ZM22.39 5.98C23.41 7.75 24 9.81 24 12 24 14.01 23.5 15.91 22.63 17.58L20.89 17.01 21.51 15.11C21.83 14.13 22 13.09 22 12.04 22 10.79 21.79 9.61 21.37 8.5L20.67 6.63 22.39 5.98ZM6.64 1.26L7.72 2.74 6.1 3.92C4.29 5.25 2.96 7.16 2.36 9.33L1.83 11.25 0.06 10.77C0.49 6.6 3.05 3.06 6.64 1.26ZM12 0C15.34 0 18.35 1.36 20.53 3.56L19.46 5.05 17.83 3.88C16.15 2.66 14.13 2 12 2 11.85 2 11.7 2 11.55 2.01L9.55 2.1 9.47 0.27C10.29 0.09 11.13 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusCanceled: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3 11H21A1 1 0 0 1 22 12V12A1 1 0 0 1 21 13H3A1 1 0 0 1 2 12V12A1 1 0 0 1 3 11z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusConfirmed: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusDone: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusInProgress: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.55 21.7C10.32 21.89 11.17 22 12 22L12 24C11.01 24 10 23.87 9.06 23.64L9.55 21.7ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM17.54 9.23C17.93 9.62 17.93 10.26 17.54 10.65L12.42 15.77C12.21 15.98 11.92 16.08 11.64 16.06 11.36 16.08 11.07 15.98 10.85 15.77L7.73 12.65C7.34 12.26 7.34 11.62 7.73 11.23 8.12 10.84 8.76 10.84 9.15 11.23L11.64 13.72 16.13 9.23C16.52 8.84 17.15 8.84 17.54 9.23ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37ZM24 12C24 18.63 18.63 24 12 24L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0 18.63 0 24 5.37 24 12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusInProgressAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.55 21.7C10.32 21.89 11.17 22 12 22L12 24C11.01 24 10 23.87 9.06 23.64L9.55 21.7ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37ZM24 12C24 18.63 18.63 24 12 24L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0 18.63 0 24 5.37 24 12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusMissing: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 11.01 24 10 23.87 9.06 23.64L9.55 21.7C10.19 21.86 10.89 21.96 11.58 21.99L12 22C17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2 11.39 2 10.8 2.05 10.22 2.16L9.87 0.19C10.57 0.06 11.27 0 12 0ZM4.49 18.6C5.15 19.35 5.92 20.01 6.78 20.53L5.74 22.24C4.71 21.61 3.78 20.83 2.99 19.92L4.49 18.6ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM2.07 13.17C2.19 14.19 2.46 15.16 2.86 16.06L1.03 16.88C0.54 15.78 0.22 14.61 0.08 13.4L2.07 13.17ZM12 7C13.66 7 15 8.34 15 10 15 11.31 14.17 12.42 13 12.83L13 13C13 13.55 12.55 14 12 14 11.45 14 11 13.55 11 13L11 12C11 11.49 11.39 11.06 11.88 11.01L12 11C12.55 11 13 10.55 13 10 13 9.45 12.55 9 12 9 11.49 9 11.06 9.39 11.01 9.88L11 10C11 10.55 10.55 11 10 11 9.45 11 9 10.55 9 10 9 8.34 10.34 7 12 7ZM1.35 6.46L3.12 7.39C2.67 8.27 2.34 9.22 2.16 10.23L0.19 9.88C0.4 8.68 0.79 7.53 1.35 6.46ZM6.43 1.37L7.36 3.14C6.46 3.61 5.65 4.21 4.94 4.92L3.53 3.5C4.38 2.65 5.36 1.93 6.43 1.37Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusNoShow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM21.95 13L2.05 13C2.55 18.05 6.82 22 12 22 17.09 22 21.29 18.2 21.92 13.28L21.95 13ZM12 2C6.81 2 2.55 5.95 2.05 11L21.95 11C21.45 5.95 17.19 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaStatusTodo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.77 18.6L20.91 20.04C18.72 22.47 15.54 24 12 24 11.32 24 10.65 23.94 10 23.83L10 22 12 22C14.29 22 16.45 21.23 18.21 19.84L19.77 18.6ZM1.87 13.23L2.5 15.13C3.21 17.27 4.62 19.11 6.5 20.35L8.17 21.45 7.16 22.98C3.47 21.36 0.76 17.93 0.14 13.81L1.87 13.23ZM22.39 5.98C23.41 7.75 24 9.81 24 12 24 14.01 23.5 15.91 22.63 17.58L20.89 17.01 21.51 15.11C21.83 14.13 22 13.09 22 12.04 22 10.79 21.79 9.61 21.37 8.5L20.67 6.63 22.39 5.98ZM16.1 9.29C16.49 9.68 16.49 10.32 16.1 10.71L11.98 14.83C11.77 15.04 11.48 15.14 11.2 15.12 10.92 15.14 10.63 15.04 10.41 14.83L8.29 12.71C7.9 12.32 7.9 11.68 8.29 11.29 8.68 10.9 9.32 10.9 9.71 11.29L11.2 12.78 14.69 9.29C15.08 8.9 15.71 8.9 16.1 9.29ZM6.64 1.26L7.72 2.74 6.1 3.92C4.29 5.25 2.96 7.16 2.36 9.33L1.83 11.25 0.06 10.77C0.49 6.6 3.05 3.06 6.64 1.26ZM12 0C15.34 0 18.35 1.36 20.53 3.56L19.46 5.05 17.83 3.88C16.15 2.66 14.13 2 12 2 11.85 2 11.7 2 11.55 2.01L9.55 2.1 9.47 0.27C10.29 0.09 11.13 0 12 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSupport: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C17.52 0 22 4.48 22 10L22 12C22 16.5 19.03 20.3 14.95 21.56 14.69 22.95 13.47 24 12 24 10.34 24 9 22.66 9 21 9 19.34 10.34 18 12 18 13.13 18 14.12 18.63 14.63 19.56 16.86 18.78 18.63 17.05 19.47 14.86 19.16 14.95 18.84 15 18.5 15L18 15C16.34 15 15 13.66 15 12L15 10C15 8.34 16.34 7 18 7L18.5 7C18.84 7 19.16 7.05 19.47 7.14 18.32 4.13 15.41 2 12 2 8.59 2 5.68 4.13 4.53 7.14 4.84 7.05 5.16 7 5.5 7L6 7C7.66 7 9 8.34 9 10L9 12C9 13.66 7.66 15 6 15L5.5 15C3.57 15 2 13.43 2 11.5L2 10.5C2 10.39 2.01 10.28 2.02 10.17 2.01 10.12 2 10.06 2 10 2 4.48 6.48 0 12 0ZM12 20C11.45 20 11 20.45 11 21 11 21.55 11.45 22 12 22 12.55 22 13 21.55 13 21 13 20.62 12.79 20.3 12.49 20.13L12.4 20.08 12.32 20.05 12.23 20.03 12.17 20.01 12.09 20 12 20ZM6 9L5.5 9C4.67 9 4 9.67 4 10.5L4 11.5C4 12.33 4.67 13 5.5 13L6 13C6.55 13 7 12.55 7 12L7 10C7 9.45 6.55 9 6 9ZM18.5 9L18 9C17.45 9 17 9.45 17 10L17 12C17 12.55 17.45 13 18 13L18.5 13C19.33 13 20 12.33 20 11.5L20 10.5C20 9.67 19.33 9 18.5 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSwitch: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.71 14.56L18.78 17.64 18.78 15C18.78 14.45 19.23 14 19.78 14 20.33 14 20.78 14.45 20.78 15L20.78 20C20.78 20.51 20.39 20.94 19.89 20.99L19.78 21 14.78 21C14.23 21 13.78 20.55 13.78 20 13.78 19.45 14.23 19 14.78 19L17.31 19 14.29 15.98C13.9 15.59 13.9 14.96 14.29 14.56 14.68 14.17 15.32 14.17 15.71 14.56ZM19.78 3C20.33 3 20.78 3.45 20.78 4L20.78 9C20.78 9.55 20.33 10 19.78 10 19.23 10 18.78 9.55 18.78 9L18.78 6.41 4.71 20.49C4.32 20.88 3.68 20.88 3.29 20.49 2.9 20.09 2.9 19.46 3.29 19.07L17.36 5 14.78 5C14.23 5 13.78 4.55 13.78 4 13.78 3.45 14.23 3 14.78 3L19.78 3ZM5 3.86L9.78 8.64C10.17 9.03 10.17 9.66 9.78 10.05 9.39 10.44 8.75 10.44 8.36 10.05L3.59 5.27C3.2 4.88 3.2 4.25 3.59 3.86 3.98 3.47 4.61 3.47 5 3.86Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTag: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.76 2.4L23 4.86C23.62 5.22 24 5.9 24 6.63L23.98 11.59C23.97 12.67 23.41 13.66 22.49 14.2L8.19 22.59C6.77 23.43 4.94 22.93 4.12 21.49L0.4 14.93C-0.42 13.48 0.07 11.63 1.49 10.8L15.79 2.41C16.71 1.87 17.84 1.86 18.76 2.4ZM16.77 4.14L2.5 12.55C2.02 12.82 1.86 13.44 2.13 13.93L5.85 20.49C6.12 20.98 6.73 21.14 7.2 20.86L21.48 12.45C21.79 12.27 21.98 11.94 21.98 11.58L22 6.6 17.76 4.13C17.46 3.95 17.08 3.96 16.77 4.14ZM18.5 7C19.33 7 20 7.67 20 8.5 20 9.33 19.33 10 18.5 10 17.67 10 17 9.33 17 8.5 17 7.67 17.67 7 18.5 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTags: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.89 0.4C19.96 0.44 20.03 0.48 20.1 0.53L23.37 2.97C23.88 3.35 24.18 3.95 24.18 4.59L24.16 8.51C24.15 9.44 23.71 10.31 22.99 10.87L22.98 13.51C22.98 14.54 22.43 15.49 21.54 16L8.68 23.42C7.3 24.22 5.53 23.75 4.73 22.37L1.39 16.57C0.59 15.19 1.06 13.42 2.45 12.62L3.5 12.01 3.32 11.66C2.64 10.3 3.08 8.65 4.33 7.82L4.48 7.73 16.91 0.4C17.83-0.13 18.97-0.13 19.89 0.4ZM20.99 12.08L10.25 18.41C8.82 19.24 6.98 18.75 6.15 17.31L6.1 17.21 4.39 13.8 3.45 14.35C3.02 14.6 2.87 15.14 3.12 15.57L6.47 21.37C6.71 21.79 7.26 21.94 7.68 21.69L20.54 14.27C20.81 14.11 20.98 13.82 20.98 13.5L20.99 12.08ZM17.91 2.13L5.5 9.45C5.06 9.71 4.88 10.25 5.08 10.71L7.88 16.31C8.06 16.62 8.38 16.8 8.71 16.81L8.82 16.81C8.97 16.8 9.11 16.76 9.25 16.68L21.66 9.36C21.96 9.18 22.15 8.86 22.16 8.5L22.18 4.57 18.9 2.13C18.59 1.96 18.21 1.96 17.91 2.13ZM18.5 5C19.33 5 20 5.67 20 6.5 20 7.33 19.33 8 18.5 8 17.67 8 17 7.33 17 6.5 17 5.67 17.67 5 18.5 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTemperature: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.21 2 16 3.79 16 6L16 11.53C17.23 12.63 18 14.22 18 16 18 19.31 15.31 22 12 22 8.69 22 6 19.31 6 16 6 14.22 6.77 12.63 8 11.53L8 6C8 3.79 9.79 2 12 2ZM12 4C10.9 4 10 4.9 10 6L10 12.42 9.33 13.02C8.49 13.77 8 14.85 8 16 8 18.21 9.79 20 12 20 14.21 20 16 18.21 16 16 16 14.85 15.51 13.77 14.67 13.02L14 12.42 14 6C14 4.9 13.1 4 12 4ZM12 14C13.1 14 14 14.9 14 16 14 17.1 13.1 18 12 18 10.9 18 10 17.1 10 16 10 14.9 10.9 14 12 14Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTimes: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.05 5.64L12 10.59 16.95 5.64C17.34 5.25 17.97 5.25 18.36 5.64 18.75 6.03 18.75 6.66 18.36 7.05L13.41 12 18.36 16.95C18.75 17.34 18.75 17.97 18.36 18.36 17.97 18.75 17.34 18.75 16.95 18.36L12 13.41 7.05 18.36C6.66 18.75 6.03 18.75 5.64 18.36 5.25 17.97 5.25 17.34 5.64 16.95L10.59 12 5.64 7.05C5.25 6.66 5.25 6.03 5.64 5.64 6.03 5.25 6.66 5.25 7.05 5.64Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTimesCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM9.05 7.64L12 10.59 14.95 7.64C15.34 7.25 15.97 7.25 16.36 7.64 16.75 8.03 16.75 8.66 16.36 9.05L13.41 12 16.36 14.95C16.75 15.34 16.75 15.97 16.36 16.36 15.97 16.75 15.34 16.75 14.95 16.36L12 13.41 9.05 16.36C8.66 16.75 8.03 16.75 7.64 16.36 7.25 15.97 7.25 15.34 7.64 14.95L10.59 12 7.64 9.05C7.25 8.66 7.25 8.03 7.64 7.64 8.03 7.25 8.66 7.25 9.05 7.64Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTimesSmall: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.17 7.76L12 10.58 14.83 7.76C15.22 7.37 15.85 7.37 16.24 7.76 16.63 8.15 16.63 8.78 16.24 9.17L13.41 12 16.24 14.83C16.63 15.22 16.63 15.85 16.24 16.24 15.85 16.63 15.22 16.63 14.83 16.24L12 13.41 9.17 16.24C8.78 16.63 8.15 16.63 7.76 16.24 7.37 15.85 7.37 15.22 7.76 14.83L10.58 12 7.76 9.17C7.37 8.78 7.37 8.15 7.76 7.76 8.15 7.37 8.78 7.37 9.17 7.76Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTimesThick: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M4.58 3.06L12 10.48 19.42 3.06C19.91 2.57 20.7 2.57 21.19 3.06 21.68 3.55 21.68 4.34 21.19 4.83L13.77 12.25 21.19 19.67C21.68 20.16 21.68 20.95 21.19 21.44 20.7 21.93 19.91 21.93 19.42 21.44L12 14.02 4.58 21.44C4.09 21.93 3.3 21.93 2.81 21.44 2.32 20.95 2.32 20.16 2.81 19.67L10.23 12.25 2.81 4.83C2.32 4.34 2.32 3.55 2.81 3.06 3.3 2.57 4.09 2.57 4.58 3.06Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTodoCreate: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17 0C17.55 0 18 0.45 18 1L18 2 20 2C21.66 2 23 3.34 23 5L23 21C23 22.66 21.66 24 20 24L4 24C2.34 24 1 22.66 1 21L1 5C1 3.34 2.34 2 4 2L6 2 6 1C6 0.45 6.45 0 7 0 7.55 0 8 0.45 8 1L8 2 16 2 16 1C16 0.45 16.45 0 17 0ZM21 10L3 10 3 21C3 21.55 3.45 22 4 22L20 22C20.55 22 21 21.55 21 21L21 10ZM15 12C15.55 12 16 12.45 16 13L16 15 18 15C18.55 15 19 15.45 19 16 19 16.55 18.55 17 18 17L16 17 16 19C16 19.55 15.55 20 15 20 14.45 20 14 19.55 14 19L14 17 12 17C11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15L14 15 14 13C14 12.45 14.45 12 15 12ZM6 4L4 4C3.45 4 3 4.45 3 5L3 8 21 8 21 5C21 4.45 20.55 4 20 4L18 4 18 5C18 5.55 17.55 6 17 6 16.45 6 16 5.55 16 5L16 4 8 4 8 5C8 5.55 7.55 6 7 6 6.45 6 6 5.55 6 5L6 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTodoDone: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C18.55 0 19 0.45 19 1L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 2 9 2 9 1C9 0.45 9.45 0 10 0 10.55 0 11 0.45 11 1L11 2 13 2 13 1C13 0.45 13.45 0 14 0 14.55 0 15 0.45 15 1L15 2 17 2 17 1C17 0.45 17.45 0 18 0ZM9 4L7 4 7 5C7 5.55 6.55 6 6 6 5.45 6 5 5.55 5 5L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L19 5C19 5.55 18.55 6 18 6 17.45 6 17 5.55 17 5L17 4 15 4 15 5C15 5.55 14.55 6 14 6 13.45 6 13 5.55 13 5L13 4 11 4 11 5C11 5.55 10.55 6 10 6 9.45 6 9 5.55 9 5L9 4ZM17.1 13.29C17.49 13.68 17.49 14.32 17.1 14.71L12.98 18.83C12.77 19.04 12.48 19.14 12.2 19.12 11.92 19.14 11.63 19.04 11.41 18.83L9.29 16.71C8.9 16.32 8.9 15.68 9.29 15.29 9.68 14.9 10.32 14.9 10.71 15.29L12.2 16.78 15.69 13.29C16.08 12.9 16.71 12.9 17.1 13.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTodoList: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 0C18.55 0 19 0.45 19 1L19 2C20.66 2 22 3.34 22 5L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 5C2 3.34 3.34 2 5 2L5 1C5 0.45 5.45 0 6 0 6.55 0 7 0.45 7 1L7 2 9 2 9 1C9 0.45 9.45 0 10 0 10.55 0 11 0.45 11 1L11 2 13 2 13 1C13 0.45 13.45 0 14 0 14.55 0 15 0.45 15 1L15 2 17 2 17 1C17 0.45 17.45 0 18 0ZM9 4L7 4 7 5C7 5.55 6.55 6 6 6 5.45 6 5 5.55 5 5L5 4C4.45 4 4 4.45 4 5L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 5C20 4.45 19.55 4 19 4L19 5C19 5.55 18.55 6 18 6 17.45 6 17 5.55 17 5L17 4 15 4 15 5C15 5.55 14.55 6 14 6 13.45 6 13 5.55 13 5L13 4 11 4 11 5C11 5.55 10.55 6 10 6 9.45 6 9 5.55 9 5L9 4ZM10 18C10.55 18 11 18.45 11 19 11 19.55 10.55 20 10 20L7 20C6.45 20 6 19.55 6 19 6 18.45 6.45 18 7 18L10 18ZM10 14C10.55 14 11 14.45 11 15 11 15.55 10.55 16 10 16L7 16C6.45 16 6 15.55 6 15 6 14.45 6.45 14 7 14L10 14Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTowels: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 2C20.25 2 22 3.75 22 6L22 14C22 14.55 21.55 15 21 15L16 15 16 21C16 21.55 15.55 22 15 22L3 22C2.45 22 2 21.55 2 21L2 6.2C2 3.85 3.85 2 6.2 2L18 2ZM14 6C14 5.27 14.19 4.58 14.51 4L6.2 4C4.95 4 4 4.95 4 6.2L4 20 14 20 14 6ZM18 4C16.85 4 16 4.85 16 6L16 13 20 13 20 6C20 4.9 19.22 4.08 18.15 4.01L18 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTrash: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.43 0L13.57 0 13.81 0.01 14.01 0.04C14.82 0.21 15.36 0.75 15.64 1.41L15.7 1.56 16.06 3 22 3C22.55 3 23 3.45 23 4 23 4.55 22.55 5 22 5L21 5 21 21C21 22.66 19.66 24 18 24L6 24C4.34 24 3 22.66 3 21L3 5 2 5C1.45 5 1 4.55 1 4 1 3.45 1.45 3 2 3L7.94 3 8.31 1.52 8.46 1.2C8.84 0.51 9.52 0 10.43 0ZM19 5L5 5 5 21C5 21.55 5.45 22 6 22L18 22C18.55 22 19 21.55 19 21L19 5ZM13.57 2L10.43 2C10.35 2 10.28 2.06 10.22 2.16L10.2 2.2 10 3 14 3 13.8 2.2C13.75 2.09 13.68 2.02 13.6 2L13.57 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTravelEnjoyHygge: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.38 1C4.28 1 5.12 1.4 5.68 2.07L5.8 2.01C7.28 1.26 9.08 1.84 9.84 3.32 10.59 4.8 10 6.6 8.53 7.35L8.43 7.4 8.82 8.17 14.76 7.18C16.3 6.92 17.78 7.89 18.16 9.41L18.9 12.34 21.59 12.88C22.99 13.16 24 14.39 24 15.82L24 16C24 17.09 23.42 18.04 22.55 18.57L23.1 20.62C23.25 21.16 22.93 21.7 22.4 21.85 21.86 21.99 21.32 21.67 21.17 21.14L20.6 19 6.72 19C6.54 19 6.36 18.98 6.18 18.95L4.87 21.23C4.59 21.71 3.98 21.87 3.5 21.6 3.02 21.32 2.86 20.71 3.13 20.23L4.45 17.96C4.2 17.67 4 17.33 3.87 16.95L2.47 12.74C2.36 12.4 2.31 12.05 2.32 11.71 2.11 11.42 1.96 11.09 1.87 10.73L0.3 4.46C-0.07 2.97 0.84 1.46 2.33 1.08 2.55 1.03 2.77 1 3 1L3.38 1ZM15.21 9.14L15.09 9.15 5.15 10.81C5.1 10.82 5.05 10.83 5 10.85 4.48 11.02 4.2 11.59 4.37 12.11L5.77 16.32C5.91 16.72 6.29 17 6.72 17L18 17 16.22 9.9C16.12 9.47 15.75 9.17 15.32 9.14L15.21 9.14ZM19.43 14.49L20 17 21 17C21.55 17 22 16.55 22 16L22 15.82C22 15.34 21.66 14.93 21.2 14.84L19.43 14.49ZM3.38 3L3 3C2.94 3 2.87 3.01 2.81 3.02 2.39 3.13 2.14 3.55 2.24 3.97L3.59 9.34C3.82 9.18 4.08 9.04 4.37 8.95 4.52 8.9 4.67 8.86 4.83 8.83L6.76 8.51 4.28 3.55C4.11 3.21 3.76 3 3.38 3ZM6.71 3.79L6.65 3.82 7.54 5.61 7.62 5.57C8.11 5.32 8.31 4.72 8.05 4.23 7.8 3.73 7.2 3.54 6.71 3.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTurnOff: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M6.34 4.93C6.73 5.32 6.73 5.95 6.34 6.34 3.22 9.47 3.22 14.53 6.34 17.66 9.47 20.78 14.53 20.78 17.66 17.66 20.78 14.53 20.78 9.47 17.66 6.34 17.27 5.95 17.27 5.32 17.66 4.93 18.05 4.54 18.68 4.54 19.07 4.93 22.98 8.83 22.98 15.17 19.07 19.07 15.17 22.98 8.83 22.98 4.93 19.07 1.02 15.17 1.02 8.83 4.93 4.93 5.32 4.54 5.95 4.54 6.34 4.93ZM12 2C12.55 2 13 2.45 13 3L13 9C13 9.55 12.55 10 12 10 11.45 10 11 9.55 11 9L11 3C11 2.45 11.45 2 12 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaTv: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.5 3.5L22.09 3.92C22.61 3.96 23 4.4 23 4.91V16.09C23 16.6 22.61 17.04 22.09 17.08L17.5 17.5C13.84 17.83 10.16 17.83 6.5 17.5L1.91 17.08C1.39 17.04 1 16.6 1 16.09V4.91C1 4.4 1.39 3.96 1.91 3.92L6.5 3.5C10.16 3.17 13.84 3.17 17.5 3.5ZM6.68 5.49L3 5.83V15.17L6.68 15.51C9.9 15.8 13.13 15.83 16.35 15.59L17.32 15.51 21 15.17V5.83L17.32 5.49C13.78 5.17 10.22 5.17 6.68 5.49ZM7 19H17C17.55 19 18 19.45 18 20 18 20.55 17.55 21 17 21H7C6.45 21 6 20.55 6 20 6 19.45 6.45 19 7 19Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUndo: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 1C18.63 1 24 6.37 24 13 24 13.55 23.55 14 23 14 22.45 14 22 13.55 22 13 22 7.48 17.52 3 12 3 6.48 3 2 7.48 2 13 2 16.45 3.01 18.69 5 19.87L5 17C5 16.45 5.45 16 6 16 6.55 16 7 16.45 7 17L7 22C7 22.51 6.61 22.94 6.12 22.99L5.98 23 1 23C0.45 23 0 22.55 0 22 0 21.45 0.45 21 1 21L3.12 21C1.04 19.34 0 16.64 0 13 0 6.37 5.37 1 12 1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUnlink: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.17 11.59C8.53 11.95 8.56 12.52 8.25 12.91L8.17 13 5.34 15.83C4.56 16.61 4.56 17.88 5.34 18.66 6.12 19.44 7.39 19.44 8.17 18.66L11 15.83C11.39 15.44 12.02 15.44 12.41 15.83 12.8 16.22 12.8 16.85 12.41 17.24L9.59 20.07C8.02 21.63 5.49 21.63 3.93 20.07 2.37 18.51 2.37 15.98 3.93 14.41L6.76 11.59C7.15 11.2 7.78 11.2 8.17 11.59ZM7.05 5.64L18.36 16.95C18.75 17.34 18.75 17.97 18.36 18.36 17.97 18.75 17.34 18.75 16.95 18.36L5.64 7.05C5.25 6.66 5.25 6.03 5.64 5.64 6.03 5.25 6.66 5.25 7.05 5.64ZM20.07 3.93C21.63 5.49 21.63 8.02 20.07 9.59L17.24 12.41C16.85 12.8 16.22 12.8 15.83 12.41 15.44 12.02 15.44 11.39 15.83 11L18.66 8.17C19.44 7.39 19.44 6.12 18.66 5.34 17.88 4.56 16.61 4.56 15.83 5.34L13 8.17C12.61 8.56 11.98 8.56 11.59 8.17 11.2 7.78 11.2 7.15 11.59 6.76L14.41 3.93C15.98 2.37 18.51 2.37 20.07 3.93Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUpload: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23 14C23.55 14 24 14.45 24 15L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 15C0 14.45 0.45 14 1 14 1.55 14 2 14.45 2 15L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 15C22 14.45 22.45 14 23 14ZM12.71 0.28L15.71 3.17C16.1 3.55 16.1 4.15 15.71 4.53 15.32 4.9 14.68 4.9 14.29 4.53L13 3.27 13 15.81C13 16.36 12.55 16.81 12 16.81 11.45 16.81 11 16.36 11 15.81L11 3.27 9.71 4.53C9.34 4.88 8.75 4.9 8.36 4.58L8.29 4.53C7.9 4.15 7.9 3.55 8.29 3.17L11.29 0.28C11.68-0.09 12.32-0.09 12.71 0.28Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaVendingMachine: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 1C12.66 1 14 2.34 14 4L14 5.34 13.96 5.36C14.6 5.13 15.28 5 16 5 19.31 5 22 7.69 22 11 22 14.31 19.31 17 16 17 15.39 17 14.79 16.91 14.24 16.74L14 16.66 14 20C14 21.66 12.66 23 11 23L5 23C3.34 23 2 21.66 2 20L2 4C2 2.34 3.34 1 5 1L11 1ZM11 3L5 3C4.45 3 4 3.45 4 4L4 20C4 20.55 4.45 21 5 21L11 21C11.55 21 12 20.55 12 20L12 15.47 12.01 15.48C10.78 14.38 10 12.78 10 11 10 9.31 10.7 7.78 11.82 6.69L12 6.53 12 4C12 3.45 11.55 3 11 3ZM8 6C8.55 6 9 6.45 9 7L9 17C9 17.51 8.61 17.94 8.12 17.99L8 18C7.45 18 7 17.55 7 17L7 7C7 6.45 7.45 6 8 6ZM16 7C13.79 7 12 8.79 12 11 12 13.21 13.79 15 16 15 18.21 15 20 13.21 20 11 20 8.79 18.21 7 16 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWarehouse: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.65 0.49L21.63 5.72C22.49 6.27 23 7.23 23 8.25L23 20.98C23 22.65 21.65 24 19.99 24L4.01 24C2.35 24 1 22.65 1 20.98L1 8.25C1 7.23 1.51 6.27 2.37 5.72L10.35 0.49C11.35-0.16 12.65-0.16 13.65 0.49ZM11.45 2.16L3.46 7.4C3.17 7.58 3 7.9 3 8.24L3 20.99C3 21.55 3.45 22 4.01 22L9 22 9 18C9 16.34 10.34 15 12 15L15 15C16.66 15 18 16.34 18 18L18 22 19.99 22C20.55 22 21 21.55 21 20.99L21 8.24C21 7.9 20.83 7.58 20.54 7.4L12.55 2.16C12.22 1.95 11.78 1.95 11.45 2.16ZM15 17L12 17C11.45 17 11 17.45 11 18L11 22 16 22 16 18C16 17.45 15.55 17 15 17Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWeather: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.57 6.47C23.24 7.44 23.81 9.58 22.85 11.25 22.1 12.55 21.09 13.13 19.26 13.18L19 13.18 2 13.18C1.45 13.18 1 12.74 1 12.18 1 11.63 1.45 11.18 2 11.18L19 11.18C20 11.18 20.7 10.97 21.12 10.25 21.53 9.53 21.28 8.62 20.57 8.2 19.89 7.81 19.04 8.01 18.6 8.63L18.52 8.75C18.24 9.23 17.63 9.39 17.15 9.12 16.67 8.84 16.51 8.23 16.79 7.75 17.75 6.08 19.89 5.5 21.57 6.47ZM12.57 2.47C14.24 3.44 14.81 5.58 13.85 7.25 13.1 8.55 12.09 9.13 10.26 9.18L10 9.18 2 9.18C1.45 9.18 1 8.74 1 8.18 1 7.63 1.45 7.18 2 7.18L10 7.18C11 7.18 11.7 6.97 12.12 6.25 12.53 5.53 12.28 4.62 11.57 4.2 10.89 3.81 10.04 4.01 9.6 4.63L9.52 4.75C9.24 5.23 8.63 5.39 8.15 5.12 7.67 4.84 7.51 4.23 7.79 3.75 8.75 2.08 10.89 1.5 12.57 2.47ZM2 15C1.45 15 1 15.45 1 16 1 16.55 1.45 17 2 17L15 17C16 17 16.7 17.22 17.12 17.93 17.53 18.65 17.28 19.57 16.57 19.98 15.89 20.37 15.04 20.18 14.6 19.55L14.52 19.43C14.24 18.95 13.63 18.79 13.15 19.07 12.67 19.34 12.51 19.95 12.79 20.43 13.75 22.11 15.89 22.68 17.57 21.71 19.24 20.75 19.81 18.61 18.85 16.93 18.1 15.63 17.09 15.05 15.26 15L15 15 2 15Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWeight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.21 2 16 3.79 16 6 16 6.73 15.8 7.41 15.46 8L16.97 8C18.38 8 19.59 8.98 19.9 10.35L21.68 18.35C22.04 19.97 21.02 21.57 19.4 21.93 19.19 21.98 18.97 22 18.75 22L5.25 22C3.59 22 2.25 20.66 2.25 19 2.25 18.78 2.27 18.56 2.32 18.35L4.1 10.35C4.41 8.98 5.63 8 7.03 8L8.54 8C8.2 7.41 8 6.73 8 6 8 3.79 9.79 2 12 2ZM16.97 10L7.03 10C6.56 10 6.16 10.33 6.06 10.78L4.27 18.78C4.26 18.85 4.25 18.93 4.25 19 4.25 19.55 4.7 20 5.25 20L18.75 20C18.83 20 18.9 19.99 18.97 19.98 19.51 19.86 19.85 19.32 19.73 18.78L17.95 10.78C17.85 10.33 17.44 10 16.97 10ZM12 4C10.9 4 10 4.9 10 6 10 7.1 10.9 8 12 8 13.1 8 14 7.1 14 6 14 4.9 13.1 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWifi: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21.8 7.4C19.6 4.47 16.3 3 12 3 7.7 3 4.4 4.47 2.2 7.4 1.87 7.84 1.96 8.47 2.4 8.8 2.84 9.13 3.47 9.04 3.8 8.6 5.6 6.2 8.3 5 12 5 15.7 5 18.4 6.2 20.2 8.6 20.41 8.89 20.76 9.04 21.12 8.99 21.47 8.95 21.78 8.72 21.92 8.39 22.06 8.06 22.01 7.69 21.8 7.4ZM12 7C14.94 7 17.52 8.11 19.71 10.29 20.09 10.69 20.08 11.31 19.69 11.69 19.31 12.08 18.69 12.09 18.29 11.71 16.48 9.89 14.4 9 12 9 9.6 9 7.52 9.89 5.71 11.71 5.31 12.09 4.69 12.08 4.31 11.69 3.92 11.31 3.91 10.69 4.29 10.29 6.48 8.11 9.06 7 12 7ZM16.71 13.29C15.2 11.79 13.63 11 12 11 10.37 11 8.8 11.79 7.29 13.29 7.03 13.54 6.93 13.92 7.02 14.27 7.11 14.62 7.38 14.89 7.73 14.98 8.08 15.07 8.46 14.97 8.71 14.71 9.87 13.55 10.96 13 12 13 13.04 13 14.13 13.55 15.29 14.71 15.69 15.09 16.31 15.08 16.69 14.69 17.05 14.34 17.08 13.78 16.79 13.39L16.71 13.29ZM12 16C13.66 16 15 17.34 15 19 15 20.66 13.66 22 12 22 10.34 22 9 20.66 9 19 9 17.34 10.34 16 12 16ZM12 18C11.45 18 11 18.45 11 19 11 19.55 11.45 20 12 20 12.55 20 13 19.55 13 19 13 18.45 12.55 18 12 18Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWifiOff: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0.61C19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.09 23.5 5.48 23.67 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.91 0.5 18.52 0.33 19 0.61ZM13.01 14.17C14.17 14.59 15 15.7 15 17 15 18.66 13.66 20 12 20 11.19 20 10.46 19.68 9.92 19.17L11.06 17.33C11.19 17.72 11.56 18 12 18 12.55 18 13 17.55 13 17 13 16.45 12.55 16 12 16 11.96 16 11.92 16 11.88 16.01L13.01 14.17ZM15.78 9.68C17.2 10.23 18.52 11.1 19.71 12.29 20.09 12.69 20.08 13.31 19.69 13.69 19.31 14.08 18.69 14.09 18.29 13.71 17.2 12.61 16.01 11.85 14.71 11.42L15.78 9.68ZM11.5 9.01L10.15 11.19C8.51 11.54 7.04 12.38 5.71 13.71 5.31 14.09 4.69 14.08 4.31 13.69 3.92 13.31 3.91 12.69 4.29 12.29 6.35 10.23 8.77 9.13 11.5 9.01ZM18.4 5.45C19.73 6.17 20.86 7.15 21.8 8.4 22.01 8.69 22.06 9.06 21.92 9.39 21.78 9.72 21.47 9.95 21.12 9.99 20.76 10.04 20.41 9.89 20.2 9.6 19.42 8.56 18.47 7.74 17.34 7.15L18.4 5.45ZM12 4C12.87 4 13.69 4.06 14.48 4.18L13.32 6.05C12.9 6.02 12.46 6 12 6 8.3 6 5.6 7.2 3.8 9.6 3.47 10.04 2.84 10.13 2.4 9.8 1.96 9.47 1.87 8.84 2.2 8.4 4.4 5.47 7.7 4 12 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWindow: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 1C17.76 1 20 3.24 20 6L20 18C20 20.76 17.76 23 15 23L9 23C6.24 23 4 20.76 4 18L4 6C4 3.24 6.24 1 9 1L15 1ZM15 3L9 3C7.34 3 6 4.34 6 6L6 18C6 19.66 7.34 21 9 21L15 21C16.66 21 18 19.66 18 18L18 6C18 4.34 16.66 3 15 3ZM14 4.5C15.38 4.5 16.5 5.62 16.5 7 16.5 7.28 16.28 7.5 16 7.5 15.72 7.5 15.5 7.28 15.5 7 15.5 6.17 14.83 5.5 14 5.5 13.72 5.5 13.5 5.28 13.5 5 13.5 4.72 13.72 4.5 14 4.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaWindowExcluded: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15 1C17.76 1 20 3.24 20 6L20 18C20 18.72 19.85 19.41 19.57 20.02L21.46 21.91C21.85 22.3 21.85 22.94 21.46 23.33 21.07 23.72 20.44 23.72 20.05 23.33L18.39 21.67C17.5 22.5 16.31 23 15 23L9 23C6.24 23 4 20.76 4 18L4 7.28 0.95 4.23C0.56 3.84 0.56 3.21 0.95 2.82 1.34 2.43 1.98 2.43 2.37 2.82L4.19 4.64C4.78 2.54 6.71 1 9 1L15 1ZM6 9.28L6 18C6 19.66 7.34 21 9 21L15 21C15.76 21 16.45 20.72 16.98 20.26L6 9.28ZM15 3L9 3C7.34 3 6 4.34 6 6L6 6.45 17.97 18.42C17.99 18.28 18 18.14 18 18L18 6C18 4.34 16.66 3 15 3ZM14 4.5C15.38 4.5 16.5 5.62 16.5 7 16.5 7.28 16.28 7.5 16 7.5 15.72 7.5 15.5 7.28 15.5 7 15.5 6.17 14.83 5.5 14 5.5 13.72 5.5 13.5 5.28 13.5 5 13.5 4.72 13.72 4.5 14 4.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};
